{
  "level": "eb03",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:eb03",
    "objects": "AREAS.E3:eb03.e3",
    "mesh": "TREES.E3:eb03.e3"
  },
  "spawn_point": {
    "position": [
      1824.0932640926865,
      1701.319535098276,
      122.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      1824.0932640926865,
      1801.319535098276,
      122.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      1633.0,
      810.0,
      98.0
    ],
    "bbox_max": [
      2025.0001220703125,
      1977.4998779296875,
      220.0
    ],
    "vertex_count": 977,
    "vertices": [
      [
        1650.0,
        1400.0,
        120.0
      ],
      [
        1650.0,
        1450.0,
        120.0
      ],
      [
        1650.0,
        840.0,
        120.0
      ],
      [
        1650.0,
        840.0,
        100.0
      ],
      [
        1633.0,
        1140.0,
        120.0
      ],
      [
        1633.0,
        1150.0,
        120.0
      ],
      [
        1633.0,
        1150.0,
        120.0
      ],
      [
        1650.0,
        840.0,
        220.0
      ],
      [
        1650.0,
        840.0,
        140.0
      ],
      [
        1650.0,
        810.0,
        120.0
      ],
      [
        1650.0,
        810.0,
        140.0
      ],
      [
        1650.0,
        1140.0,
        131.33334350585938
      ],
      [
        1650.0,
        1150.0,
        131.33334350585938
      ],
      [
        1650.0,
        1150.0,
        133.33334350585938
      ],
      [
        1650.0,
        1150.0,
        131.33334350585938
      ],
      [
        1650.0,
        1050.0,
        140.0
      ],
      [
        1650.0,
        1050.0,
        138.0
      ],
      [
        1650.0,
        1220.0,
        140.0
      ],
      [
        1650.0,
        1220.0,
        138.0
      ],
      [
        1655.0,
        840.0,
        120.0
      ],
      [
        1655.0,
        840.0,
        100.0
      ],
      [
        1655.0,
        840.0,
        220.0
      ],
      [
        1655.0,
        840.0,
        140.0
      ],
      [
        1655.0,
        810.0,
        120.0
      ],
      [
        1655.0,
        810.0,
        140.0
      ],
      [
        1655.0,
        1400.0,
        120.0
      ],
      [
        1655.0,
        1450.0,
        120.0
      ],
      [
        1655.0,
        990.0,
        118.0
      ],
      [
        1655.0,
        960.0,
        98.0
      ],
      [
        1655.0,
        940.0,
        118.0
      ],
      [
        1655.0,
        940.0,
        120.0
      ],
      [
        1655.0,
        1000.0,
        118.0
      ],
      [
        1655.0,
        1000.0,
        120.0
      ],
      [
        1655.0,
        1140.0,
        134.6666717529297
      ],
      [
        1655.0,
        1150.0,
        134.6666717529297
      ],
      [
        1655.0,
        1150.0,
        136.6666717529297
      ],
      [
        1655.0,
        1150.0,
        134.6666717529297
      ],
      [
        1655.0,
        1050.0,
        140.0
      ],
      [
        1655.0,
        1050.0,
        138.0
      ],
      [
        1655.0,
        1220.0,
        140.0
      ],
      [
        1655.0,
        1220.0,
        138.0
      ],
      [
        1680.0,
        840.0,
        120.0
      ],
      [
        1680.0,
        840.0,
        100.0
      ],
      [
        1680.0,
        840.0,
        220.0
      ],
      [
        1680.0,
        840.0,
        140.0
      ],
      [
        1680.0,
        810.0,
        120.0
      ],
      [
        1680.0,
        810.0,
        140.0
      ],
      [
        1680.0,
        1450.0,
        120.0
      ],
      [
        1680.0,
        1495.0,
        120.0
      ],
      [
        1680.0,
        1495.0,
        120.0
      ],
      [
        1680.0,
        1554.9998779296875,
        120.0
      ],
      [
        1750.0009765625,
        1400.0,
        120.0
      ],
      [
        1680.0,
        1450.0,
        120.0
      ],
      [
        1750.0006103515625,
        1450.0,
        120.0
      ],
      [
        1680.0,
        940.0,
        118.0
      ],
      [
        1750.0037841796875,
        940.0,
        118.0
      ],
      [
        1750.0037841796875,
        940.0,
        120.0
      ],
      [
        1680.0,
        940.0,
        120.0
      ],
      [
        1750.0009765625,
        1400.0,
        120.0
      ],
      [
        1750.0009765625,
        1400.0,
        140.0
      ],
      [
        1680.0,
        1465.0,
        135.0
      ],
      [
        1680.0,
        1442.5,
        135.0
      ],
      [
        1680.0,
        1465.0,
        135.0
      ],
      [
        1680.0,
        1495.0,
        135.0
      ],
      [
        1680.0,
        1495.0,
        135.0
      ],
      [
        1680.0,
        1554.9998779296875,
        135.0
      ],
      [
        1847.5,
        1555.0001220703125,
        120.0
      ],
      [
        1841.0,
        1555.0001220703125,
        120.0
      ],
      [
        1839.0,
        1555.0001220703125,
        120.0
      ],
      [
        1832.5,
        1555.0001220703125,
        120.0
      ],
      [
        1768.0,
        1400.0,
        120.0
      ],
      [
        1768.0,
        1450.0,
        120.0
      ],
      [
        1768.0,
        940.0,
        118.0
      ],
      [
        1768.0,
        940.0,
        120.0
      ],
      [
        1822.071533203125,
        1555.0001220703125,
        170.0
      ],
      [
        1827.4996337890625,
        1555.0001220703125,
        170.0
      ],
      [
        1827.4996337890625,
        1555.0001220703125,
        170.0
      ],
      [
        1840.251220703125,
        1555.0001220703125,
        170.0
      ],
      [
        1768.0,
        1400.0,
        120.0
      ],
      [
        1768.0,
        1400.0,
        140.0
      ],
      [
        1847.5,
        1555.0001220703125,
        135.0
      ],
      [
        1832.5,
        1555.0001220703125,
        135.0
      ],
      [
        1852.5,
        1555.0001220703125,
        127.5
      ],
      [
        1847.5,
        1555.0001220703125,
        135.0
      ],
      [
        1847.5,
        1555.0001220703125,
        120.0
      ],
      [
        1852.5,
        1555.0001220703125,
        127.5
      ],
      [
        1839.0,
        1555.0001220703125,
        123.0
      ],
      [
        1841.0,
        1555.0001220703125,
        123.0
      ],
      [
        1841.0,
        1547.3287353515625,
        120.0
      ],
      [
        1841.0,
        1547.3287353515625,
        123.0
      ],
      [
        1830.5,
        1542.5,
        123.0
      ],
      [
        1830.5,
        1555.0001220703125,
        123.0
      ],
      [
        1832.5,
        1555.0001220703125,
        120.0
      ],
      [
        1839.0,
        1555.0001220703125,
        120.0
      ],
      [
        1839.0,
        1555.0001220703125,
        123.0
      ],
      [
        1841.0,
        1555.0001220703125,
        120.0
      ],
      [
        1841.0,
        1555.0001220703125,
        123.0
      ],
      [
        1832.5,
        1555.0001220703125,
        135.0
      ],
      [
        1827.5001220703125,
        1555.0001220703125,
        127.5
      ],
      [
        1827.5001220703125,
        1555.0001220703125,
        127.5
      ],
      [
        1827.4996337890625,
        1555.0001220703125,
        185.0
      ],
      [
        1822.071533203125,
        1555.0001220703125,
        185.0
      ],
      [
        1827.4996337890625,
        1555.0001220703125,
        185.0
      ],
      [
        1840.251220703125,
        1555.0001220703125,
        185.0
      ],
      [
        1822.071533203125,
        1555.0001220703125,
        185.0
      ],
      [
        1845.251220703125,
        1555.0001220703125,
        177.5
      ],
      [
        1840.251220703125,
        1555.0001220703125,
        185.0
      ],
      [
        1838.18017578125,
        1550.0001220703125,
        185.0
      ],
      [
        1822.071533203125,
        1555.0001220703125,
        170.0
      ],
      [
        1838.18017578125,
        1550.0001220703125,
        170.0
      ],
      [
        1840.251220703125,
        1555.0001220703125,
        170.0
      ],
      [
        1845.251220703125,
        1555.0001220703125,
        177.5
      ],
      [
        1680.0,
        810.0,
        138.0
      ],
      [
        1655.0,
        810.0,
        138.0
      ],
      [
        1671.75,
        881.75,
        138.0
      ],
      [
        1668.25,
        881.75,
        138.0
      ],
      [
        1657.0,
        1150.0,
        138.0
      ],
      [
        1666.25,
        883.75,
        120.0
      ],
      [
        1673.75,
        883.75,
        120.0
      ],
      [
        1680.0,
        810.0,
        135.0
      ],
      [
        1655.0,
        810.0,
        135.0
      ],
      [
        1655.5,
        1140.0,
        135.0
      ],
      [
        1655.5,
        1150.0,
        135.0
      ],
      [
        1655.0,
        1150.0,
        135.0
      ],
      [
        1655.5,
        1150.0,
        135.0
      ],
      [
        1672.5,
        882.5,
        135.0
      ],
      [
        1667.5,
        882.5,
        135.0
      ],
      [
        1841.0,
        1964.9998779296875,
        120.0
      ],
      [
        1847.4998779296875,
        1964.9998779296875,
        120.0
      ],
      [
        1832.5,
        1964.9998779296875,
        120.0
      ],
      [
        1839.0,
        1964.9998779296875,
        120.0
      ],
      [
        1832.5,
        1964.9998779296875,
        135.0
      ],
      [
        1847.4998779296875,
        1964.9998779296875,
        135.0
      ],
      [
        1827.5,
        1964.9998779296875,
        127.5
      ],
      [
        1832.5,
        1964.9998779296875,
        135.0
      ],
      [
        1832.5,
        1964.9998779296875,
        120.0
      ],
      [
        1827.5,
        1964.9998779296875,
        127.5
      ],
      [
        1841.0,
        1964.9998779296875,
        123.0
      ],
      [
        1839.0,
        1964.9998779296875,
        123.0
      ],
      [
        1839.0,
        1972.6712646484375,
        120.0
      ],
      [
        1839.0,
        1972.6712646484375,
        123.0
      ],
      [
        1849.4998779296875,
        1977.4998779296875,
        123.0
      ],
      [
        1849.4998779296875,
        1964.9998779296875,
        123.0
      ],
      [
        1847.4998779296875,
        1964.9998779296875,
        120.0
      ],
      [
        1841.0,
        1964.9998779296875,
        120.0
      ],
      [
        1841.0,
        1964.9998779296875,
        123.0
      ],
      [
        1839.0,
        1964.9998779296875,
        120.0
      ],
      [
        1839.0,
        1964.9998779296875,
        123.0
      ],
      [
        1847.4998779296875,
        1964.9998779296875,
        135.0
      ],
      [
        1852.5,
        1964.9998779296875,
        127.5
      ],
      [
        1852.5,
        1964.9998779296875,
        127.5
      ],
      [
        1803.0001220703125,
        1845.0001220703125,
        140.0
      ],
      [
        1802.9998779296875,
        1824.9998779296875,
        140.0
      ],
      [
        1802.9998779296875,
        1824.9998779296875,
        140.0
      ],
      [
        1818.0,
        1825.0,
        140.0
      ],
      [
        1818.0,
        1845.0,
        140.0
      ],
      [
        1803.0001220703125,
        1845.0001220703125,
        140.0
      ],
      [
        1818.0,
        1840.0,
        140.0
      ],
      [
        1818.0,
        1845.0,
        140.0
      ],
      [
        1818.0,
        1825.0,
        140.0
      ],
      [
        1818.0001220703125,
        1830.0001220703125,
        140.0
      ],
      [
        1818.0001220703125,
        1830.0001220703125,
        140.0
      ],
      [
        1818.0,
        1840.0,
        140.0
      ],
      [
        1831.4644775390625,
        1751.4644775390625,
        140.0
      ],
      [
        1830.17041015625,
        1756.2940673828125,
        140.0
      ],
      [
        1836.2940673828125,
        1750.17041015625,
        140.0
      ],
      [
        1831.4644775390625,
        1751.4644775390625,
        140.0
      ],
      [
        1849.82958984375,
        1756.2940673828125,
        140.0
      ],
      [
        1848.5355224609375,
        1751.4644775390625,
        140.0
      ],
      [
        1848.5355224609375,
        1751.4644775390625,
        140.0
      ],
      [
        1843.7059326171875,
        1750.17041015625,
        140.0
      ],
      [
        1830.17041015625,
        1763.7059326171875,
        140.0
      ],
      [
        1831.4644775390625,
        1768.5355224609375,
        140.0
      ],
      [
        1831.4644775390625,
        1768.5355224609375,
        140.0
      ],
      [
        1836.2940673828125,
        1769.82958984375,
        140.0
      ],
      [
        1848.5355224609375,
        1768.5355224609375,
        140.0
      ],
      [
        1849.82958984375,
        1763.7059326171875,
        140.0
      ],
      [
        1843.7059326171875,
        1769.82958984375,
        140.0
      ],
      [
        1848.5355224609375,
        1768.5355224609375,
        140.0
      ],
      [
        1838.53564453125,
        1758.53564453125,
        140.0
      ],
      [
        1839.8297119140625,
        1753.7060546875,
        140.0
      ],
      [
        1833.7060546875,
        1759.8297119140625,
        140.0
      ],
      [
        1838.53564453125,
        1758.53564453125,
        140.0
      ],
      [
        1839.8297119140625,
        1753.7060546875,
        140.0
      ],
      [
        1836.2940673828125,
        1750.17041015625,
        140.0
      ],
      [
        1830.17041015625,
        1756.2940673828125,
        140.0
      ],
      [
        1833.7060546875,
        1759.8297119140625,
        140.0
      ],
      [
        1833.7059326171875,
        1760.17041015625,
        140.0
      ],
      [
        1830.17041015625,
        1763.7059326171875,
        140.0
      ],
      [
        1837.80322265625,
        1761.268310546875,
        140.0
      ],
      [
        1833.7059326171875,
        1760.17041015625,
        140.0
      ],
      [
        1837.80322265625,
        1761.268310546875,
        145.0
      ],
      [
        1841.4644775390625,
        1758.5355224609375,
        140.0
      ],
      [
        1846.2940673828125,
        1759.82958984375,
        140.0
      ],
      [
        1843.7059326171875,
        1750.17041015625,
        140.0
      ],
      [
        1840.17041015625,
        1753.7059326171875,
        140.0
      ],
      [
        1846.2940673828125,
        1759.82958984375,
        140.0
      ],
      [
        1849.82958984375,
        1756.2940673828125,
        140.0
      ],
      [
        1840.17041015625,
        1753.7059326171875,
        140.0
      ],
      [
        1841.4644775390625,
        1758.5355224609375,
        140.0
      ],
      [
        1841.4644775390625,
        1761.4644775390625,
        140.0
      ],
      [
        1840.17041015625,
        1766.2940673828125,
        140.0
      ],
      [
        1840.17041015625,
        1766.2940673828125,
        140.0
      ],
      [
        1843.7059326171875,
        1769.82958984375,
        140.0
      ],
      [
        1849.82958984375,
        1763.7059326171875,
        140.0
      ],
      [
        1846.2940673828125,
        1760.17041015625,
        140.0
      ],
      [
        1846.2940673828125,
        1760.17041015625,
        140.0
      ],
      [
        1841.4644775390625,
        1761.4644775390625,
        140.0
      ],
      [
        1836.2940673828125,
        1769.82958984375,
        140.0
      ],
      [
        1839.82958984375,
        1766.2940673828125,
        140.0
      ],
      [
        1839.82958984375,
        1766.2940673828125,
        140.0
      ],
      [
        1838.5355224609375,
        1761.4644775390625,
        140.0
      ],
      [
        1838.5355224609375,
        1761.4644775390625,
        140.0
      ],
      [
        1655.0,
        1578.0,
        145.0
      ],
      [
        1665.0,
        1578.0,
        145.0
      ],
      [
        1665.0,
        1578.0,
        145.0
      ],
      [
        1655.0,
        1918.0,
        140.0
      ],
      [
        1665.0,
        1918.0,
        140.0
      ],
      [
        1665.0,
        1918.0,
        140.0
      ],
      [
        1664.9998779296875,
        1941.9998779296875,
        145.0
      ],
      [
        1655.0,
        1942.0,
        145.0
      ],
      [
        1664.9998779296875,
        1941.9998779296875,
        145.0
      ],
      [
        2025.0,
        1942.0,
        145.0
      ],
      [
        2015.0,
        1942.0,
        145.0
      ],
      [
        2015.0,
        1942.0,
        145.0
      ],
      [
        2025.0001220703125,
        1602.0001220703125,
        140.0
      ],
      [
        2014.9998779296875,
        1601.9998779296875,
        140.0
      ],
      [
        2014.9998779296875,
        1601.9998779296875,
        140.0
      ],
      [
        2015.0,
        1578.0,
        145.0
      ],
      [
        2025.0,
        1578.0,
        145.0
      ],
      [
        2015.0,
        1578.0,
        145.0
      ],
      [
        1803.0001220703125,
        1845.0001220703125,
        165.0
      ],
      [
        1802.9998779296875,
        1824.9998779296875,
        165.0
      ],
      [
        1802.9998779296875,
        1824.9998779296875,
        165.0
      ],
      [
        1818.0,
        1825.0,
        165.0
      ],
      [
        1818.0,
        1845.0,
        165.0
      ],
      [
        1803.0001220703125,
        1845.0001220703125,
        165.0
      ],
      [
        1818.0,
        1840.0,
        165.0
      ],
      [
        1818.0,
        1845.0,
        165.0
      ],
      [
        1818.0,
        1825.0,
        165.0
      ],
      [
        1818.0001220703125,
        1830.0001220703125,
        165.0
      ],
      [
        1818.0001220703125,
        1830.0001220703125,
        165.0
      ],
      [
        1818.0,
        1840.0,
        165.0
      ],
      [
        1831.4644775390625,
        1751.4644775390625,
        165.0
      ],
      [
        1830.17041015625,
        1756.2940673828125,
        165.0
      ],
      [
        1836.2940673828125,
        1750.17041015625,
        165.0
      ],
      [
        1831.4644775390625,
        1751.4644775390625,
        165.0
      ],
      [
        1849.82958984375,
        1756.2940673828125,
        165.0
      ],
      [
        1848.5355224609375,
        1751.4644775390625,
        165.0
      ],
      [
        1848.5355224609375,
        1751.4644775390625,
        165.0
      ],
      [
        1843.7059326171875,
        1750.17041015625,
        165.0
      ],
      [
        1830.17041015625,
        1763.7059326171875,
        165.0
      ],
      [
        1831.4644775390625,
        1768.5355224609375,
        165.0
      ],
      [
        1831.4644775390625,
        1768.5355224609375,
        165.0
      ],
      [
        1836.2940673828125,
        1769.82958984375,
        165.0
      ],
      [
        1848.5355224609375,
        1768.5355224609375,
        165.0
      ],
      [
        1849.82958984375,
        1763.7059326171875,
        165.0
      ],
      [
        1843.7059326171875,
        1769.82958984375,
        165.0
      ],
      [
        1848.5355224609375,
        1768.5355224609375,
        165.0
      ],
      [
        1838.53564453125,
        1758.53564453125,
        165.0
      ],
      [
        1839.8297119140625,
        1753.7060546875,
        165.0
      ],
      [
        1833.7060546875,
        1759.8297119140625,
        165.0
      ],
      [
        1838.53564453125,
        1758.53564453125,
        165.0
      ],
      [
        1839.8297119140625,
        1753.7060546875,
        165.0
      ],
      [
        1836.2940673828125,
        1750.17041015625,
        165.0
      ],
      [
        1830.17041015625,
        1756.2940673828125,
        165.0
      ],
      [
        1833.7060546875,
        1759.8297119140625,
        165.0
      ],
      [
        1833.7059326171875,
        1760.17041015625,
        165.0
      ],
      [
        1830.17041015625,
        1763.7059326171875,
        165.0
      ],
      [
        1837.80322265625,
        1761.268310546875,
        165.0
      ],
      [
        1833.7059326171875,
        1760.17041015625,
        165.0
      ],
      [
        1837.80322265625,
        1761.268310546875,
        170.0
      ],
      [
        1841.4644775390625,
        1758.5355224609375,
        165.0
      ],
      [
        1846.2940673828125,
        1759.82958984375,
        165.0
      ],
      [
        1843.7059326171875,
        1750.17041015625,
        165.0
      ],
      [
        1840.17041015625,
        1753.7059326171875,
        165.0
      ],
      [
        1846.2940673828125,
        1759.82958984375,
        165.0
      ],
      [
        1849.82958984375,
        1756.2940673828125,
        165.0
      ],
      [
        1840.17041015625,
        1753.7059326171875,
        165.0
      ],
      [
        1841.4644775390625,
        1758.5355224609375,
        165.0
      ],
      [
        1841.4644775390625,
        1761.4644775390625,
        165.0
      ],
      [
        1840.17041015625,
        1766.2940673828125,
        165.0
      ],
      [
        1840.17041015625,
        1766.2940673828125,
        165.0
      ],
      [
        1843.7059326171875,
        1769.82958984375,
        165.0
      ],
      [
        1849.82958984375,
        1763.7059326171875,
        165.0
      ],
      [
        1846.2940673828125,
        1760.17041015625,
        165.0
      ],
      [
        1846.2940673828125,
        1760.17041015625,
        165.0
      ],
      [
        1841.4644775390625,
        1761.4644775390625,
        165.0
      ],
      [
        1836.2940673828125,
        1769.82958984375,
        165.0
      ],
      [
        1839.82958984375,
        1766.2940673828125,
        165.0
      ],
      [
        1839.82958984375,
        1766.2940673828125,
        165.0
      ],
      [
        1838.5355224609375,
        1761.4644775390625,
        165.0
      ],
      [
        1838.5355224609375,
        1761.4644775390625,
        165.0
      ],
      [
        2025.0001220703125,
        1602.0001220703125,
        165.0
      ],
      [
        2014.9998779296875,
        1601.9998779296875,
        165.0
      ],
      [
        2014.9998779296875,
        1601.9998779296875,
        165.0
      ],
      [
        2015.0,
        1918.0,
        165.0
      ],
      [
        2024.9998779296875,
        1917.9998779296875,
        165.0
      ],
      [
        2015.0,
        1918.0,
        165.0
      ],
      [
        1665.0,
        1602.0,
        165.0
      ],
      [
        1655.0,
        1602.0,
        165.0
      ],
      [
        1665.0,
        1602.0,
        165.0
      ],
      [
        1655.0,
        1918.0,
        165.0
      ],
      [
        1665.0,
        1918.0,
        165.0
      ],
      [
        1665.0,
        1918.0,
        165.0
      ],
      [
        1857.4996337890625,
        1885.0,
        170.0
      ],
      [
        1899.999755859375,
        1752.4998779296875,
        185.0
      ],
      [
        1899.999755859375,
        1752.4998779296875,
        185.0
      ],
      [
        1899.999755859375,
        1752.2318115234375,
        184.59791564941406
      ],
      [
        1899.999755859375,
        1767.5,
        185.0
      ],
      [
        1899.999755859375,
        1767.5,
        185.0
      ],
      [
        1899.999755859375,
        1767.76806640625,
        184.59796142578125
      ],
      [
        1847.49951171875,
        1817.990478515625,
        185.0
      ],
      [
        1844.1661376953125,
        1793.001708984375,
        190.0
      ],
      [
        1847.4998779296875,
        1702.009521484375,
        185.0
      ],
      [
        1844.166259765625,
        1726.998291015625,
        190.0
      ],
      [
        1899.999755859375,
        1779.3197021484375,
        177.5
      ],
      [
        1899.999755859375,
        1770.11865234375,
        173.92800903320312
      ],
      [
        1899.999755859375,
        1767.5,
        170.0
      ],
      [
        1899.999755859375,
        1770.11865234375,
        173.92800903320312
      ],
      [
        1899.999755859375,
        1770.11865234375,
        181.07199096679688
      ],
      [
        1899.999755859375,
        1779.3197021484375,
        177.5
      ],
      [
        1899.999755859375,
        1770.11865234375,
        181.07199096679688
      ],
      [
        1899.999755859375,
        1749.8812255859375,
        173.92813110351562
      ],
      [
        1899.999755859375,
        1740.6805419921875,
        177.5
      ],
      [
        1899.999755859375,
        1749.8812255859375,
        173.92813110351562
      ],
      [
        1899.999755859375,
        1752.4998779296875,
        170.0
      ],
      [
        1899.999755859375,
        1740.6805419921875,
        177.5
      ],
      [
        1899.999755859375,
        1749.8812255859375,
        181.07186889648438
      ],
      [
        1899.999755859375,
        1749.8812255859375,
        181.07186889648438
      ],
      [
        1857.499755859375,
        1815.3109130859375,
        170.0
      ],
      [
        1857.5,
        1704.6890869140625,
        170.0
      ],
      [
        1849.82958984375,
        1756.2940673828125,
        181.505126953125
      ],
      [
        1848.5355224609375,
        1751.4644775390625,
        183.44630432128906
      ],
      [
        1848.5355224609375,
        1768.5355224609375,
        183.44630432128906
      ],
      [
        1849.82958984375,
        1763.7059326171875,
        181.505126953125
      ],
      [
        1848.5355224609375,
        1768.5355224609375,
        183.44630432128906
      ],
      [
        1844.166259765625,
        1769.7061767578125,
        190.0
      ],
      [
        1848.5355224609375,
        1751.4644775390625,
        183.44630432128906
      ],
      [
        1844.166259765625,
        1750.2938232421875,
        190.0
      ],
      [
        1846.2940673828125,
        1759.82958984375,
        186.8084259033203
      ],
      [
        1849.82958984375,
        1756.2940673828125,
        181.505126953125
      ],
      [
        1846.2940673828125,
        1759.82958984375,
        186.8084259033203
      ],
      [
        1844.166259765625,
        1759.259521484375,
        190.0
      ],
      [
        1845.828125,
        1760.2952880859375,
        187.50729370117188
      ],
      [
        1844.166259765625,
        1760.740478515625,
        190.0
      ],
      [
        1845.828125,
        1760.2952880859375,
        190.0
      ],
      [
        1849.82958984375,
        1763.7059326171875,
        181.505126953125
      ],
      [
        1846.2940673828125,
        1760.17041015625,
        186.8084259033203
      ],
      [
        1846.2940673828125,
        1760.17041015625,
        186.8084259033203
      ],
      [
        1857.4996337890625,
        1900.0,
        170.0
      ],
      [
        1852.5,
        1900.0,
        177.49923706054688
      ],
      [
        1849.82958984375,
        1756.2940673828125,
        173.49417114257812
      ],
      [
        1848.5355224609375,
        1751.4644775390625,
        171.552978515625
      ],
      [
        1848.5355224609375,
        1768.5355224609375,
        171.55299377441406
      ],
      [
        1849.82958984375,
        1763.7059326171875,
        173.49417114257812
      ],
      [
        1847.5001220703125,
        1758.62353515625,
        170.0
      ],
      [
        1849.82958984375,
        1756.2940673828125,
        173.49417114257812
      ],
      [
        1848.5355224609375,
        1751.4644775390625,
        171.55299377441406
      ],
      [
        1847.5001220703125,
        1751.18701171875,
        170.0
      ],
      [
        1849.82958984375,
        1763.7059326171875,
        173.49417114257812
      ],
      [
        1847.5001220703125,
        1761.37646484375,
        170.0
      ],
      [
        1847.5001220703125,
        1768.81298828125,
        170.0
      ],
      [
        1848.5355224609375,
        1768.5355224609375,
        171.552978515625
      ],
      [
        1822.5,
        1635.0,
        170.0
      ],
      [
        1779.9998779296875,
        1767.5,
        185.0
      ],
      [
        1779.9998779296875,
        1767.5,
        185.0
      ],
      [
        1779.9998779296875,
        1767.76806640625,
        184.597900390625
      ],
      [
        1779.999755859375,
        1752.4998779296875,
        185.0
      ],
      [
        1779.999755859375,
        1752.4998779296875,
        185.0
      ],
      [
        1779.999755859375,
        1752.2318115234375,
        184.5978240966797
      ],
      [
        1832.499755859375,
        1702.0096435546875,
        185.0
      ],
      [
        1835.8331298828125,
        1726.9984130859375,
        190.0
      ],
      [
        1828.0384521484375,
        1830.0,
        185.0
      ],
      [
        1832.5,
        1834.4615478515625,
        185.0
      ],
      [
        1818.0,
        1825.0,
        179.6556854248047
      ],
      [
        1808.896484375,
        1824.9998779296875,
        170.0
      ],
      [
        1818.0001220703125,
        1830.0001220703125,
        174.3525390625
      ],
      [
        1818.0,
        1825.0,
        179.6556854248047
      ],
      [
        1822.4996337890625,
        1840.0,
        170.0
      ],
      [
        1820.0,
        1830.0,
        176.47401428222656
      ],
      [
        1818.0001220703125,
        1830.0001220703125,
        174.3525390625
      ],
      [
        1820.96728515625,
        1830.0,
        177.5
      ],
      [
        1828.0384521484375,
        1830.0,
        185.0
      ],
      [
        1820.96728515625,
        1830.0,
        177.5
      ],
      [
        1820.0,
        1830.0,
        176.47401428222656
      ],
      [
        1832.49951171875,
        1817.990234375,
        185.0
      ],
      [
        1835.8330078125,
        1793.00146484375,
        190.0
      ],
      [
        1830.8980712890625,
        1830.0,
        182.5970001220703
      ],
      [
        1825.5098876953125,
        1830.0,
        182.31809997558594
      ],
      [
        1818.0,
        1825.0,
        175.34425354003906
      ],
      [
        1815.967529296875,
        1825.0,
        177.4999542236328
      ],
      [
        1822.4996337890625,
        1830.0,
        170.0
      ],
      [
        1824.7939453125,
        1830.0,
        173.44122314453125
      ],
      [
        1818.0,
        1827.032470703125,
        177.49998474121094
      ],
      [
        1818.0,
        1825.0,
        175.34425354003906
      ],
      [
        1779.999755859375,
        1740.682373046875,
        177.5
      ],
      [
        1779.999755859375,
        1749.8807373046875,
        173.92884826660156
      ],
      [
        1779.999755859375,
        1752.4998779296875,
        170.0
      ],
      [
        1779.999755859375,
        1749.8807373046875,
        173.92884826660156
      ],
      [
        1779.999755859375,
        1749.8807373046875,
        181.07115173339844
      ],
      [
        1779.999755859375,
        1740.682373046875,
        177.5
      ],
      [
        1779.999755859375,
        1749.8807373046875,
        181.07115173339844
      ],
      [
        1779.9998779296875,
        1770.1190185546875,
        173.92860412597656
      ],
      [
        1779.9998779296875,
        1779.3184814453125,
        177.5
      ],
      [
        1779.9998779296875,
        1770.1190185546875,
        173.92860412597656
      ],
      [
        1779.9998779296875,
        1767.5,
        170.0
      ],
      [
        1779.9998779296875,
        1779.3184814453125,
        177.5
      ],
      [
        1779.9998779296875,
        1770.1190185546875,
        181.07139587402344
      ],
      [
        1779.9998779296875,
        1770.1190185546875,
        181.07139587402344
      ],
      [
        1822.4998779296875,
        1704.6890869140625,
        170.0
      ],
      [
        1822.4996337890625,
        1815.310791015625,
        170.0
      ],
      [
        1831.4644775390625,
        1751.4644775390625,
        183.44711303710938
      ],
      [
        1830.17041015625,
        1756.2940673828125,
        181.5059051513672
      ],
      [
        1830.17041015625,
        1763.7059326171875,
        181.5059051513672
      ],
      [
        1831.4644775390625,
        1768.5355224609375,
        183.44711303710938
      ],
      [
        1831.4644775390625,
        1751.4644775390625,
        183.44711303710938
      ],
      [
        1835.8331298828125,
        1750.2939453125,
        190.0
      ],
      [
        1831.4644775390625,
        1768.5355224609375,
        183.44711303710938
      ],
      [
        1835.8331298828125,
        1769.7060546875,
        190.0
      ],
      [
        1830.17041015625,
        1756.2940673828125,
        181.5059051513672
      ],
      [
        1833.7060546875,
        1759.8297119140625,
        186.8094940185547
      ],
      [
        1833.7060546875,
        1759.8297119140625,
        186.8094940185547
      ],
      [
        1835.8331298828125,
        1759.259765625,
        190.0
      ],
      [
        1834.17138671875,
        1760.295166015625,
        190.0
      ],
      [
        1835.8331298828125,
        1760.7403564453125,
        190.0
      ],
      [
        1834.17138671875,
        1760.295166015625,
        187.50747680664062
      ],
      [
        1833.7059326171875,
        1760.17041015625,
        186.80926513671875
      ],
      [
        1830.17041015625,
        1763.7059326171875,
        181.5059051513672
      ],
      [
        1833.7059326171875,
        1760.17041015625,
        186.80926513671875
      ],
      [
        1832.5001220703125,
        1555.0001220703125,
        185.0
      ],
      [
        1822.5001220703125,
        1620.0001220703125,
        170.0
      ],
      [
        1817.2489013671875,
        1555.0001220703125,
        172.99630737304688
      ],
      [
        1824.49755859375,
        1558.002197265625,
        172.9959259033203
      ],
      [
        1824.49755859375,
        1558.002197265625,
        172.9959259033203
      ],
      [
        1822.500244140625,
        1555.177734375,
        170.0
      ],
      [
        1831.4644775390625,
        1751.4644775390625,
        171.55322265625
      ],
      [
        1830.17041015625,
        1756.2940673828125,
        173.49441528320312
      ],
      [
        1830.17041015625,
        1763.7059326171875,
        173.49441528320312
      ],
      [
        1831.4644775390625,
        1768.5355224609375,
        171.55322265625
      ],
      [
        1830.17041015625,
        1756.2940673828125,
        173.49441528320312
      ],
      [
        1832.5,
        1758.6236572265625,
        170.0
      ],
      [
        1832.5,
        1751.18701171875,
        170.0
      ],
      [
        1831.4644775390625,
        1751.4644775390625,
        171.55322265625
      ],
      [
        1832.5,
        1761.3763427734375,
        170.0
      ],
      [
        1830.17041015625,
        1763.7059326171875,
        173.49441528320312
      ],
      [
        1831.4644775390625,
        1768.5355224609375,
        171.55322265625
      ],
      [
        1832.5,
        1768.81298828125,
        170.0
      ],
      [
        1836.2940673828125,
        1769.82958984375,
        185.0
      ],
      [
        1832.499755859375,
        1768.8128662109375,
        185.0
      ],
      [
        1836.2940673828125,
        1750.17041015625,
        185.0
      ],
      [
        1832.499755859375,
        1751.1871337890625,
        185.0
      ],
      [
        1843.7059326171875,
        1769.82958984375,
        185.0
      ],
      [
        1847.4996337890625,
        1768.8131103515625,
        185.0
      ],
      [
        1843.7059326171875,
        1750.17041015625,
        185.0
      ],
      [
        1847.4996337890625,
        1751.1868896484375,
        185.0
      ],
      [
        1838.53564453125,
        1758.53564453125,
        185.0
      ],
      [
        1839.8297119140625,
        1753.7060546875,
        185.0
      ],
      [
        1839.8297119140625,
        1753.7060546875,
        185.0
      ],
      [
        1836.2940673828125,
        1750.17041015625,
        185.0
      ],
      [
        1833.7060546875,
        1759.8297119140625,
        185.0
      ],
      [
        1838.53564453125,
        1758.53564453125,
        185.0
      ],
      [
        1833.7060546875,
        1759.8297119140625,
        185.0
      ],
      [
        1832.499755859375,
        1758.6234130859375,
        185.0
      ],
      [
        1837.80322265625,
        1761.268310546875,
        185.0
      ],
      [
        1833.7059326171875,
        1760.17041015625,
        185.0
      ],
      [
        1837.80322265625,
        1761.268310546875,
        190.0
      ],
      [
        1833.7059326171875,
        1760.17041015625,
        185.0
      ],
      [
        1832.499755859375,
        1761.3765869140625,
        185.0
      ],
      [
        1839.82958984375,
        1766.2940673828125,
        185.0
      ],
      [
        1838.5355224609375,
        1761.4644775390625,
        185.0
      ],
      [
        1836.2940673828125,
        1769.82958984375,
        185.0
      ],
      [
        1839.82958984375,
        1766.2940673828125,
        185.0
      ],
      [
        1838.5355224609375,
        1761.4644775390625,
        185.0
      ],
      [
        1843.7059326171875,
        1750.17041015625,
        185.0
      ],
      [
        1840.17041015625,
        1753.7059326171875,
        185.0
      ],
      [
        1840.17041015625,
        1766.2940673828125,
        185.0
      ],
      [
        1843.7059326171875,
        1769.82958984375,
        185.0
      ],
      [
        1841.4644775390625,
        1758.5355224609375,
        185.0
      ],
      [
        1846.2940673828125,
        1759.82958984375,
        185.0
      ],
      [
        1840.17041015625,
        1753.7059326171875,
        185.0
      ],
      [
        1841.4644775390625,
        1758.5355224609375,
        185.0
      ],
      [
        1846.2940673828125,
        1759.82958984375,
        185.0
      ],
      [
        1847.4996337890625,
        1758.6240234375,
        185.0
      ],
      [
        1841.4644775390625,
        1761.4644775390625,
        185.0
      ],
      [
        1840.17041015625,
        1766.2940673828125,
        185.0
      ],
      [
        1846.2940673828125,
        1760.17041015625,
        185.0
      ],
      [
        1841.4644775390625,
        1761.4644775390625,
        185.0
      ],
      [
        1846.2940673828125,
        1760.17041015625,
        185.0
      ],
      [
        1847.4996337890625,
        1761.3759765625,
        185.0
      ],
      [
        1837.8033447265625,
        1758.73193359375,
        170.0
      ],
      [
        1837.8033447265625,
        1758.73193359375,
        185.0
      ],
      [
        1721.0067138671875,
        1756.268310546875,
        182.0
      ],
      [
        1721.0067138671875,
        1756.268310546875,
        173.0
      ],
      [
        1731.3160400390625,
        1795.0,
        180.0
      ],
      [
        1730.78369140625,
        1793.0,
        174.0
      ],
      [
        1731.3160400390625,
        1795.0,
        180.0
      ],
      [
        1730.78369140625,
        1793.0,
        174.0
      ],
      [
        1750.0,
        1777.4996337890625,
        170.0
      ],
      [
        1779.9998779296875,
        1773.9017333984375,
        175.39712524414062
      ],
      [
        1730.6318359375,
        1728.0,
        174.0
      ],
      [
        1731.1715087890625,
        1725.9998779296875,
        180.0
      ],
      [
        1731.1715087890625,
        1725.9998779296875,
        180.0
      ],
      [
        1730.6318359375,
        1728.0,
        174.0
      ],
      [
        1730.6318359375,
        1728.0,
        174.0
      ],
      [
        1750.0001220703125,
        1742.5003662109375,
        185.0
      ],
      [
        1779.999755859375,
        1746.0982666015625,
        179.60264587402344
      ],
      [
        1680.6767578125,
        1765.0,
        190.0
      ],
      [
        1680.6767578125,
        1765.0,
        170.0
      ],
      [
        1681.476806640625,
        1755.0,
        170.0
      ],
      [
        1681.476806640625,
        1755.0,
        190.0
      ],
      [
        1680.0,
        1756.476806640625,
        170.0
      ],
      [
        1680.0,
        1764.3232421875,
        170.0
      ],
      [
        1680.0,
        1764.3232421875,
        190.0
      ],
      [
        1680.0,
        1756.476806640625,
        190.0
      ],
      [
        1899.999755859375,
        1769.5,
        173.0
      ],
      [
        1930.0,
        1769.5,
        173.0
      ],
      [
        1930.0,
        1769.5,
        173.0
      ],
      [
        1930.0,
        1790.0,
        173.0
      ],
      [
        1899.999755859375,
        1750.5,
        173.0
      ],
      [
        1930.0,
        1750.5,
        173.0
      ],
      [
        1930.0001220703125,
        1731.0001220703125,
        173.0
      ],
      [
        1930.0,
        1750.5,
        173.0
      ],
      [
        1958.993408203125,
        1756.268310546875,
        182.0
      ],
      [
        1949.2164306640625,
        1793.0,
        174.0
      ],
      [
        1948.6839599609375,
        1794.9998779296875,
        180.0
      ],
      [
        1948.6839599609375,
        1794.9998779296875,
        180.0
      ],
      [
        1949.2164306640625,
        1793.0,
        174.0
      ],
      [
        1949.2164306640625,
        1793.0,
        174.0
      ],
      [
        1948.8287353515625,
        1726.0,
        180.0
      ],
      [
        1949.3681640625,
        1728.0001220703125,
        174.0
      ],
      [
        1948.8287353515625,
        1726.0,
        180.0
      ],
      [
        1949.3681640625,
        1728.0001220703125,
        174.0
      ],
      [
        1930.0,
        1775.4998779296875,
        173.0
      ],
      [
        1899.999755859375,
        1773.902099609375,
        175.39678955078125
      ],
      [
        1930.0,
        1744.500244140625,
        173.0
      ],
      [
        1899.999755859375,
        1746.0980224609375,
        175.3968505859375
      ],
      [
        1999.3232421875,
        1765.0,
        170.0
      ],
      [
        1999.3232421875,
        1765.0,
        190.0
      ],
      [
        1998.5230712890625,
        1755.0,
        190.0
      ],
      [
        1998.5230712890625,
        1755.0,
        170.0
      ],
      [
        2000.0,
        1756.4769287109375,
        190.0
      ],
      [
        2000.0,
        1764.3232421875,
        190.0
      ],
      [
        2000.0,
        1764.3232421875,
        170.0
      ],
      [
        2000.0,
        1756.4769287109375,
        170.0
      ],
      [
        1832.5,
        1820.4000244140625,
        160.0
      ],
      [
        1841.4931640625,
        1820.4000244140625,
        160.0
      ],
      [
        1832.4998779296875,
        1820.4000244140625,
        160.0
      ],
      [
        1832.178466796875,
        1820.4000244140625,
        159.51780700683594
      ],
      [
        1847.5001220703125,
        1820.4000244140625,
        160.0
      ],
      [
        1847.5,
        1820.4000244140625,
        160.0
      ],
      [
        1847.8214111328125,
        1820.4000244140625,
        159.51783752441406
      ],
      [
        1840.0,
        1700.4000244140625,
        160.07728576660156
      ],
      [
        1841.492919921875,
        1700.4000244140625,
        160.0
      ],
      [
        1841.492919921875,
        1700.4000244140625,
        160.0
      ],
      [
        1847.5001220703125,
        1700.4000244140625,
        160.0
      ],
      [
        1847.5,
        1700.4000244140625,
        160.0
      ],
      [
        1847.7147216796875,
        1700.4000244140625,
        159.67794799804688
      ],
      [
        1840.0,
        1700.4000244140625,
        160.07728576660156
      ],
      [
        1838.507080078125,
        1700.4000244140625,
        160.0
      ],
      [
        1832.5,
        1700.4000244140625,
        160.0
      ],
      [
        1838.5069580078125,
        1700.4000244140625,
        160.0
      ],
      [
        1832.4998779296875,
        1700.4000244140625,
        160.0
      ],
      [
        1832.28515625,
        1700.4000244140625,
        159.677978515625
      ],
      [
        1857.82568359375,
        1820.4000244140625,
        152.5
      ],
      [
        1850.6402587890625,
        1820.4000244140625,
        155.28953552246094
      ],
      [
        1850.6402587890625,
        1820.4000244140625,
        155.28953552246094
      ],
      [
        1850.6402587890625,
        1820.4000244140625,
        149.71046447753906
      ],
      [
        1857.82568359375,
        1820.4000244140625,
        152.5
      ],
      [
        1850.6402587890625,
        1820.4000244140625,
        149.71046447753906
      ],
      [
        1847.5,
        1820.4000244140625,
        145.0
      ],
      [
        1829.359619140625,
        1820.4000244140625,
        155.28944396972656
      ],
      [
        1822.17431640625,
        1820.4000244140625,
        152.5
      ],
      [
        1829.359619140625,
        1820.4000244140625,
        155.28944396972656
      ],
      [
        1822.17431640625,
        1820.4000244140625,
        152.5
      ],
      [
        1829.359619140625,
        1820.4000244140625,
        149.71055603027344
      ],
      [
        1832.4998779296875,
        1820.4000244140625,
        145.0
      ],
      [
        1829.359619140625,
        1820.4000244140625,
        149.71055603027344
      ],
      [
        1849.5975341796875,
        1700.4000244140625,
        156.85357666015625
      ],
      [
        1860.8118896484375,
        1700.4000244140625,
        152.5
      ],
      [
        1849.5975341796875,
        1700.4000244140625,
        156.85357666015625
      ],
      [
        1860.8118896484375,
        1700.4000244140625,
        152.5
      ],
      [
        1849.5975341796875,
        1700.4000244140625,
        148.14642333984375
      ],
      [
        1847.5,
        1700.4000244140625,
        145.0
      ],
      [
        1849.5975341796875,
        1700.4000244140625,
        148.14642333984375
      ],
      [
        1819.1884765625,
        1700.4000244140625,
        152.5
      ],
      [
        1830.40234375,
        1700.4000244140625,
        156.85362243652344
      ],
      [
        1830.40234375,
        1700.4000244140625,
        156.85362243652344
      ],
      [
        1830.40234375,
        1700.4000244140625,
        148.14637756347656
      ],
      [
        1819.1884765625,
        1700.4000244140625,
        152.5
      ],
      [
        1830.40234375,
        1700.4000244140625,
        148.14637756347656
      ],
      [
        1832.4998779296875,
        1700.4000244140625,
        145.0
      ],
      [
        1835.5621337890625,
        1769.6334228515625,
        160.0
      ],
      [
        1835.5621337890625,
        1769.6334228515625,
        165.0
      ],
      [
        1835.5621337890625,
        1769.6334228515625,
        160.0
      ],
      [
        1835.5621337890625,
        1769.6334228515625,
        145.0
      ],
      [
        1837.803466796875,
        1761.268310546875,
        160.0
      ],
      [
        1837.803466796875,
        1761.268310546875,
        165.0
      ],
      [
        1837.803466796875,
        1761.268310546875,
        160.0
      ],
      [
        1837.803466796875,
        1761.268310546875,
        145.0
      ],
      [
        1840.295166015625,
        1754.17138671875,
        160.0
      ],
      [
        1840.295166015625,
        1754.17138671875,
        165.0
      ],
      [
        1840.295166015625,
        1754.17138671875,
        160.0
      ],
      [
        1840.295166015625,
        1754.17138671875,
        145.0
      ],
      [
        1845.82861328125,
        1759.704833984375,
        160.0
      ],
      [
        1845.82861328125,
        1759.704833984375,
        165.0
      ],
      [
        1845.82861328125,
        1759.704833984375,
        160.0
      ],
      [
        1845.82861328125,
        1759.704833984375,
        145.0
      ],
      [
        1844.4381103515625,
        1769.6334228515625,
        160.0
      ],
      [
        1844.4381103515625,
        1769.6334228515625,
        165.0
      ],
      [
        1844.4381103515625,
        1769.6334228515625,
        160.0
      ],
      [
        1844.4381103515625,
        1769.6334228515625,
        145.0
      ],
      [
        1842.1966552734375,
        1761.268310546875,
        160.0
      ],
      [
        1842.1966552734375,
        1761.268310546875,
        165.0
      ],
      [
        1842.1966552734375,
        1761.268310546875,
        160.0
      ],
      [
        1842.1966552734375,
        1761.268310546875,
        145.0
      ],
      [
        1840.2952880859375,
        1765.828125,
        160.0
      ],
      [
        1840.2952880859375,
        1765.828125,
        165.0
      ],
      [
        1840.2952880859375,
        1765.828125,
        160.0
      ],
      [
        1840.2952880859375,
        1765.828125,
        145.0
      ],
      [
        1843.7442626953125,
        1879.3966064453125,
        157.0
      ],
      [
        1843.7442626953125,
        1879.3966064453125,
        148.0
      ],
      [
        1807.0,
        1869.6163330078125,
        149.0
      ],
      [
        1805.0,
        1869.083984375,
        155.0
      ],
      [
        1805.0,
        1869.083984375,
        155.0
      ],
      [
        1807.0,
        1869.6163330078125,
        149.0
      ],
      [
        1857.5,
        1850.400146484375,
        145.0
      ],
      [
        1853.5948486328125,
        1820.4000244140625,
        150.85751342773438
      ],
      [
        1874.0001220703125,
        1869.228515625,
        155.0
      ],
      [
        1874.0001220703125,
        1869.228515625,
        155.0
      ],
      [
        1872.0,
        1869.7679443359375,
        149.0
      ],
      [
        1872.0,
        1869.7679443359375,
        149.0
      ],
      [
        1832.4998779296875,
        1825.0001220703125,
        145.0
      ],
      [
        1827.5,
        1825.0001220703125,
        152.5
      ],
      [
        1826.405029296875,
        1820.4000244140625,
        154.14244079589844
      ],
      [
        1832.4998779296875,
        1825.0001220703125,
        160.0
      ],
      [
        1827.5,
        1825.0001220703125,
        152.5
      ],
      [
        1832.5,
        1844.9998779296875,
        145.0
      ],
      [
        1827.5001220703125,
        1844.9998779296875,
        152.5
      ],
      [
        1827.5001220703125,
        1844.9998779296875,
        152.5
      ],
      [
        1832.5,
        1844.9998779296875,
        160.0
      ],
      [
        1843.7447509765625,
        1641.4034423828125,
        157.0
      ],
      [
        1843.7447509765625,
        1641.4034423828125,
        148.0
      ],
      [
        1805.0,
        1651.7161865234375,
        155.0
      ],
      [
        1807.0,
        1651.183837890625,
        149.0
      ],
      [
        1805.0,
        1651.7161865234375,
        155.0
      ],
      [
        1807.0,
        1651.183837890625,
        149.0
      ],
      [
        1872.0001220703125,
        1651.0321044921875,
        149.0
      ],
      [
        1874.0,
        1651.571533203125,
        155.0
      ],
      [
        1874.0,
        1651.571533203125,
        155.0
      ],
      [
        1872.0001220703125,
        1651.0321044921875,
        149.0
      ],
      [
        1857.4996337890625,
        1670.4000244140625,
        160.0
      ],
      [
        1854.208740234375,
        1700.4000244140625,
        155.06344604492188
      ],
      [
        1822.5001220703125,
        1670.4000244140625,
        145.0
      ],
      [
        1825.791015625,
        1700.4000244140625,
        149.9366455078125
      ],
      [
        1780.0,
        1864.322998046875,
        135.0
      ],
      [
        1780.0001220703125,
        1965.0001220703125,
        135.0
      ],
      [
        1780.0,
        1555.0,
        135.0
      ],
      [
        1780.0,
        1656.4769287109375,
        135.0
      ],
      [
        1900.0,
        1864.322998046875,
        135.0
      ],
      [
        1900.0,
        1965.0,
        135.0
      ],
      [
        1900.0,
        1555.0,
        135.0
      ],
      [
        1899.9998779296875,
        1656.476806640625,
        135.0
      ],
      [
        1837.80322265625,
        1761.268310546875,
        135.0
      ],
      [
        1837.80322265625,
        1761.268310546875,
        140.0
      ],
      [
        1943.923095703125,
        1700.4000244140625,
        135.0
      ],
      [
        1899.9998779296875,
        1656.476806640625,
        135.0
      ],
      [
        1943.923095703125,
        1820.4000244140625,
        135.0
      ],
      [
        1948.9803466796875,
        1801.39990234375,
        135.0
      ],
      [
        1948.9803466796875,
        1801.39990234375,
        135.0
      ],
      [
        1960.0,
        1760.0,
        135.0
      ],
      [
        1943.923095703125,
        1700.4000244140625,
        135.0
      ],
      [
        1949.08203125,
        1719.5250244140625,
        135.0
      ],
      [
        1960.0,
        1760.0,
        135.0
      ],
      [
        1949.08203125,
        1719.5250244140625,
        135.0
      ],
      [
        1990.0001220703125,
        1855.0001220703125,
        135.0
      ],
      [
        2000.0001220703125,
        1855.0,
        135.0
      ],
      [
        1989.9998779296875,
        1899.9998779296875,
        135.0
      ],
      [
        2000.0001220703125,
        1900.0001220703125,
        135.0
      ],
      [
        1990.0001220703125,
        1910.0001220703125,
        135.0
      ],
      [
        1989.9998779296875,
        1899.9998779296875,
        135.0
      ],
      [
        2000.0001220703125,
        1900.0001220703125,
        135.0
      ],
      [
        2000.0,
        1910.0,
        135.0
      ],
      [
        2000.0001220703125,
        1855.0,
        135.0
      ],
      [
        2000.0,
        1865.0,
        135.0
      ],
      [
        1990.0001220703125,
        1865.0,
        135.0
      ],
      [
        1990.0001220703125,
        1855.0001220703125,
        135.0
      ],
      [
        1990.0,
        1765.0,
        135.0
      ],
      [
        2000.0,
        1765.0,
        135.0
      ],
      [
        1990.0,
        1765.0,
        135.0
      ],
      [
        1990.0001220703125,
        1755.0001220703125,
        135.0
      ],
      [
        2000.0,
        1756.4769287109375,
        140.0
      ],
      [
        2000.0,
        1765.0,
        135.0
      ],
      [
        2000.0,
        1756.4769287109375,
        135.0
      ],
      [
        1990.0001220703125,
        1755.0001220703125,
        135.0
      ],
      [
        1998.5230712890625,
        1755.0,
        140.0
      ],
      [
        1998.5230712890625,
        1755.0,
        135.0
      ],
      [
        1990.0,
        1805.0,
        135.0
      ],
      [
        2000.0,
        1805.0,
        135.0
      ],
      [
        1990.0,
        1815.0,
        135.0
      ],
      [
        1990.0,
        1805.0,
        135.0
      ],
      [
        2000.0,
        1805.0,
        135.0
      ],
      [
        2000.0,
        1815.0,
        135.0
      ],
      [
        2025.0001220703125,
        1594.0001220703125,
        135.0
      ],
      [
        2014.9998779296875,
        1593.9998779296875,
        135.0
      ],
      [
        2014.9998779296875,
        1602.178466796875,
        135.0
      ],
      [
        2025.0001220703125,
        1602.1787109375,
        135.0
      ],
      [
        2014.9998779296875,
        1593.9998779296875,
        135.0
      ],
      [
        2014.9998779296875,
        1602.178466796875,
        135.0
      ],
      [
        1990.0,
        1665.0,
        135.0
      ],
      [
        2000.0,
        1665.0,
        135.0
      ],
      [
        1990.0,
        1620.0,
        135.0
      ],
      [
        2000.0,
        1620.0,
        135.0
      ],
      [
        1990.0,
        1620.0,
        135.0
      ],
      [
        1990.0,
        1610.0,
        135.0
      ],
      [
        2000.0,
        1610.0,
        135.0
      ],
      [
        2000.0,
        1620.0,
        135.0
      ],
      [
        1990.0,
        1610.0,
        135.0
      ],
      [
        2000.0,
        1610.0,
        135.0
      ],
      [
        1990.0,
        1665.0,
        135.0
      ],
      [
        1990.0,
        1655.0,
        135.0
      ],
      [
        2000.0,
        1655.0,
        135.0
      ],
      [
        2000.0,
        1665.0,
        135.0
      ],
      [
        1990.0,
        1655.0,
        135.0
      ],
      [
        2000.0,
        1655.0,
        135.0
      ],
      [
        1990.0,
        1715.0,
        135.0
      ],
      [
        2000.0,
        1715.0,
        135.0
      ],
      [
        1990.0,
        1715.0,
        135.0
      ],
      [
        1990.0,
        1705.0,
        135.0
      ],
      [
        2000.0,
        1705.0,
        135.0
      ],
      [
        2000.0,
        1715.0,
        135.0
      ],
      [
        1990.0,
        1705.0,
        135.0
      ],
      [
        2000.0,
        1705.0,
        135.0
      ],
      [
        2000.0,
        1755.0,
        135.0
      ],
      [
        2000.0,
        1755.0,
        135.0
      ],
      [
        1736.0767822265625,
        1820.39990234375,
        135.0
      ],
      [
        1780.0,
        1864.322998046875,
        135.0
      ],
      [
        1731.0196533203125,
        1801.4000244140625,
        135.0
      ],
      [
        1736.0767822265625,
        1820.39990234375,
        135.0
      ],
      [
        1720.0001220703125,
        1760.0001220703125,
        135.0
      ],
      [
        1731.0196533203125,
        1801.4000244140625,
        135.0
      ],
      [
        1730.91796875,
        1719.52490234375,
        135.0
      ],
      [
        1736.076904296875,
        1700.4000244140625,
        135.0
      ],
      [
        1730.91796875,
        1719.52490234375,
        135.0
      ],
      [
        1720.0001220703125,
        1760.0001220703125,
        135.0
      ],
      [
        1690.0,
        1610.0,
        135.0
      ],
      [
        1690.0,
        1620.0,
        135.0
      ],
      [
        1682.736083984375,
        1620.0,
        140.0
      ],
      [
        1682.736083984375,
        1620.0,
        135.0
      ],
      [
        1690.0,
        1620.0,
        135.0
      ],
      [
        1680.0,
        1665.0,
        135.0
      ],
      [
        1690.0,
        1665.0,
        135.0
      ],
      [
        1680.0,
        1620.0,
        135.0
      ],
      [
        1680.0,
        1610.0,
        135.0
      ],
      [
        1680.0,
        1665.0,
        135.0
      ],
      [
        1680.0,
        1655.0,
        135.0
      ],
      [
        1690.0,
        1655.0,
        135.0
      ],
      [
        1690.0,
        1665.0,
        135.0
      ],
      [
        1680.0,
        1620.0,
        135.0
      ],
      [
        1680.0,
        1755.0,
        135.0
      ],
      [
        1690.0,
        1755.0,
        135.0
      ],
      [
        1690.0,
        1755.0,
        135.0
      ],
      [
        1690.0,
        1765.0,
        135.0
      ],
      [
        1680.6767578125,
        1765.0,
        140.0
      ],
      [
        1680.6767578125,
        1765.0,
        135.0
      ],
      [
        1690.0,
        1765.0,
        135.0
      ],
      [
        1680.0,
        1764.3232421875,
        140.0
      ],
      [
        1680.0,
        1755.0,
        135.0
      ],
      [
        1680.0,
        1764.3232421875,
        135.0
      ],
      [
        1680.0,
        1715.0,
        135.0
      ],
      [
        1680.0,
        1705.0,
        135.0
      ],
      [
        1680.0,
        1715.0,
        135.0
      ],
      [
        1689.9998779296875,
        1714.9998779296875,
        135.0
      ],
      [
        1690.0,
        1705.0,
        135.0
      ],
      [
        1689.9998779296875,
        1714.9998779296875,
        135.0
      ],
      [
        1665.0,
        1918.3214111328125,
        135.0
      ],
      [
        1655.0,
        1918.3214111328125,
        135.0
      ],
      [
        1655.0,
        1926.0,
        135.0
      ],
      [
        1665.0,
        1926.0,
        135.0
      ],
      [
        1665.0,
        1926.0,
        135.0
      ],
      [
        1665.0,
        1918.3214111328125,
        135.0
      ],
      [
        1680.0001220703125,
        1855.0,
        135.0
      ],
      [
        1690.0,
        1855.0,
        135.0
      ],
      [
        1680.0001220703125,
        1900.0001220703125,
        135.0
      ],
      [
        1690.0001220703125,
        1900.0,
        135.0
      ],
      [
        1690.0001220703125,
        1900.0,
        135.0
      ],
      [
        1690.0,
        1910.0,
        135.0
      ],
      [
        1680.0001220703125,
        1910.0,
        135.0
      ],
      [
        1680.0001220703125,
        1900.0001220703125,
        135.0
      ],
      [
        1680.0001220703125,
        1910.0,
        135.0
      ],
      [
        1690.0,
        1910.0,
        135.0
      ],
      [
        1690.0,
        1855.0,
        135.0
      ],
      [
        1690.0,
        1865.0,
        135.0
      ],
      [
        1680.0,
        1865.0,
        135.0
      ],
      [
        1680.0001220703125,
        1855.0,
        135.0
      ],
      [
        1680.0,
        1865.0,
        135.0
      ],
      [
        1690.0,
        1865.0,
        135.0
      ],
      [
        1680.0,
        1805.0,
        135.0
      ],
      [
        1690.0,
        1805.0,
        135.0
      ],
      [
        1680.0,
        1815.0,
        135.0
      ],
      [
        1680.0,
        1805.0,
        135.0
      ],
      [
        1680.0,
        1815.0,
        135.0
      ],
      [
        1690.0,
        1814.9998779296875,
        135.0
      ],
      [
        1690.0,
        1805.0,
        135.0
      ],
      [
        1690.0,
        1814.9998779296875,
        135.0
      ],
      [
        1680.0,
        1765.0,
        135.0
      ],
      [
        1680.0,
        1765.0,
        135.0
      ],
      [
        1851.4998779296875,
        1775.307373046875,
        126.0
      ],
      [
        1851.4998779296875,
        1744.692626953125,
        126.0
      ],
      [
        1895.5478515625,
        1792.070556640625,
        126.0
      ],
      [
        1899.999755859375,
        1775.455810546875,
        126.0
      ],
      [
        1899.999755859375,
        1770.11865234375,
        123.92801666259766
      ],
      [
        1899.999755859375,
        1767.5,
        120.0
      ],
      [
        1899.999755859375,
        1770.11865234375,
        123.92801666259766
      ],
      [
        1899.999755859375,
        1749.8812255859375,
        123.92813110351562
      ],
      [
        1899.999755859375,
        1744.5443115234375,
        126.0
      ],
      [
        1895.5478515625,
        1727.929443359375,
        126.0
      ],
      [
        1899.999755859375,
        1749.8812255859375,
        123.92813110351562
      ],
      [
        1899.999755859375,
        1752.4998779296875,
        120.0
      ],
      [
        1851.4998779296875,
        1775.307373046875,
        126.0
      ],
      [
        1850.670654296875,
        1778.4820556640625,
        124.75614166259766
      ],
      [
        1850.670654296875,
        1741.5181884765625,
        124.75625610351562
      ],
      [
        1851.4998779296875,
        1744.692626953125,
        126.0
      ],
      [
        1847.4998779296875,
        1738.2442626953125,
        120.0
      ],
      [
        1849.499755859375,
        1738.7801513671875,
        123.0
      ],
      [
        1847.4998779296875,
        1781.755859375,
        120.0
      ],
      [
        1849.499755859375,
        1781.219970703125,
        123.0
      ],
      [
        1849.499755859375,
        1738.7801513671875,
        123.0
      ],
      [
        1850.670654296875,
        1741.5181884765625,
        124.75625610351562
      ],
      [
        1849.499755859375,
        1781.219970703125,
        123.0
      ],
      [
        1850.670654296875,
        1778.4820556640625,
        124.75614166259766
      ],
      [
        1899.999755859375,
        1770.11865234375,
        131.07199096679688
      ],
      [
        1899.999755859375,
        1779.3197021484375,
        127.5
      ],
      [
        1899.999755859375,
        1770.11865234375,
        131.07199096679688
      ],
      [
        1899.999755859375,
        1767.5,
        135.0
      ],
      [
        1899.999755859375,
        1740.6805419921875,
        127.5
      ],
      [
        1899.999755859375,
        1749.8812255859375,
        131.07186889648438
      ],
      [
        1899.999755859375,
        1752.4998779296875,
        135.0
      ],
      [
        1899.999755859375,
        1749.8812255859375,
        131.07186889648438
      ],
      [
        1857.5,
        1704.6890869140625,
        135.0
      ],
      [
        1857.5,
        1815.3109130859375,
        135.0
      ],
      [
        1899.999755859375,
        1740.6805419921875,
        127.5
      ],
      [
        1899.999755859375,
        1779.3197021484375,
        127.5
      ],
      [
        1899.999755859375,
        1769.5,
        123.0
      ],
      [
        1930.0,
        1769.5,
        123.0
      ],
      [
        1930.0,
        1769.5,
        123.0
      ],
      [
        1930.0,
        1790.0,
        123.0
      ],
      [
        1899.999755859375,
        1750.5,
        123.0
      ],
      [
        1930.0,
        1750.5,
        123.0
      ],
      [
        1930.0001220703125,
        1731.0001220703125,
        123.0
      ],
      [
        1930.0,
        1750.5,
        123.0
      ],
      [
        1958.993408203125,
        1756.268310546875,
        132.0
      ],
      [
        1949.2164306640625,
        1793.0,
        124.0
      ],
      [
        1948.6839599609375,
        1794.9998779296875,
        130.0
      ],
      [
        1948.6839599609375,
        1794.9998779296875,
        130.0
      ],
      [
        1949.2164306640625,
        1793.0,
        124.0
      ],
      [
        1949.2164306640625,
        1793.0,
        124.0
      ],
      [
        1948.8287353515625,
        1726.0,
        130.0
      ],
      [
        1949.3681640625,
        1728.0001220703125,
        124.0
      ],
      [
        1948.8287353515625,
        1726.0,
        130.0
      ],
      [
        1949.3681640625,
        1728.0001220703125,
        124.0
      ],
      [
        1930.0,
        1775.5,
        123.0
      ],
      [
        1899.999755859375,
        1773.9022216796875,
        125.39684295654297
      ],
      [
        1930.0,
        1744.5003662109375,
        123.0
      ],
      [
        1899.999755859375,
        1746.0980224609375,
        125.3968505859375
      ],
      [
        2000.0,
        1756.4769287109375,
        135.0
      ],
      [
        2000.0,
        1756.4769287109375,
        120.0
      ],
      [
        1998.5230712890625,
        1755.0,
        135.0
      ],
      [
        1998.5230712890625,
        1755.0,
        120.0
      ],
      [
        1848.5355224609375,
        1751.4644775390625,
        133.44677734375
      ],
      [
        1849.82958984375,
        1756.2940673828125,
        131.50558471679688
      ],
      [
        1849.82958984375,
        1763.7059326171875,
        131.50558471679688
      ],
      [
        1848.5355224609375,
        1768.5355224609375,
        133.44677734375
      ],
      [
        1849.82958984375,
        1756.2940673828125,
        131.50558471679688
      ],
      [
        1847.5,
        1758.6236572265625,
        135.0
      ],
      [
        1847.5,
        1751.18701171875,
        135.0
      ],
      [
        1848.5355224609375,
        1751.4644775390625,
        133.44677734375
      ],
      [
        1847.5,
        1761.3763427734375,
        135.0
      ],
      [
        1849.82958984375,
        1763.7059326171875,
        131.50558471679688
      ],
      [
        1848.5355224609375,
        1768.5355224609375,
        133.44677734375
      ],
      [
        1847.5,
        1768.81298828125,
        135.0
      ],
      [
        1818.0,
        1825.0,
        125.34430694580078
      ],
      [
        1808.8963623046875,
        1824.9998779296875,
        135.0
      ],
      [
        1818.0001220703125,
        1830.0001220703125,
        130.6474151611328
      ],
      [
        1818.0,
        1825.0,
        125.34430694580078
      ],
      [
        1822.499755859375,
        1840.0,
        135.0
      ],
      [
        1820.0,
        1830.0,
        128.5260009765625
      ],
      [
        1818.0001220703125,
        1830.0001220703125,
        130.6474151611328
      ],
      [
        1828.0384521484375,
        1830.0,
        120.0
      ],
      [
        1820.96728515625,
        1830.0,
        127.5
      ],
      [
        1820.96728515625,
        1830.0,
        127.5
      ],
      [
        1820.0,
        1830.0,
        128.52598571777344
      ],
      [
        1818.0,
        1825.0,
        129.6557159423828
      ],
      [
        1815.967529296875,
        1825.0,
        127.5000228881836
      ],
      [
        1824.7940673828125,
        1830.0,
        131.5587921142578
      ],
      [
        1822.499755859375,
        1830.0,
        135.0
      ],
      [
        1818.0,
        1825.0,
        129.6557159423828
      ],
      [
        1818.0,
        1827.0325927734375,
        127.5000228881836
      ],
      [
        1828.5,
        1744.6927490234375,
        126.0
      ],
      [
        1828.5,
        1775.3072509765625,
        126.0
      ],
      [
        1784.4521484375,
        1727.929443359375,
        126.0
      ],
      [
        1780.0,
        1744.5450439453125,
        126.0
      ],
      [
        1780.0,
        1749.8809814453125,
        123.92837524414062
      ],
      [
        1780.0,
        1752.4998779296875,
        120.0
      ],
      [
        1780.0,
        1749.8809814453125,
        123.92837524414062
      ],
      [
        1780.0,
        1770.118896484375,
        123.9283676147461
      ],
      [
        1780.0,
        1775.4552001953125,
        126.0
      ],
      [
        1784.4520263671875,
        1792.0704345703125,
        126.0
      ],
      [
        1780.0,
        1770.118896484375,
        123.9283676147461
      ],
      [
        1780.0,
        1767.5,
        120.0
      ],
      [
        1828.5,
        1744.6927490234375,
        126.0
      ],
      [
        1829.329345703125,
        1741.5177001953125,
        124.75595092773438
      ],
      [
        1829.3292236328125,
        1778.4822998046875,
        124.75595092773438
      ],
      [
        1828.5,
        1775.3072509765625,
        126.0
      ],
      [
        1832.499755859375,
        1738.2442626953125,
        120.0
      ],
      [
        1830.4998779296875,
        1738.7801513671875,
        123.0
      ],
      [
        1832.4996337890625,
        1781.755615234375,
        120.0
      ],
      [
        1830.499755859375,
        1781.2197265625,
        123.0
      ],
      [
        1830.4998779296875,
        1738.7801513671875,
        123.0
      ],
      [
        1829.329345703125,
        1741.5177001953125,
        124.75595092773438
      ],
      [
        1830.499755859375,
        1781.2197265625,
        123.0
      ],
      [
        1829.3292236328125,
        1778.4822998046875,
        124.75595092773438
      ],
      [
        1780.0,
        1779.3189697265625,
        127.5
      ],
      [
        1780.0,
        1770.118896484375,
        131.07164001464844
      ],
      [
        1780.0,
        1767.5,
        135.0
      ],
      [
        1780.0,
        1770.118896484375,
        131.07164001464844
      ],
      [
        1780.0,
        1749.8809814453125,
        131.07162475585938
      ],
      [
        1780.0,
        1740.681396484375,
        127.5
      ],
      [
        1780.0,
        1749.8809814453125,
        131.07162475585938
      ],
      [
        1780.0,
        1752.4998779296875,
        135.0
      ],
      [
        1822.4998779296875,
        1704.6890869140625,
        135.0
      ],
      [
        1822.499755859375,
        1815.310791015625,
        135.0
      ],
      [
        1780.0,
        1740.681396484375,
        127.5
      ],
      [
        1780.0,
        1779.3189697265625,
        127.5
      ],
      [
        1721.0067138671875,
        1756.268310546875,
        132.0
      ],
      [
        1721.0067138671875,
        1756.268310546875,
        123.0
      ],
      [
        1731.3160400390625,
        1795.0,
        130.0
      ],
      [
        1730.78369140625,
        1793.0,
        124.0
      ],
      [
        1731.3160400390625,
        1795.0,
        130.0
      ],
      [
        1730.78369140625,
        1793.0,
        124.0
      ],
      [
        1750.0,
        1777.4998779296875,
        120.0
      ],
      [
        1780.0,
        1773.90185546875,
        125.39698791503906
      ],
      [
        1730.6318359375,
        1728.0,
        124.0
      ],
      [
        1731.1715087890625,
        1725.9998779296875,
        130.0
      ],
      [
        1731.1715087890625,
        1725.9998779296875,
        130.0
      ],
      [
        1730.6318359375,
        1728.0,
        124.0
      ],
      [
        1730.6318359375,
        1728.0,
        124.0
      ],
      [
        1750.0001220703125,
        1742.500244140625,
        135.0
      ],
      [
        1780.0,
        1746.097900390625,
        129.6029052734375
      ],
      [
        1682.7354736328125,
        1620.0,
        120.0
      ],
      [
        1682.736572265625,
        1620.0,
        135.0
      ],
      [
        1680.6767578125,
        1765.0,
        120.0
      ],
      [
        1680.6767578125,
        1765.0,
        135.0
      ],
      [
        1680.0,
        1764.3232421875,
        120.0
      ],
      [
        1680.0,
        1764.3232421875,
        135.0
      ],
      [
        1830.17041015625,
        1756.2940673828125,
        131.50558471679688
      ],
      [
        1831.4644775390625,
        1751.4644775390625,
        133.44677734375
      ],
      [
        1831.4644775390625,
        1768.5355224609375,
        133.44677734375
      ],
      [
        1830.17041015625,
        1763.7059326171875,
        131.50558471679688
      ],
      [
        1832.5,
        1758.6236572265625,
        135.0
      ],
      [
        1830.17041015625,
        1756.2940673828125,
        131.50558471679688
      ],
      [
        1831.4644775390625,
        1751.4644775390625,
        133.44677734375
      ],
      [
        1832.4998779296875,
        1751.18701171875,
        135.0
      ],
      [
        1830.17041015625,
        1763.7059326171875,
        131.50558471679688
      ],
      [
        1832.5,
        1761.3763427734375,
        135.0
      ],
      [
        1832.4998779296875,
        1768.81298828125,
        135.0
      ],
      [
        1831.4644775390625,
        1768.5355224609375,
        133.44677734375
      ],
      [
        1839.0,
        1783.4974365234375,
        120.0
      ],
      [
        1839.0,
        1783.4974365234375,
        123.0
      ],
      [
        1841.0,
        1736.5025634765625,
        120.0
      ],
      [
        1841.0,
        1736.5025634765625,
        123.0
      ],
      [
        1839.0,
        1736.5025634765625,
        120.0
      ],
      [
        1839.0,
        1736.5025634765625,
        123.0
      ],
      [
        1841.0,
        1783.4974365234375,
        120.0
      ],
      [
        1841.0,
        1783.4974365234375,
        123.0
      ],
      [
        1842.1966552734375,
        1761.268310546875,
        126.0
      ],
      [
        1842.1966552734375,
        1761.268310546875,
        135.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1655.0,
      "bbox_min": [
        1580.0,
        810.0,
        98.0
      ],
      "bbox_max": [
        2025.0001220703125,
        2077.5,
        385.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1650.0,
      "bbox_min": [
        1580.0,
        810.0,
        98.0
      ],
      "bbox_max": [
        1655.0,
        1450.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1580.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1650.0,
        1450.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1600.0,
        840.0,
        100.0
      ],
      "bbox_max": [
        1650.0,
        1150.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1630.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1650.0,
        1150.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -805.9794921875,
      "bbox_min": [
        1630.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1633.0,
        1150.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1630.0,
        1150.0,
        118.0
      ],
      "bbox_max": [
        1633.0,
        1150.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1600.0,
        810.0,
        120.0
      ],
      "bbox_max": [
        1650.0,
        810.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -805.9794921875,
      "bbox_min": [
        1630.0,
        1050.0,
        120.0
      ],
      "bbox_max": [
        1650.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1630.0,
        1050.0,
        120.0
      ],
      "bbox_max": [
        1650.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        1630.0,
        1050.0,
        138.0
      ],
      "bbox_max": [
        1650.0,
        1050.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1220.0,
      "bbox_min": [
        1630.0,
        1220.0,
        138.0
      ],
      "bbox_max": [
        1650.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1650.0,
        810.0,
        98.0
      ],
      "bbox_max": [
        1655.0,
        1450.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1650.0,
        810.0,
        120.0
      ],
      "bbox_max": [
        1655.0,
        810.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1650.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1655.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547002553939819,
        -0.8320503234863281
      ],
      "plane_d": -450.9713134765625,
      "bbox_min": [
        1650.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1655.0,
        1000.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        1650.0,
        940.0,
        118.0
      ],
      "bbox_max": [
        1655.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1650.0,
        1000.0,
        118.0
      ],
      "bbox_max": [
        1655.0,
        1000.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -805.9794921875,
      "bbox_min": [
        1650.0,
        1050.0,
        131.33334350585938
      ],
      "bbox_max": [
        1655.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1650.0,
        1050.0,
        131.33334350585938
      ],
      "bbox_max": [
        1655.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        1650.0,
        1050.0,
        138.0
      ],
      "bbox_max": [
        1655.0,
        1050.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1220.0,
      "bbox_min": [
        1650.0,
        1220.0,
        138.0
      ],
      "bbox_max": [
        1655.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -5.954652806394733e-07,
        0.0
      ],
      "plane_d": 2025.0010986328125,
      "bbox_min": [
        1655.0,
        810.0,
        98.0
      ],
      "bbox_max": [
        2025.0001220703125,
        2077.5,
        385.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        -3.299196578154806e-07,
        1.0,
        0.0
      ],
      "plane_d": -1554.99951171875,
      "bbox_min": [
        1655.0,
        810.0,
        98.0
      ],
      "bbox_max": [
        2025.0001220703125,
        2077.5,
        385.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1655.0,
        810.0,
        98.0
      ],
      "bbox_max": [
        1852.5,
        1555.0001220703125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        6.103553459979594e-06,
        0.0
      ],
      "plane_d": -1750.009521484375,
      "bbox_min": [
        1680.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1852.5,
        1555.0001220703125,
        385.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1680.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1750.0037841796875,
        1554.9998779296875,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1680.0,
        810.0,
        120.0
      ],
      "bbox_max": [
        1750.0,
        810.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1680.0,
        940.0,
        118.0
      ],
      "bbox_max": [
        1750.0037841796875,
        1554.9998779296875,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        1680.0,
        940.0,
        118.0
      ],
      "bbox_max": [
        1750.0037841796875,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1680.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1750.0009765625,
        1554.9998779296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1680.0,
        1442.5,
        135.0
      ],
      "bbox_max": [
        1695.0001220703125,
        1554.9998779296875,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1768.0,
      "bbox_min": [
        1750.0,
        940.0,
        118.0
      ],
      "bbox_max": [
        1852.5,
        1555.0001220703125,
        385.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1768.0,
        940.0,
        118.0
      ],
      "bbox_max": [
        1852.5,
        1555.0001220703125,
        185.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        1768.0,
        940.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        1768.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1852.5,
        1555.0001220703125,
        185.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.32583823800086975,
        0.7866415977478027,
        -0.5244277119636536
      ],
      "plane_d": -527.9386596679688,
      "bbox_min": [
        1768.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1852.5,
        1555.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1768.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32583779096603394,
        0.7866417765617371,
        0.5244278907775879
      ],
      "plane_d": -661.6688842773438,
      "bbox_min": [
        1819.9998779296875,
        1510.0,
        120.0
      ],
      "bbox_max": [
        1852.5,
        1555.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7866414189338684,
        0.32583993673324585,
        -0.5244269967079163
      ],
      "plane_d": 1021.5097045898438,
      "bbox_min": [
        1819.9998779296875,
        1515.0,
        120.0
      ],
      "bbox_max": [
        1852.5,
        1555.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7866423726081848,
        0.3258380591869354,
        0.5244265794754028
      ],
      "plane_d": 887.7854614257812,
      "bbox_min": [
        1819.9998779296875,
        1515.0,
        120.0
      ],
      "bbox_max": [
        1852.5,
        1555.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1819.9998779296875,
        1515.0,
        120.0
      ],
      "bbox_max": [
        1852.5,
        1555.0001220703125,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        -6.524487616843544e-07,
        -0.5547002553939819
      ],
      "plane_d": 1612.0985107421875,
      "bbox_min": [
        1819.9998779296875,
        1521.5,
        120.0
      ],
      "bbox_max": [
        1852.5,
        1555.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547002553939819
      ],
      "plane_d": 1470.64892578125,
      "bbox_min": [
        1819.9998779296875,
        1521.5,
        120.0
      ],
      "bbox_max": [
        1852.5,
        1555.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        1819.9998779296875,
        1521.5,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1555.0001220703125,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3826851546764374,
        0.9238787889480591,
        0.0
      ],
      "plane_d": -711.042236328125,
      "bbox_min": [
        1819.9998779296875,
        1523.4998779296875,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1555.0001220703125,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238806366920471,
        0.3826810121536255,
        0.0
      ],
      "plane_d": 1108.73095703125,
      "bbox_min": [
        1830.5,
        1529.06494140625,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1555.0001220703125,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1841.0,
      "bbox_min": [
        1841.0,
        1542.5,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1547.3287353515625,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320565223693848,
        6.524541618091462e-07,
        0.5546908378601074
      ],
      "plane_d": -1591.307373046875,
      "bbox_min": [
        1830.5,
        1542.5,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1555.0001220703125,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1841.0,
      "bbox_min": [
        1841.0,
        1547.3287353515625,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1555.0001220703125,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320565223693848,
        6.367607738866354e-07,
        -0.5546908378601074
      ],
      "plane_d": -1449.861328125,
      "bbox_min": [
        1827.5001220703125,
        1542.5,
        123.0
      ],
      "bbox_max": [
        1832.5,
        1555.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320565223693848,
        6.524541618091462e-07,
        0.5546908378601074
      ],
      "plane_d": -1591.307373046875,
      "bbox_min": [
        1827.5001220703125,
        1542.5,
        123.0
      ],
      "bbox_max": [
        1830.5,
        1555.0001220703125,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 185.0,
      "bbox_min": [
        1768.0,
        1530.0,
        170.0
      ],
      "bbox_max": [
        1845.251220703125,
        1555.0001220703125,
        185.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        0.5547002553939819
      ],
      "plane_d": -1371.496337890625,
      "bbox_min": [
        1768.0,
        1530.0,
        170.0
      ],
      "bbox_max": [
        1845.251220703125,
        1555.0001220703125,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.539208253438119e-06,
        0.8320503234863281,
        -0.5547002553939819
      ],
      "plane_d": -1174.572998046875,
      "bbox_min": [
        1768.0,
        1530.0,
        170.0
      ],
      "bbox_max": [
        1845.251220703125,
        1555.0001220703125,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320565223693848,
        -0.5546908378601074
      ],
      "plane_d": 1392.3055419921875,
      "bbox_min": [
        1768.0,
        1530.0,
        170.0
      ],
      "bbox_max": [
        1845.251220703125,
        1555.0001220703125,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3258320391178131,
        -0.786646842956543,
        -0.5244237184524536
      ],
      "plane_d": 726.5650634765625,
      "bbox_min": [
        1810.0,
        1550.0001220703125,
        177.5
      ],
      "bbox_max": [
        1845.251220703125,
        1555.0001220703125,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32583320140838623,
        -0.7866465449333191,
        0.5244235396385193
      ],
      "plane_d": 540.3921508789062,
      "bbox_min": [
        1810.0,
        1550.0001220703125,
        170.0
      ],
      "bbox_max": [
        1845.251220703125,
        1555.0001220703125,
        177.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.325836718082428,
        0.7866420149803162,
        0.5244280695915222
      ],
      "plane_d": -706.8837890625,
      "bbox_min": [
        1768.0,
        1530.0,
        170.0
      ],
      "bbox_max": [
        1845.251220703125,
        1555.0001220703125,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7866402268409729,
        0.32584214210510254,
        -0.5244274735450745
      ],
      "plane_d": 1037.9500732421875,
      "bbox_min": [
        1768.0,
        1530.0,
        170.0
      ],
      "bbox_max": [
        1845.251220703125,
        1555.0001220703125,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7866410613059998,
        0.325840562582016,
        0.5244271755218506
      ],
      "plane_d": 851.782470703125,
      "bbox_min": [
        1768.0,
        1530.0,
        170.0
      ],
      "bbox_max": [
        1845.251220703125,
        1555.0001220703125,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -8.137954864650965e-06,
        -3.3908476325450465e-05
      ],
      "plane_d": -1769.981201171875,
      "bbox_min": [
        1768.0,
        1530.0,
        170.0
      ],
      "bbox_max": [
        1770.0,
        1555.0,
        185.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        6.103888154029846e-05,
        1.0,
        0.0
      ],
      "plane_d": -1537.6080322265625,
      "bbox_min": [
        1768.0,
        1537.5,
        170.0
      ],
      "bbox_max": [
        1770.0,
        1547.5,
        182.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1547.5,
      "bbox_min": [
        1768.0,
        1537.5,
        170.0
      ],
      "bbox_max": [
        1770.0,
        1547.5,
        182.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 182.0,
      "bbox_min": [
        1768.0,
        1537.5,
        182.0
      ],
      "bbox_max": [
        1770.0,
        1547.5,
        182.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.781730462535052e-06,
        1.0,
        0.0
      ],
      "plane_d": -1532.511962890625,
      "bbox_min": [
        1750.0,
        940.0,
        118.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1552.5,
        385.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1750.0006103515625,
        940.0,
        118.0
      ],
      "bbox_max": [
        1768.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        1750.0037841796875,
        940.0,
        118.0
      ],
      "bbox_max": [
        1768.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1750.0009765625,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1768.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1552.5,
      "bbox_min": [
        1750.0,
        1532.5,
        170.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1552.5,
        385.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 385.0,
      "bbox_min": [
        1750.0,
        1532.5,
        170.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1552.5,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        1750.0,
        1532.5,
        170.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1552.5,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1655.0,
        810.0,
        98.0
      ],
      "bbox_max": [
        1680.0,
        1555.0,
        220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1655.0,
        810.0,
        138.0
      ],
      "bbox_max": [
        1680.0,
        1220.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1655.0,
        810.0,
        138.0
      ],
      "bbox_max": [
        1680.0,
        810.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -888.89306640625,
      "bbox_min": [
        1655.0,
        880.0,
        138.0
      ],
      "bbox_max": [
        1671.75,
        1220.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        1655.0,
        1050.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1220.0,
      "bbox_min": [
        1655.0,
        1150.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1657.0,
        1150.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1655.0,
        810.0,
        98.0
      ],
      "bbox_max": [
        1680.0,
        1555.0,
        138.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1655.0,
        840.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        1655.0,
        880.0,
        105.0
      ],
      "bbox_max": [
        1680.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": -828.2591552734375,
      "bbox_min": [
        1666.25,
        880.0,
        105.0
      ],
      "bbox_max": [
        1673.75,
        883.75,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1655.0,
        1000.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        1000.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1655.0,
        810.0,
        120.0
      ],
      "bbox_max": [
        1680.0,
        1555.0,
        138.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1655.0,
        810.0,
        135.0
      ],
      "bbox_max": [
        1680.0,
        1150.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -805.9794921875,
      "bbox_min": [
        1655.0,
        881.75,
        135.0
      ],
      "bbox_max": [
        1672.5,
        1150.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1655.0,
        1150.0,
        135.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -888.89306640625,
      "bbox_min": [
        1667.5,
        881.75,
        135.0
      ],
      "bbox_max": [
        1672.5,
        882.5,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1655.0,
        810.0,
        120.0
      ],
      "bbox_max": [
        1680.0,
        1150.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -888.89306640625,
      "bbox_min": [
        1655.0,
        882.5,
        120.0
      ],
      "bbox_max": [
        1675.0,
        1150.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": -828.2591552734375,
      "bbox_min": [
        1665.0,
        883.75,
        120.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -805.9794921875,
      "bbox_min": [
        1655.0,
        1140.0,
        134.6666717529297
      ],
      "bbox_max": [
        1655.5,
        1150.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1655.0,
        1150.0,
        134.6666717529297
      ],
      "bbox_max": [
        1655.5,
        1150.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.2991988518915605e-07,
        -1.0,
        0.0
      ],
      "plane_d": 1965.00048828125,
      "bbox_min": [
        1655.0,
        1555.0,
        119.99995422363281
      ],
      "bbox_max": [
        2025.0001220703125,
        2077.5,
        201.0
      ],
      "face_count": 15
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1827.5,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        2025.0,
        2077.5,
        135.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1827.5,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        2025.0,
        2077.5,
        135.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.32583823800086975,
        -0.7866415977478027,
        -0.5244277119636536
      ],
      "plane_d": 1041.955078125,
      "bbox_min": [
        1827.5,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1860.0,
        2010.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32583779096603394,
        -0.7866417765617371,
        0.5244278907775879
      ],
      "plane_d": 908.2271728515625,
      "bbox_min": [
        1827.5,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1860.0,
        2010.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7866421937942505,
        -0.32583850622177124,
        -0.5244266986846924
      ],
      "plane_d": -726.3786010742188,
      "bbox_min": [
        1827.5,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1860.0,
        2000.48095703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7866423726081848,
        -0.3258380591869354,
        0.5244265794754028
      ],
      "plane_d": -860.1085815429688,
      "bbox_min": [
        1827.5,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1860.0,
        2000.48095703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320565223693848,
        7.3868721983672e-07,
        -0.5546908378601074
      ],
      "plane_d": -1449.861572265625,
      "bbox_min": [
        1827.5,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1860.0,
        1998.5,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320565223693848,
        -0.0,
        0.5546908378601074
      ],
      "plane_d": -1591.306396484375,
      "bbox_min": [
        1827.5,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1860.0,
        1998.5,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        1839.0,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1860.0,
        1998.5,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3826810121536255,
        -0.9238806366920471,
        0.0
      ],
      "plane_d": 1132.740966796875,
      "bbox_min": [
        1839.0,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1860.0,
        1996.5,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238818287849426,
        -0.38267800211906433,
        0.0
      ],
      "plane_d": -944.1207885742188,
      "bbox_min": [
        1839.0,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1849.4998779296875,
        1990.93505859375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1839.0,
      "bbox_min": [
        1839.0,
        1972.6712646484375,
        120.0
      ],
      "bbox_max": [
        1839.0,
        1977.5,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320440649986267,
        0.0,
        0.5547096133232117
      ],
      "plane_d": 1470.6361083984375,
      "bbox_min": [
        1839.0,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1849.4998779296875,
        1977.4998779296875,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1839.0,
      "bbox_min": [
        1839.0,
        1964.9998779296875,
        120.0
      ],
      "bbox_max": [
        1839.0,
        1972.6712646484375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320440649986267,
        -6.367512241922668e-07,
        -0.5547096133232117
      ],
      "plane_d": 1612.0882568359375,
      "bbox_min": [
        1847.4998779296875,
        1964.9998779296875,
        123.0
      ],
      "bbox_max": [
        1852.5,
        1977.5,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        1655.0,
        1555.0,
        119.99995422363281
      ],
      "bbox_max": [
        2025.0001220703125,
        1965.0001220703125,
        201.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1900.0,
      "bbox_min": [
        1760.0,
        1955.0,
        190.0
      ],
      "bbox_max": [
        1920.0,
        1965.0001220703125,
        201.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1955.5,
      "bbox_min": [
        1760.0,
        1955.5,
        190.0
      ],
      "bbox_max": [
        1780.0001220703125,
        1965.0001220703125,
        201.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1780.0001220703125,
      "bbox_min": [
        1760.0,
        1955.5,
        190.0
      ],
      "bbox_max": [
        1780.0001220703125,
        1965.0001220703125,
        201.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -191.0,
      "bbox_min": [
        1760.0,
        1955.5,
        190.0
      ],
      "bbox_max": [
        1780.0001220703125,
        1965.0001220703125,
        201.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1760.0,
        1955.5,
        190.0
      ],
      "bbox_max": [
        1760.0,
        1965.0001220703125,
        191.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 201.0,
      "bbox_min": [
        1760.0,
        1955.5,
        191.0
      ],
      "bbox_max": [
        1780.0001220703125,
        1965.0001220703125,
        201.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1760.0,
        1955.5,
        191.0
      ],
      "bbox_max": [
        1760.0,
        1965.0001220703125,
        201.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1955.0,
      "bbox_min": [
        1900.0,
        1955.0,
        190.0
      ],
      "bbox_max": [
        1920.0,
        1965.0,
        201.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -191.0,
      "bbox_min": [
        1900.0,
        1955.0,
        190.0
      ],
      "bbox_max": [
        1920.0,
        1965.0,
        201.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1910.0,
        1955.0,
        190.0
      ],
      "bbox_max": [
        1910.0,
        1965.0,
        191.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 201.0,
      "bbox_min": [
        1900.0,
        1955.0,
        191.0
      ],
      "bbox_max": [
        1920.0,
        1965.0,
        201.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1920.0,
      "bbox_min": [
        1920.0,
        1955.0,
        191.0
      ],
      "bbox_max": [
        1920.0,
        1965.0,
        201.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1655.0,
        1555.0,
        119.99995422363281
      ],
      "bbox_max": [
        2025.0001220703125,
        1965.0001220703125,
        190.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        1.0,
        -3.051748535654042e-06,
        0.0
      ],
      "plane_d": -1999.9951171875,
      "bbox_min": [
        1655.0,
        1569.9998779296875,
        140.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1950.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -3.051757857974735e-06,
        0.0
      ],
      "plane_d": 1680.0059814453125,
      "bbox_min": [
        1655.0,
        1570.0,
        140.0
      ],
      "bbox_max": [
        1874.1180419921875,
        1950.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -1.220688227476785e-05,
        0.0
      ],
      "plane_d": -1802.9776611328125,
      "bbox_min": [
        1802.9998779296875,
        1725.8819580078125,
        140.0
      ],
      "bbox_max": [
        1874.1180419921875,
        1845.0001220703125,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659252166748047,
        -0.25882142782211304,
        0.0
      ],
      "plane_d": -1288.8211669921875,
      "bbox_min": [
        1802.9998779296875,
        1725.8819580078125,
        140.0
      ],
      "bbox_max": [
        1874.1180419921875,
        1845.0001220703125,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.137954864650965e-06,
        1.0,
        0.0
      ],
      "plane_d": -1824.9852294921875,
      "bbox_min": [
        1802.9998779296875,
        1824.9998779296875,
        140.0
      ],
      "bbox_max": [
        1818.0001220703125,
        1845.0001220703125,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.138087650877424e-06,
        -1.0,
        -0.0
      ],
      "plane_d": 1845.0147705078125,
      "bbox_min": [
        1803.0001220703125,
        1825.0,
        140.0
      ],
      "bbox_max": [
        1818.0001220703125,
        1845.0001220703125,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -1.2207180589030031e-05,
        -0.0
      ],
      "plane_d": 1818.0224609375,
      "bbox_min": [
        1818.0,
        1825.0,
        140.0
      ],
      "bbox_max": [
        1818.0001220703125,
        1845.0,
        145.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.25882142782211304,
        0.9659252166748047,
        0.0
      ],
      "plane_d": -1190.8414306640625,
      "bbox_min": [
        1805.8819580078125,
        1725.8819580078125,
        140.0
      ],
      "bbox_max": [
        1874.1180419921875,
        1794.1180419921875,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659265279769897,
        -0.2588167190551758,
        -0.0
      ],
      "plane_d": 2265.77783203125,
      "bbox_min": [
        1805.8819580078125,
        1725.8819580078125,
        140.0
      ],
      "bbox_max": [
        1874.1180419921875,
        1794.1180419921875,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659265279769897,
        0.2588167190551758,
        0.0
      ],
      "plane_d": 1354.742919921875,
      "bbox_min": [
        1805.8819580078125,
        1725.8819580078125,
        140.0
      ],
      "bbox_max": [
        1874.1180419921875,
        1794.1180419921875,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588167190551758,
        0.9659265279769897,
        0.0
      ],
      "plane_d": -2143.2978515625,
      "bbox_min": [
        1805.8819580078125,
        1725.8819580078125,
        140.0
      ],
      "bbox_max": [
        1869.547119140625,
        1794.1180419921875,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659265279769897,
        0.2588167190551758,
        0.0
      ],
      "plane_d": -2199.86669921875,
      "bbox_min": [
        1805.8819580078125,
        1730.452880859375,
        140.0
      ],
      "bbox_max": [
        1869.547119140625,
        1794.1180419921875,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588167190551758,
        -0.9659265279769897,
        0.0
      ],
      "plane_d": 1256.763427734375,
      "bbox_min": [
        1810.452880859375,
        1730.452880859375,
        140.0
      ],
      "bbox_max": [
        1869.547119140625,
        1794.1180419921875,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588167190551758,
        -0.9659265279769897,
        -0.0
      ],
      "plane_d": 2209.208984375,
      "bbox_min": [
        1810.452880859375,
        1730.452880859375,
        140.0
      ],
      "bbox_max": [
        1869.547119140625,
        1794.1180419921875,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2512.62890625,
      "bbox_min": [
        1810.452880859375,
        1730.452880859375,
        140.0
      ],
      "bbox_max": [
        1869.547119140625,
        1789.547119140625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2578.5400390625,
      "bbox_min": [
        1810.4530029296875,
        1730.4530029296875,
        140.0
      ],
      "bbox_max": [
        1869.547119140625,
        1789.547119140625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 89.5240478515625,
      "bbox_min": [
        1810.4530029296875,
        1730.4530029296875,
        140.0
      ],
      "bbox_max": [
        1869.547119140625,
        1789.547119140625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -23.613037109375,
      "bbox_min": [
        1810.4530029296875,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1789.547119140625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": 2222.3671875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2165.79833984375,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1332.2431640625,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1213.35595703125,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1311.33544921875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1234.263671875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        -0.0
      ],
      "plane_d": -2243.27490234375,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2186.705810546875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        -0.0
      ],
      "plane_d": -2231.02734375,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2174.458740234375,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1763.7059326171875,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.898681640625,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        140.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1759.8297119140625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1830.17041015625,
        1756.2940673828125,
        140.0
      ],
      "bbox_max": [
        1833.7060546875,
        1759.8297119140625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2541.25439453125,
      "bbox_min": [
        1830.17041015625,
        1760.17041015625,
        140.0
      ],
      "bbox_max": [
        1837.80322265625,
        1763.7059326171875,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1225.603515625,
      "bbox_min": [
        1833.7059326171875,
        1760.17041015625,
        140.0
      ],
      "bbox_max": [
        1837.80322265625,
        1761.268310546875,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1840.17041015625,
        1753.7059326171875,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1759.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1323.5828857421875,
      "bbox_min": [
        1840.17041015625,
        1753.7059326171875,
        140.0
      ],
      "bbox_max": [
        1841.4644775390625,
        1758.5355224609375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": 2234.614501953125,
      "bbox_min": [
        1836.2940673828125,
        1760.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1840.17041015625,
        1760.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.8985595703125,
      "bbox_min": [
        1841.4644775390625,
        1760.17041015625,
        140.0
      ],
      "bbox_max": [
        1849.82958984375,
        1763.7059326171875,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2178.045654296875,
      "bbox_min": [
        1841.4644775390625,
        1760.17041015625,
        140.0
      ],
      "bbox_max": [
        1846.2940673828125,
        1761.4644775390625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1836.2940673828125,
        1761.268310546875,
        140.0
      ],
      "bbox_max": [
        1839.82958984375,
        1769.82958984375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1319.99560546875,
      "bbox_min": [
        1837.80322265625,
        1761.268310546875,
        140.0
      ],
      "bbox_max": [
        1839.82958984375,
        1766.2940673828125,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1910.0,
      "bbox_min": [
        1655.0,
        1570.0,
        140.0
      ],
      "bbox_max": [
        1680.0001220703125,
        1950.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5299989581108093,
        -0.8479983806610107
      ],
      "plane_d": -713.3786010742188,
      "bbox_min": [
        1655.0,
        1570.0,
        140.0
      ],
      "bbox_max": [
        1665.0,
        1578.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1665.0,
      "bbox_min": [
        1665.0,
        1570.0,
        140.0
      ],
      "bbox_max": [
        1665.0,
        1578.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5299989581108093,
        0.8479983806610107
      ],
      "plane_d": -1135.2578125,
      "bbox_min": [
        1655.0,
        1910.0,
        140.0
      ],
      "bbox_max": [
        1665.0,
        1950.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5300001502037048,
        -0.8479976654052734
      ],
      "plane_d": 1152.219970703125,
      "bbox_min": [
        1655.0,
        1941.9998779296875,
        140.0
      ],
      "bbox_max": [
        1664.9998779296875,
        1950.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        3.0517671802954283e-06,
        0.0
      ],
      "plane_d": -1665.005859375,
      "bbox_min": [
        1664.9998779296875,
        1941.9998779296875,
        140.0
      ],
      "bbox_max": [
        1664.9998779296875,
        1949.9998779296875,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.138087650877424e-06,
        -1.0,
        -0.0
      ],
      "plane_d": 1610.0162353515625,
      "bbox_min": [
        2000.0,
        1570.0,
        140.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1950.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5299978256225586,
        -0.847999095916748
      ],
      "plane_d": 1152.215576171875,
      "bbox_min": [
        2015.0,
        1942.0,
        140.0
      ],
      "bbox_max": [
        2025.0,
        1950.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 2015.0,
      "bbox_min": [
        2015.0,
        1942.0,
        140.0
      ],
      "bbox_max": [
        2015.0,
        1950.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2939141015522182e-05,
        0.5300001502037048,
        -0.8479976654052734
      ],
      "plane_d": -713.3544921875,
      "bbox_min": [
        2015.0,
        1570.0,
        140.0
      ],
      "bbox_max": [
        2025.0,
        1578.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -3.0517671802954283e-06,
        -0.0
      ],
      "plane_d": 2015.0047607421875,
      "bbox_min": [
        2015.0,
        1570.0,
        140.0
      ],
      "bbox_max": [
        2015.0,
        1578.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 165.0,
      "bbox_min": [
        1655.0,
        1555.0,
        145.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1965.0001220703125,
        190.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1655.0,
        1555.0,
        165.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1965.0,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        1802.9998779296875,
        1555.0,
        165.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1965.0,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -1.220688227476785e-05,
        0.0
      ],
      "plane_d": -1802.9776611328125,
      "bbox_min": [
        1802.9998779296875,
        1725.8819580078125,
        165.0
      ],
      "bbox_max": [
        1874.1180419921875,
        1845.0001220703125,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659252166748047,
        -0.25882142782211304,
        0.0
      ],
      "plane_d": -1288.8211669921875,
      "bbox_min": [
        1802.9998779296875,
        1725.8819580078125,
        165.0
      ],
      "bbox_max": [
        1874.1180419921875,
        1845.0001220703125,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.137954864650965e-06,
        1.0,
        0.0
      ],
      "plane_d": -1824.9852294921875,
      "bbox_min": [
        1802.9998779296875,
        1824.9998779296875,
        165.0
      ],
      "bbox_max": [
        1818.0001220703125,
        1845.0001220703125,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.138087650877424e-06,
        -1.0,
        -0.0
      ],
      "plane_d": 1845.0147705078125,
      "bbox_min": [
        1803.0001220703125,
        1825.0,
        165.0
      ],
      "bbox_max": [
        1818.0001220703125,
        1845.0001220703125,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -1.2207180589030031e-05,
        -0.0
      ],
      "plane_d": 1818.0224609375,
      "bbox_min": [
        1818.0,
        1825.0,
        165.0
      ],
      "bbox_max": [
        1818.0001220703125,
        1845.0,
        170.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.25882142782211304,
        0.9659252166748047,
        0.0
      ],
      "plane_d": -1190.8414306640625,
      "bbox_min": [
        1805.8819580078125,
        1725.8819580078125,
        165.0
      ],
      "bbox_max": [
        1874.1180419921875,
        1794.1180419921875,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659265279769897,
        -0.2588167190551758,
        -0.0
      ],
      "plane_d": 2265.77783203125,
      "bbox_min": [
        1805.8819580078125,
        1725.8819580078125,
        165.0
      ],
      "bbox_max": [
        1874.1180419921875,
        1794.1180419921875,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659265279769897,
        0.2588167190551758,
        0.0
      ],
      "plane_d": 1354.742919921875,
      "bbox_min": [
        1805.8819580078125,
        1725.8819580078125,
        165.0
      ],
      "bbox_max": [
        1874.1180419921875,
        1794.1180419921875,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588167190551758,
        0.9659265279769897,
        0.0
      ],
      "plane_d": -2143.2978515625,
      "bbox_min": [
        1805.8819580078125,
        1725.8819580078125,
        165.0
      ],
      "bbox_max": [
        1869.547119140625,
        1794.1180419921875,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659265279769897,
        0.2588167190551758,
        0.0
      ],
      "plane_d": -2199.86669921875,
      "bbox_min": [
        1805.8819580078125,
        1730.452880859375,
        165.0
      ],
      "bbox_max": [
        1869.547119140625,
        1794.1180419921875,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588167190551758,
        -0.9659265279769897,
        0.0
      ],
      "plane_d": 1256.763427734375,
      "bbox_min": [
        1810.452880859375,
        1730.452880859375,
        165.0
      ],
      "bbox_max": [
        1869.547119140625,
        1794.1180419921875,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588167190551758,
        -0.9659265279769897,
        -0.0
      ],
      "plane_d": 2209.208984375,
      "bbox_min": [
        1810.452880859375,
        1730.452880859375,
        165.0
      ],
      "bbox_max": [
        1869.547119140625,
        1794.1180419921875,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2512.62890625,
      "bbox_min": [
        1810.452880859375,
        1730.452880859375,
        165.0
      ],
      "bbox_max": [
        1869.547119140625,
        1789.547119140625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2578.5400390625,
      "bbox_min": [
        1810.4530029296875,
        1730.4530029296875,
        165.0
      ],
      "bbox_max": [
        1869.547119140625,
        1789.547119140625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 89.5240478515625,
      "bbox_min": [
        1810.4530029296875,
        1730.4530029296875,
        165.0
      ],
      "bbox_max": [
        1869.547119140625,
        1789.547119140625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -23.613037109375,
      "bbox_min": [
        1810.4530029296875,
        1750.17041015625,
        165.0
      ],
      "bbox_max": [
        1849.82958984375,
        1789.547119140625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": 2222.3671875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        165.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2165.79833984375,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        165.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1332.2431640625,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        165.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1213.35595703125,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        165.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1311.33544921875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        165.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1234.263671875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        165.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        -0.0
      ],
      "plane_d": -2243.27490234375,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        165.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2186.705810546875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        165.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        -0.0
      ],
      "plane_d": -2231.02734375,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        165.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2174.458740234375,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        165.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1763.7059326171875,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.898681640625,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        165.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1759.8297119140625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1830.17041015625,
        1756.2940673828125,
        165.0
      ],
      "bbox_max": [
        1833.7060546875,
        1759.8297119140625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2541.25439453125,
      "bbox_min": [
        1830.17041015625,
        1760.17041015625,
        165.0
      ],
      "bbox_max": [
        1837.80322265625,
        1763.7059326171875,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1225.603515625,
      "bbox_min": [
        1833.7059326171875,
        1760.17041015625,
        165.0
      ],
      "bbox_max": [
        1837.80322265625,
        1761.268310546875,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1840.17041015625,
        1753.7059326171875,
        165.0
      ],
      "bbox_max": [
        1849.82958984375,
        1759.82958984375,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1323.5828857421875,
      "bbox_min": [
        1840.17041015625,
        1753.7059326171875,
        165.0
      ],
      "bbox_max": [
        1841.4644775390625,
        1758.5355224609375,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": 2234.614501953125,
      "bbox_min": [
        1836.2940673828125,
        1760.17041015625,
        165.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1840.17041015625,
        1760.17041015625,
        165.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.8985595703125,
      "bbox_min": [
        1841.4644775390625,
        1760.17041015625,
        165.0
      ],
      "bbox_max": [
        1849.82958984375,
        1763.7059326171875,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2178.045654296875,
      "bbox_min": [
        1841.4644775390625,
        1760.17041015625,
        165.0
      ],
      "bbox_max": [
        1846.2940673828125,
        1761.4644775390625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1836.2940673828125,
        1761.268310546875,
        165.0
      ],
      "bbox_max": [
        1839.82958984375,
        1769.82958984375,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1319.99560546875,
      "bbox_min": [
        1837.80322265625,
        1761.268310546875,
        165.0
      ],
      "bbox_max": [
        1839.82958984375,
        1766.2940673828125,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1910.0,
      "bbox_min": [
        2000.0,
        1601.9998779296875,
        165.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1918.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.138087650877424e-06,
        -1.0,
        -0.0
      ],
      "plane_d": 1610.0162353515625,
      "bbox_min": [
        2000.0,
        1601.9998779296875,
        165.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1610.0001220703125,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2939084626850672e-05,
        -0.5299978256225586,
        0.847999095916748
      ],
      "plane_d": 709.1105346679688,
      "bbox_min": [
        2014.9998779296875,
        1601.9998779296875,
        165.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1610.0001220703125,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5299989581108093,
        0.8479983806610107
      ],
      "plane_d": -1156.457763671875,
      "bbox_min": [
        2015.0,
        1909.9998779296875,
        165.0
      ],
      "bbox_max": [
        2024.9998779296875,
        1918.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 2015.0,
      "bbox_min": [
        2015.0,
        1910.0,
        165.0
      ],
      "bbox_max": [
        2015.0,
        1918.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1655.0,
        1602.0,
        165.0
      ],
      "bbox_max": [
        1680.0,
        1610.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5299989581108093,
        0.8479983806610107
      ],
      "plane_d": 709.1386108398438,
      "bbox_min": [
        1655.0,
        1602.0,
        165.0
      ],
      "bbox_max": [
        1665.0,
        1610.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5299989581108093,
        0.8479983806610107
      ],
      "plane_d": -1156.457763671875,
      "bbox_min": [
        1655.0,
        1910.0,
        165.0
      ],
      "bbox_max": [
        1665.0,
        1918.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        3.0517671802954283e-06,
        0.0
      ],
      "plane_d": -1665.005859375,
      "bbox_min": [
        1665.0,
        1910.0,
        165.0
      ],
      "bbox_max": [
        1665.0,
        1918.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.202938051392266e-06,
        0.0
      ],
      "plane_d": -1900.0018310546875,
      "bbox_min": [
        1680.0,
        1555.0,
        170.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1965.0001220703125,
        190.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        1.2124930890422547e-06,
        0.0
      ],
      "plane_d": 1779.9976806640625,
      "bbox_min": [
        1680.0,
        1555.0,
        170.0
      ],
      "bbox_max": [
        1900.0001220703125,
        1965.0001220703125,
        190.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8320440649986267,
        -1.6077774489531294e-06,
        -0.5547096133232117
      ],
      "plane_d": 1639.8251953125,
      "bbox_min": [
        1779.999755859375,
        1555.0,
        170.0
      ],
      "bbox_max": [
        1900.0001220703125,
        1900.0001220703125,
        190.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        2.6828713544091443e-06,
        1.0,
        0.0
      ],
      "plane_d": -1885.0050048828125,
      "bbox_min": [
        1844.1661376953125,
        1698.1728515625,
        170.0
      ],
      "bbox_max": [
        1900.0001220703125,
        1900.0001220703125,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.1386750191450119,
        0.1386750191450119,
        -0.9805806279182434
      ],
      "plane_d": 203.86744689941406,
      "bbox_min": [
        1844.1661376953125,
        1698.1728515625,
        170.0
      ],
      "bbox_max": [
        1900.0,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1894332766532898,
        0.050758346915245056,
        -0.9805808067321777
      ],
      "plane_d": 451.9959716796875,
      "bbox_min": [
        1844.1661376953125,
        1698.1728515625,
        170.0
      ],
      "bbox_max": [
        1900.0,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 185.0,
      "bbox_min": [
        1897.990234375,
        1752.2318115234375,
        184.59791564941406
      ],
      "bbox_max": [
        1900.0,
        1760.0,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.173072855133796e-06,
        0.8320558071136475,
        -0.5546919703483582
      ],
      "plane_d": -1355.5537109375,
      "bbox_min": [
        1897.990234375,
        1752.2318115234375,
        184.59791564941406
      ],
      "bbox_max": [
        1899.999755859375,
        1752.4998779296875,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18943345546722412,
        -0.050758395344018936,
        -0.9805806875228882
      ],
      "plane_d": 630.665771484375,
      "bbox_min": [
        1844.1661376953125,
        1698.1728515625,
        170.0
      ],
      "bbox_max": [
        1900.0,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 185.0,
      "bbox_min": [
        1897.9903564453125,
        1760.0,
        184.59796142578125
      ],
      "bbox_max": [
        1900.0,
        1767.76806640625,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.6051924325875007e-06,
        -0.8320494890213013,
        -0.5547015070915222
      ],
      "plane_d": 1573.2740478515625,
      "bbox_min": [
        1897.9903564453125,
        1767.5,
        184.59796142578125
      ],
      "bbox_max": [
        1899.999755859375,
        1767.76806640625,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": 0.9910125732421875,
      "bbox_min": [
        1844.1661376953125,
        1698.1728515625,
        170.0
      ],
      "bbox_max": [
        1899.999755859375,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883490443229675,
        0.5883490443229675,
        -0.5546990036964417
      ],
      "plane_d": 197.90924072265625,
      "bbox_min": [
        1844.1661376953125,
        1698.1728515625,
        170.0
      ],
      "bbox_max": [
        1899.999755859375,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": 2071.9794921875,
      "bbox_min": [
        1844.1661376953125,
        1698.1728515625,
        170.0
      ],
      "bbox_max": [
        1899.999755859375,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": 2268.897705078125,
      "bbox_min": [
        1844.1661376953125,
        1698.1728515625,
        170.0
      ],
      "bbox_max": [
        1899.999755859375,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.050758346915245056,
        -0.1894332766532898,
        -0.9805808067321777
      ],
      "plane_d": 619.5714111328125,
      "bbox_min": [
        1844.1661376953125,
        1698.1728515625,
        170.0
      ],
      "bbox_max": [
        1899.999755859375,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0507582351565361,
        0.18943285942077637,
        -0.9805808663368225
      ],
      "plane_d": -47.23326110839844,
      "bbox_min": [
        1844.166259765625,
        1698.1728515625,
        170.0
      ],
      "bbox_max": [
        1899.999755859375,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21534736454486847,
        0.8036937713623047,
        -0.5547088980674744
      ],
      "plane_d": -867.4191284179688,
      "bbox_min": [
        1844.166259765625,
        1698.1728515625,
        170.0
      ],
      "bbox_max": [
        1899.999755859375,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21534866094589233,
        -0.8036985993385315,
        -0.5547012686729431
      ],
      "plane_d": 1961.5927734375,
      "bbox_min": [
        1844.166259765625,
        1698.1728515625,
        170.0
      ],
      "bbox_max": [
        1899.999755859375,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036985993385315,
        -0.21534866094589233,
        0.5547012686729431
      ],
      "plane_d": 1811.7418212890625,
      "bbox_min": [
        1844.166259765625,
        1698.1728515625,
        170.0
      ],
      "bbox_max": [
        1899.999755859375,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320502638816833,
        0.5547001361846924
      ],
      "plane_d": 1376.3497314453125,
      "bbox_min": [
        1897.9903564453125,
        1767.5,
        170.0
      ],
      "bbox_max": [
        1899.999755859375,
        1770.11865234375,
        173.92800903320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036980032920837,
        -0.2153484970331192,
        -0.5547022223472595
      ],
      "plane_d": 2008.659423828125,
      "bbox_min": [
        1844.166259765625,
        1698.1728515625,
        170.0
      ],
      "bbox_max": [
        1899.999755859375,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.6051924325875007e-06,
        -0.8320494890213013,
        -0.5547015070915222
      ],
      "plane_d": 1573.2740478515625,
      "bbox_min": [
        1897.9903564453125,
        1767.5,
        181.07199096679688
      ],
      "bbox_max": [
        1899.999755859375,
        1770.11865234375,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036952018737793,
        0.21534454822540283,
        0.5547077059745789
      ],
      "plane_d": 1053.714111328125,
      "bbox_min": [
        1844.166259765625,
        1698.1728515625,
        170.0
      ],
      "bbox_max": [
        1899.999755859375,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8320565223693848,
        0.5546907782554626
      ],
      "plane_d": -1552.4764404296875,
      "bbox_min": [
        1897.990234375,
        1749.8812255859375,
        170.0
      ],
      "bbox_max": [
        1899.999755859375,
        1752.4998779296875,
        173.92813110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036996722221375,
        0.21534575521945953,
        -0.5547009110450745
      ],
      "plane_d": 1250.640380859375,
      "bbox_min": [
        1844.166259765625,
        1698.1728515625,
        170.0
      ],
      "bbox_max": [
        1899.999755859375,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.173072855133796e-06,
        0.8320558071136475,
        -0.5546919703483582
      ],
      "plane_d": -1355.5537109375,
      "bbox_min": [
        1897.990234375,
        1749.8812255859375,
        181.07186889648438
      ],
      "bbox_max": [
        1899.999755859375,
        1752.4998779296875,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2153484970331192,
        -0.8036980032920837,
        0.5547022223472595
      ],
      "plane_d": 1764.672119140625,
      "bbox_min": [
        1844.166259765625,
        1698.1728515625,
        170.0
      ],
      "bbox_max": [
        1872.588134765625,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        -0.0
      ],
      "plane_d": -2243.27490234375,
      "bbox_min": [
        1844.166259765625,
        1750.2938232421875,
        181.505126953125
      ],
      "bbox_max": [
        1849.82958984375,
        1769.7061767578125,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2186.705810546875,
      "bbox_min": [
        1844.166259765625,
        1750.2938232421875,
        181.505126953125
      ],
      "bbox_max": [
        1849.82958984375,
        1769.7061767578125,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1213.35595703125,
      "bbox_min": [
        1844.166259765625,
        1750.2938232421875,
        181.505126953125
      ],
      "bbox_max": [
        1849.82958984375,
        1763.7059326171875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1844.166259765625,
        1756.2940673828125,
        181.505126953125
      ],
      "bbox_max": [
        1849.82958984375,
        1763.7059326171875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1222.016357421875,
      "bbox_min": [
        1844.166259765625,
        1759.259521484375,
        186.8084259033203
      ],
      "bbox_max": [
        1846.2940673828125,
        1760.740478515625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2178.045654296875,
      "bbox_min": [
        1844.166259765625,
        1760.2952880859375,
        187.50729370117188
      ],
      "bbox_max": [
        1845.828125,
        1760.740478515625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2178.045654296875,
      "bbox_min": [
        1845.828125,
        1760.17041015625,
        186.8084259033203
      ],
      "bbox_max": [
        1846.2940673828125,
        1760.2952880859375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1900.0,
      "bbox_min": [
        1847.4998779296875,
        1884.9998779296875,
        170.0
      ],
      "bbox_max": [
        1900.0001220703125,
        1900.0001220703125,
        185.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        8.137954864650965e-06,
        0.0
      ],
      "plane_d": 1897.9844970703125,
      "bbox_min": [
        1897.9998779296875,
        1884.9998779296875,
        182.0
      ],
      "bbox_max": [
        1900.0001220703125,
        1900.0001220703125,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 182.0,
      "bbox_min": [
        1897.9998779296875,
        1884.9998779296875,
        182.0
      ],
      "bbox_max": [
        1900.0001220703125,
        1900.0001220703125,
        182.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320440649986267,
        1.5157175994318095e-06,
        0.5547096133232117
      ],
      "plane_d": 1442.898193359375,
      "bbox_min": [
        1779.999755859375,
        1555.0,
        170.0
      ],
      "bbox_max": [
        1857.5,
        1900.0,
        190.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.2153484970331192,
        -0.8036980032920837,
        0.5547022223472595
      ],
      "plane_d": 1764.672119140625,
      "bbox_min": [
        1847.4998779296875,
        1698.1728515625,
        170.0
      ],
      "bbox_max": [
        1857.5,
        1900.0,
        177.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1900.0,
      "bbox_min": [
        1847.4998779296875,
        1885.0,
        170.0
      ],
      "bbox_max": [
        1857.4996337890625,
        1900.0,
        177.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1885.0,
      "bbox_min": [
        1847.5,
        1885.0,
        170.0
      ],
      "bbox_max": [
        1857.4996337890625,
        1885.0,
        177.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        -0.0
      ],
      "plane_d": -2243.27490234375,
      "bbox_min": [
        1847.5001220703125,
        1751.18701171875,
        170.0
      ],
      "bbox_max": [
        1849.82958984375,
        1768.81298828125,
        173.49417114257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1847.5001220703125,
        1751.18701171875,
        170.0
      ],
      "bbox_max": [
        1849.82958984375,
        1768.81298828125,
        173.49417114257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1213.35595703125,
      "bbox_min": [
        1847.5001220703125,
        1751.18701171875,
        170.0
      ],
      "bbox_max": [
        1848.5355224609375,
        1751.4644775390625,
        171.55299377441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.8985595703125,
      "bbox_min": [
        1847.5001220703125,
        1761.37646484375,
        170.0
      ],
      "bbox_max": [
        1849.82958984375,
        1768.81298828125,
        173.49417114257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2186.705810546875,
      "bbox_min": [
        1847.5001220703125,
        1768.5355224609375,
        170.0
      ],
      "bbox_max": [
        1848.5355224609375,
        1768.81298828125,
        171.552978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        1.5157344250837923e-06,
        -0.5547002553939819
      ],
      "plane_d": -1422.1151123046875,
      "bbox_min": [
        1779.999755859375,
        1555.0,
        170.0
      ],
      "bbox_max": [
        1852.5001220703125,
        1900.0,
        190.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1635.0,
      "bbox_min": [
        1779.999755859375,
        1555.0,
        170.0
      ],
      "bbox_max": [
        1835.8331298828125,
        1845.0001220703125,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.1894332766532898,
        -0.050758346915245056,
        -0.9805808067321777
      ],
      "plane_d": -66.44908142089844,
      "bbox_min": [
        1779.999755859375,
        1698.1729736328125,
        170.0
      ],
      "bbox_max": [
        1835.8331298828125,
        1845.0001220703125,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 185.0,
      "bbox_min": [
        1779.9998779296875,
        1760.0,
        184.597900390625
      ],
      "bbox_max": [
        1782.0096435546875,
        1767.76806640625,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320565223693848,
        -0.5546908378601074
      ],
      "plane_d": 1573.2777099609375,
      "bbox_min": [
        1779.9998779296875,
        1767.5,
        184.597900390625
      ],
      "bbox_max": [
        1782.0096435546875,
        1767.76806640625,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18943345546722412,
        0.050758395344018936,
        -0.9805806875228882
      ],
      "plane_d": -245.11891174316406,
      "bbox_min": [
        1779.999755859375,
        1698.1729736328125,
        170.0
      ],
      "bbox_max": [
        1835.8331298828125,
        1845.0001220703125,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 185.0,
      "bbox_min": [
        1779.999755859375,
        1752.2318115234375,
        184.5978240966797
      ],
      "bbox_max": [
        1782.009521484375,
        1760.0,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320565223693848,
        -0.5546907782554626
      ],
      "plane_d": -1355.5611572265625,
      "bbox_min": [
        1779.999755859375,
        1752.2318115234375,
        184.5978240966797
      ],
      "bbox_max": [
        1782.009521484375,
        1752.4998779296875,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": -2164.133056640625,
      "bbox_min": [
        1779.999755859375,
        1698.1729736328125,
        170.0
      ],
      "bbox_max": [
        1835.8331298828125,
        1845.0001220703125,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": -1967.2149658203125,
      "bbox_min": [
        1779.999755859375,
        1698.1729736328125,
        170.0
      ],
      "bbox_max": [
        1835.8331298828125,
        1845.0001220703125,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.050758346915245056,
        0.1894332766532898,
        -0.9805808067321777
      ],
      "plane_d": -234.0244903564453,
      "bbox_min": [
        1779.999755859375,
        1698.1729736328125,
        170.0
      ],
      "bbox_max": [
        1835.8331298828125,
        1845.0001220703125,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": 103.77336120605469,
      "bbox_min": [
        1779.999755859375,
        1698.1729736328125,
        170.0
      ],
      "bbox_max": [
        1835.8331298828125,
        1845.0001220703125,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -1.220688227476785e-05,
        0.0
      ],
      "plane_d": -1802.9776611328125,
      "bbox_min": [
        1802.9998779296875,
        1824.9998779296875,
        170.0
      ],
      "bbox_max": [
        1832.5,
        1845.0001220703125,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 185.0,
      "bbox_min": [
        1802.9998779296875,
        1824.9998779296875,
        170.0
      ],
      "bbox_max": [
        1832.5,
        1845.0001220703125,
        185.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -8.138087650877424e-06,
        -1.0,
        0.0
      ],
      "plane_d": 1845.0147705078125,
      "bbox_min": [
        1802.9998779296875,
        1824.9998779296875,
        170.0
      ],
      "bbox_max": [
        1832.5,
        1845.0001220703125,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.137954864650965e-06,
        1.0,
        0.0
      ],
      "plane_d": -1824.9852294921875,
      "bbox_min": [
        1802.9998779296875,
        1824.9998779296875,
        170.0
      ],
      "bbox_max": [
        1832.5,
        1845.0,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1818.0,
      "bbox_min": [
        1818.0,
        1825.0,
        170.0
      ],
      "bbox_max": [
        1832.5,
        1845.0,
        185.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -1.627604251552839e-05
      ],
      "plane_d": 1840.0030517578125,
      "bbox_min": [
        1818.0,
        1830.0,
        170.0
      ],
      "bbox_max": [
        1832.5,
        1840.0001220703125,
        185.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.627577694307547e-05,
        1.0,
        2.712629793677479e-05
      ],
      "plane_d": -1829.97509765625,
      "bbox_min": [
        1818.0001220703125,
        1830.0,
        174.3525390625
      ],
      "bbox_max": [
        1828.0384521484375,
        1830.0001220703125,
        185.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.1386750191450119,
        -0.1386750191450119,
        -0.9805806279182434
      ],
      "plane_d": 181.67942810058594,
      "bbox_min": [
        1779.999755859375,
        1698.1729736328125,
        170.0
      ],
      "bbox_max": [
        1835.8331298828125,
        1834.4615478515625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.050758395344018936,
        -0.18943345546722412,
        -0.9805806875228882
      ],
      "plane_d": 432.7808837890625,
      "bbox_min": [
        1779.999755859375,
        1698.1729736328125,
        170.0
      ],
      "bbox_max": [
        1835.8331298828125,
        1834.4615478515625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 185.0,
      "bbox_min": [
        1825.5098876953125,
        1830.0,
        182.31809997558594
      ],
      "bbox_max": [
        1832.5,
        1834.4615478515625,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.627577694307547e-05,
        1.0,
        2.712629793677479e-05
      ],
      "plane_d": -1829.97509765625,
      "bbox_min": [
        1825.5098876953125,
        1830.0,
        182.31809997558594
      ],
      "bbox_max": [
        1832.5,
        1830.0,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.137954864650965e-06,
        1.0,
        0.0
      ],
      "plane_d": -1824.9852294921875,
      "bbox_min": [
        1808.896484375,
        1824.9998779296875,
        170.0
      ],
      "bbox_max": [
        1824.7939453125,
        1830.0001220703125,
        177.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -1.627604251552839e-05
      ],
      "plane_d": -1829.9971923828125,
      "bbox_min": [
        1818.0,
        1825.0,
        170.0
      ],
      "bbox_max": [
        1824.7939453125,
        1830.0001220703125,
        177.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        2.4413466235273518e-05,
        0.0
      ],
      "plane_d": 1817.9554443359375,
      "bbox_min": [
        1818.0,
        1825.0,
        170.0
      ],
      "bbox_max": [
        1818.0001220703125,
        1830.0001220703125,
        177.49998474121094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.137954864650965e-06,
        1.0,
        0.0
      ],
      "plane_d": -1824.9852294921875,
      "bbox_min": [
        1815.967529296875,
        1825.0,
        175.34425354003906
      ],
      "bbox_max": [
        1818.0,
        1825.0,
        179.6556854248047
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.346212103380822e-06,
        0.8320550322532654,
        0.5546930432319641
      ],
      "plane_d": -1552.4854736328125,
      "bbox_min": [
        1779.999755859375,
        1749.8807373046875,
        170.0
      ],
      "bbox_max": [
        1782.009521484375,
        1752.4998779296875,
        173.92884826660156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8037027716636658,
        0.2153553068637848,
        -0.5546925663948059
      ],
      "plane_d": -1706.998046875,
      "bbox_min": [
        1779.999755859375,
        1698.1729736328125,
        170.0
      ],
      "bbox_max": [
        1835.8331298828125,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320565223693848,
        -0.5546907782554626
      ],
      "plane_d": -1355.5611572265625,
      "bbox_min": [
        1779.999755859375,
        1749.8807373046875,
        181.07115173339844
      ],
      "bbox_max": [
        1782.009521484375,
        1752.4998779296875,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036937713623047,
        -0.21534736454486847,
        0.5547088980674744
      ],
      "plane_d": -1145.8641357421875,
      "bbox_min": [
        1779.9998779296875,
        1698.1729736328125,
        170.0
      ],
      "bbox_max": [
        1835.8331298828125,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.6052263112651417e-06,
        -0.8320573568344116,
        0.5546895265579224
      ],
      "plane_d": 1376.37060546875,
      "bbox_min": [
        1779.9998779296875,
        1767.5,
        170.0
      ],
      "bbox_max": [
        1782.0096435546875,
        1770.1190185546875,
        173.92860412597656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036943078041077,
        -0.2153475135564804,
        -0.5547080039978027
      ],
      "plane_d": -948.943359375,
      "bbox_min": [
        1779.9998779296875,
        1698.1729736328125,
        170.0
      ],
      "bbox_max": [
        1835.8331298828125,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320565223693848,
        -0.5546908378601074
      ],
      "plane_d": 1573.2777099609375,
      "bbox_min": [
        1779.9998779296875,
        1767.5,
        181.07139587402344
      ],
      "bbox_max": [
        1782.0096435546875,
        1770.1190185546875,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2153553068637848,
        0.8037027716636658,
        0.5546925663948059
      ],
      "plane_d": -1856.8460693359375,
      "bbox_min": [
        1807.411865234375,
        1698.1729736328125,
        170.0
      ],
      "bbox_max": [
        1835.8331298828125,
        1821.8270263671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1311.33544921875,
      "bbox_min": [
        1830.17041015625,
        1750.2939453125,
        181.5059051513672
      ],
      "bbox_max": [
        1835.8331298828125,
        1769.7060546875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2165.79833984375,
      "bbox_min": [
        1830.17041015625,
        1750.2939453125,
        181.5059051513672
      ],
      "bbox_max": [
        1835.8331298828125,
        1769.7060546875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1234.263671875,
      "bbox_min": [
        1830.17041015625,
        1756.2940673828125,
        181.5059051513672
      ],
      "bbox_max": [
        1835.8331298828125,
        1769.7060546875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1830.17041015625,
        1756.2940673828125,
        181.5059051513672
      ],
      "bbox_max": [
        1835.8331298828125,
        1763.7059326171875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2174.458740234375,
      "bbox_min": [
        1833.7060546875,
        1759.259765625,
        186.8094940185547
      ],
      "bbox_max": [
        1835.8331298828125,
        1760.7403564453125,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1225.603515625,
      "bbox_min": [
        1834.17138671875,
        1760.295166015625,
        187.50747680664062
      ],
      "bbox_max": [
        1835.8331298828125,
        1760.7403564453125,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1225.603515625,
      "bbox_min": [
        1833.7059326171875,
        1760.17041015625,
        186.80926513671875
      ],
      "bbox_max": [
        1834.17138671875,
        1760.295166015625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 185.0,
      "bbox_min": [
        1780.0,
        1555.0,
        170.0
      ],
      "bbox_max": [
        1832.5001220703125,
        1635.0001220703125,
        185.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -5.365699507819954e-06,
        1.0,
        0.0
      ],
      "plane_d": -1619.9903564453125,
      "bbox_min": [
        1780.0,
        1555.0,
        170.0
      ],
      "bbox_max": [
        1832.5,
        1620.0001220703125,
        185.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.32583320140838623,
        -0.7866465449333191,
        0.5244235396385193
      ],
      "plane_d": 540.3921508789062,
      "bbox_min": [
        1810.0,
        1555.0,
        172.99630737304688
      ],
      "bbox_max": [
        1822.374267578125,
        1560.12548828125,
        177.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7866412401199341,
        -0.3258401155471802,
        0.5244269967079163
      ],
      "plane_d": -1018.2890625,
      "bbox_min": [
        1817.2489013671875,
        1555.0001220703125,
        170.0
      ],
      "bbox_max": [
        1827.5,
        1572.5,
        177.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32583320140838623,
        -0.7866465449333191,
        0.5244235396385193
      ],
      "plane_d": 540.3921508789062,
      "bbox_min": [
        1817.2489013671875,
        1555.0001220703125,
        170.0
      ],
      "bbox_max": [
        1824.49755859375,
        1560.12548828125,
        177.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        -0.0,
        0.5547002553939819
      ],
      "plane_d": -1619.03125,
      "bbox_min": [
        1822.4996337890625,
        1555.0001220703125,
        170.0
      ],
      "bbox_max": [
        1852.5001220703125,
        1900.0,
        190.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.7866412401199341,
        -0.3258401155471802,
        0.5244269967079163
      ],
      "plane_d": -1018.2890625,
      "bbox_min": [
        1822.4996337890625,
        1555.177734375,
        170.0
      ],
      "bbox_max": [
        1832.5,
        1840.0001220703125,
        177.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2153553068637848,
        0.8037027716636658,
        0.5546925663948059
      ],
      "plane_d": -1856.8460693359375,
      "bbox_min": [
        1822.4996337890625,
        1555.177734375,
        170.0
      ],
      "bbox_max": [
        1832.5,
        1840.0001220703125,
        177.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -5.365699507819954e-06,
        1.0,
        0.0
      ],
      "plane_d": -1619.9903564453125,
      "bbox_min": [
        1822.5,
        1555.177734375,
        170.0
      ],
      "bbox_max": [
        1832.5,
        1635.0,
        177.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.32583320140838623,
        -0.7866465449333191,
        0.5244235396385193
      ],
      "plane_d": 540.3921508789062,
      "bbox_min": [
        1822.500244140625,
        1555.177734375,
        170.0
      ],
      "bbox_max": [
        1825.9097900390625,
        1558.002197265625,
        172.9959259033203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.627577694307547e-05,
        -1.0,
        2.712629793677479e-05
      ],
      "plane_d": 1839.965576171875,
      "bbox_min": [
        1822.4996337890625,
        1830.0,
        170.0
      ],
      "bbox_max": [
        1832.5,
        1840.0001220703125,
        177.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1311.33544921875,
      "bbox_min": [
        1830.17041015625,
        1751.18701171875,
        170.0
      ],
      "bbox_max": [
        1832.5,
        1768.81298828125,
        173.49441528320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1830.17041015625,
        1751.18701171875,
        170.0
      ],
      "bbox_max": [
        1832.5,
        1768.81298828125,
        173.49441528320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2165.79833984375,
      "bbox_min": [
        1831.4644775390625,
        1751.18701171875,
        170.0
      ],
      "bbox_max": [
        1832.5,
        1751.4644775390625,
        171.55322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2541.25439453125,
      "bbox_min": [
        1830.17041015625,
        1761.3763427734375,
        170.0
      ],
      "bbox_max": [
        1832.5,
        1768.81298828125,
        173.49441528320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1234.263671875,
      "bbox_min": [
        1831.4644775390625,
        1768.5355224609375,
        170.0
      ],
      "bbox_max": [
        1832.5,
        1768.81298828125,
        171.55322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 185.0,
      "bbox_min": [
        1827.5,
        1555.0001220703125,
        170.0
      ],
      "bbox_max": [
        1852.5001220703125,
        1900.0,
        190.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.050758395344018936,
        -0.18943345546722412,
        -0.9805806875228882
      ],
      "plane_d": 432.7808837890625,
      "bbox_min": [
        1832.49951171875,
        1700.0,
        185.0
      ],
      "bbox_max": [
        1847.4998779296875,
        1820.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.050758346915245056,
        0.1894332766532898,
        -0.9805808067321777
      ],
      "plane_d": -234.0244903564453,
      "bbox_min": [
        1832.499755859375,
        1700.0,
        185.0
      ],
      "bbox_max": [
        1847.4998779296875,
        1820.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0507582351565361,
        0.18943285942077637,
        -0.9805808663368225
      ],
      "plane_d": -47.23326110839844,
      "bbox_min": [
        1832.499755859375,
        1700.0,
        185.0
      ],
      "bbox_max": [
        1847.4998779296875,
        1820.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.050758346915245056,
        -0.1894332766532898,
        -0.9805808067321777
      ],
      "plane_d": 619.5714111328125,
      "bbox_min": [
        1832.499755859375,
        1750.17041015625,
        185.0
      ],
      "bbox_max": [
        1847.4996337890625,
        1820.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2186.705810546875,
      "bbox_min": [
        1832.499755859375,
        1750.17041015625,
        185.0
      ],
      "bbox_max": [
        1847.4996337890625,
        1769.82958984375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.898681640625,
      "bbox_min": [
        1832.499755859375,
        1750.17041015625,
        185.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1761.3765869140625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2174.458740234375,
      "bbox_min": [
        1832.499755859375,
        1758.53564453125,
        185.0
      ],
      "bbox_max": [
        1838.53564453125,
        1761.3765869140625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1832.499755859375,
        1758.6234130859375,
        185.0
      ],
      "bbox_max": [
        1833.7060546875,
        1759.8297119140625,
        186.8094940185547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2541.25439453125,
      "bbox_min": [
        1832.499755859375,
        1760.17041015625,
        185.0
      ],
      "bbox_max": [
        1833.7059326171875,
        1761.3765869140625,
        186.80926513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1836.2940673828125,
        1761.268310546875,
        185.0
      ],
      "bbox_max": [
        1839.82958984375,
        1769.82958984375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1225.603515625,
      "bbox_min": [
        1837.80322265625,
        1761.268310546875,
        185.0
      ],
      "bbox_max": [
        1838.5355224609375,
        1761.4644775390625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1840.17041015625,
        1753.7059326171875,
        185.0
      ],
      "bbox_max": [
        1847.4996337890625,
        1769.82958984375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1222.016357421875,
      "bbox_min": [
        1840.17041015625,
        1753.7059326171875,
        185.0
      ],
      "bbox_max": [
        1847.4996337890625,
        1766.2940673828125,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1323.5828857421875,
      "bbox_min": [
        1840.17041015625,
        1753.7059326171875,
        185.0
      ],
      "bbox_max": [
        1847.4996337890625,
        1759.82958984375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1846.2940673828125,
        1758.6240234375,
        185.0
      ],
      "bbox_max": [
        1847.4996337890625,
        1759.82958984375,
        186.8084259033203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2178.045654296875,
      "bbox_min": [
        1841.4644775390625,
        1760.17041015625,
        185.0
      ],
      "bbox_max": [
        1847.4996337890625,
        1761.4644775390625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.8985595703125,
      "bbox_min": [
        1846.2940673828125,
        1760.17041015625,
        185.0
      ],
      "bbox_max": [
        1847.4996337890625,
        1761.3759765625,
        186.8084259033203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7866410613059998,
        0.325840562582016,
        0.5244271755218506
      ],
      "plane_d": 851.782470703125,
      "bbox_min": [
        1827.5,
        1555.0001220703125,
        170.0
      ],
      "bbox_max": [
        1852.5001220703125,
        1900.0,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1899.9998779296875,
      "bbox_min": [
        1827.5,
        1750.17041015625,
        170.0
      ],
      "bbox_max": [
        1852.5,
        1900.0,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2165.79833984375,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        170.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1225.603515625,
      "bbox_min": [
        1830.17041015625,
        1751.4644775390625,
        170.0
      ],
      "bbox_max": [
        1839.82958984375,
        1769.82958984375,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1830.17041015625,
        1760.17041015625,
        170.0
      ],
      "bbox_max": [
        1839.82958984375,
        1769.82958984375,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1234.263671875,
      "bbox_min": [
        1830.17041015625,
        1760.17041015625,
        170.0
      ],
      "bbox_max": [
        1836.2940673828125,
        1769.82958984375,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2541.25439453125,
      "bbox_min": [
        1830.17041015625,
        1760.17041015625,
        170.0
      ],
      "bbox_max": [
        1833.7059326171875,
        1768.5355224609375,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1311.33544921875,
      "bbox_min": [
        1830.17041015625,
        1763.7059326171875,
        171.55322265625
      ],
      "bbox_max": [
        1831.4644775390625,
        1768.5355224609375,
        183.44711303710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2174.458740234375,
      "bbox_min": [
        1830.17041015625,
        1751.4644775390625,
        170.0
      ],
      "bbox_max": [
        1837.8033447265625,
        1759.8297119140625,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1830.17041015625,
        1751.4644775390625,
        170.0
      ],
      "bbox_max": [
        1833.7060546875,
        1759.8297119140625,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": 2222.3671875,
      "bbox_min": [
        1830.17041015625,
        1751.4644775390625,
        171.55322265625
      ],
      "bbox_max": [
        1831.4644775390625,
        1756.2940673828125,
        183.44711303710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2178.045654296875,
      "bbox_min": [
        1836.2940673828125,
        1750.17041015625,
        170.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1840.17041015625,
        1760.17041015625,
        170.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": 2234.614501953125,
      "bbox_min": [
        1840.17041015625,
        1760.17041015625,
        170.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2186.705810546875,
      "bbox_min": [
        1843.7059326171875,
        1760.17041015625,
        170.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.8985595703125,
      "bbox_min": [
        1846.2940673828125,
        1760.17041015625,
        170.0
      ],
      "bbox_max": [
        1849.82958984375,
        1768.5355224609375,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        -0.0
      ],
      "plane_d": -2243.27490234375,
      "bbox_min": [
        1848.5355224609375,
        1763.7059326171875,
        171.55299377441406
      ],
      "bbox_max": [
        1849.82958984375,
        1768.5355224609375,
        183.44630432128906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1323.5828857421875,
      "bbox_min": [
        1836.2940673828125,
        1750.17041015625,
        170.0
      ],
      "bbox_max": [
        1849.82958984375,
        1759.82958984375,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2541.25439453125,
      "bbox_min": [
        1840.17041015625,
        1750.17041015625,
        170.0
      ],
      "bbox_max": [
        1849.82958984375,
        1759.82958984375,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1222.016357421875,
      "bbox_min": [
        1841.4644775390625,
        1750.17041015625,
        170.0
      ],
      "bbox_max": [
        1849.82958984375,
        1759.82958984375,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1213.35595703125,
      "bbox_min": [
        1843.7059326171875,
        1750.17041015625,
        170.0
      ],
      "bbox_max": [
        1849.82958984375,
        1759.82958984375,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1846.2940673828125,
        1751.4644775390625,
        170.0
      ],
      "bbox_max": [
        1849.82958984375,
        1759.82958984375,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1332.2431640625,
      "bbox_min": [
        1848.5355224609375,
        1751.4644775390625,
        171.552978515625
      ],
      "bbox_max": [
        1849.82958984375,
        1756.2940673828125,
        183.44630432128906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.898681640625,
      "bbox_min": [
        1836.2940673828125,
        1750.17041015625,
        170.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1758.73193359375,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        -0.0
      ],
      "plane_d": -2231.02734375,
      "bbox_min": [
        1837.8033447265625,
        1753.7060546875,
        170.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1758.73193359375,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707105815410614,
        0.7071077823638916,
        0.0
      ],
      "plane_d": -59.6290283203125,
      "bbox_min": [
        1680.0,
        1610.0,
        170.0
      ],
      "bbox_max": [
        1780.0,
        1910.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2429.956298828125,
      "bbox_min": [
        1680.0,
        1610.0,
        170.0
      ],
      "bbox_max": [
        1780.0,
        1820.39990234375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9663541316986084,
        0.257215291261673,
        0.0
      ],
      "plane_d": 1209.43017578125,
      "bbox_min": [
        1680.0,
        1700.4000244140625,
        170.0
      ],
      "bbox_max": [
        1780.0,
        1820.39990234375,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9654912352561951,
        -0.26043567061424255,
        3.147785537294112e-05
      ],
      "plane_d": 2119.005859375,
      "bbox_min": [
        1720.0001220703125,
        1700.4000244140625,
        170.0
      ],
      "bbox_max": [
        1780.0,
        1795.0,
        190.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 185.0,
      "bbox_min": [
        1720.0001220703125,
        1725.9998779296875,
        170.0
      ],
      "bbox_max": [
        1780.0,
        1795.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        1729.8226318359375,
        1731.0,
        185.0
      ],
      "bbox_max": [
        1750.0001220703125,
        1790.0,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1731.0,
      "bbox_min": [
        1729.8226318359375,
        1731.0,
        185.0
      ],
      "bbox_max": [
        1750.0,
        1790.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1790.0,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        185.0
      ],
      "bbox_max": [
        1750.0,
        1790.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9663532972335815,
        -0.2572184205055237,
        0.0
      ],
      "plane_d": -1211.35595703125,
      "bbox_min": [
        1720.0001220703125,
        1725.9998779296875,
        170.0
      ],
      "bbox_max": [
        1779.9998779296875,
        1795.0,
        185.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 182.0,
      "bbox_min": [
        1720.0001220703125,
        1756.268310546875,
        173.0
      ],
      "bbox_max": [
        1731.3160400390625,
        1795.0,
        182.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -6.103888154029846e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 1790.1055908203125,
      "bbox_min": [
        1727.9853515625,
        1790.0,
        173.0
      ],
      "bbox_max": [
        1731.3160400390625,
        1795.0,
        182.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -1729.985107421875,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        173.0
      ],
      "bbox_max": [
        1731.3160400390625,
        1795.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833810806274,
        0.3162277936935425
      ],
      "plane_d": 1645.9656982421875,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        173.0
      ],
      "bbox_max": [
        1731.3160400390625,
        1795.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3162277638912201,
        0.9486833214759827
      ],
      "plane_d": 401.9255065917969,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        173.0
      ],
      "bbox_max": [
        1730.78369140625,
        1793.0,
        174.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320565223693848,
        -0.5546908378601074
      ],
      "plane_d": 1573.2777099609375,
      "bbox_min": [
        1721.0067138671875,
        1725.9998779296875,
        170.0
      ],
      "bbox_max": [
        1779.9998779296875,
        1795.0,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        1729.9852294921875,
        1767.5,
        170.0
      ],
      "bbox_max": [
        1779.9998779296875,
        1795.0,
        185.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8036937713623047,
        -0.21534736454486847,
        0.5547088980674744
      ],
      "plane_d": -1145.8641357421875,
      "bbox_min": [
        1778.1728515625,
        1772.4998779296875,
        175.39712524414062
      ],
      "bbox_max": [
        1779.9998779296875,
        1779.3184814453125,
        177.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1790.0,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        170.0
      ],
      "bbox_max": [
        1750.0,
        1795.0,
        185.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 180.0,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        173.0
      ],
      "bbox_max": [
        1750.0,
        1795.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.6052263112651417e-06,
        -0.8320573568344116,
        0.5546895265579224
      ],
      "plane_d": 1376.37060546875,
      "bbox_min": [
        1721.0067138671875,
        1725.9998779296875,
        170.0
      ],
      "bbox_max": [
        1779.9998779296875,
        1777.4996337890625,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        1750.0,
        1767.5,
        170.0
      ],
      "bbox_max": [
        1779.9998779296875,
        1777.4996337890625,
        177.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036937713623047,
        -0.21534736454486847,
        0.5547088980674744
      ],
      "plane_d": -1145.8641357421875,
      "bbox_min": [
        1778.1728515625,
        1770.1190185546875,
        173.92860412597656
      ],
      "bbox_max": [
        1779.9998779296875,
        1773.9017333984375,
        177.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9654908776283264,
        0.2604372203350067,
        0.0
      ],
      "plane_d": -2120.94482421875,
      "bbox_min": [
        1721.0067138671875,
        1725.9998779296875,
        170.0
      ],
      "bbox_max": [
        1779.999755859375,
        1760.0,
        185.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 182.0,
      "bbox_min": [
        1721.0067138671875,
        1725.9998779296875,
        173.0
      ],
      "bbox_max": [
        1731.1715087890625,
        1760.0,
        182.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1729.8226318359375,
      "bbox_min": [
        1729.822509765625,
        1725.9998779296875,
        173.0
      ],
      "bbox_max": [
        1731.1715087890625,
        1731.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486775994300842,
        0.3162451684474945
      ],
      "plane_d": -1694.341552734375,
      "bbox_min": [
        1729.822509765625,
        1725.9998779296875,
        173.0
      ],
      "bbox_max": [
        1731.1715087890625,
        1731.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.346212103380822e-06,
        0.8320550322532654,
        0.5546930432319641
      ],
      "plane_d": -1552.4854736328125,
      "bbox_min": [
        1729.8226318359375,
        1725.9998779296875,
        170.0
      ],
      "bbox_max": [
        1779.999755859375,
        1752.5001220703125,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        5.6776571000227705e-06,
        -1.2490845620050095e-05
      ],
      "plane_d": 1749.9921875,
      "bbox_min": [
        1729.8226318359375,
        1725.9998779296875,
        170.0
      ],
      "bbox_max": [
        1779.999755859375,
        1752.5001220703125,
        185.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8037027716636658,
        0.2153553068637848,
        -0.5546925663948059
      ],
      "plane_d": -1706.998046875,
      "bbox_min": [
        1778.1729736328125,
        1740.682373046875,
        177.5
      ],
      "bbox_max": [
        1779.999755859375,
        1747.5,
        179.60264587402344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1731.0,
      "bbox_min": [
        1729.8226318359375,
        1725.9998779296875,
        170.0
      ],
      "bbox_max": [
        1750.0,
        1731.0,
        185.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 180.0,
      "bbox_min": [
        1729.8226318359375,
        1725.9998779296875,
        173.0
      ],
      "bbox_max": [
        1750.0,
        1731.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320565223693848,
        -0.5546907782554626
      ],
      "plane_d": -1355.5611572265625,
      "bbox_min": [
        1750.0,
        1742.5003662109375,
        177.5
      ],
      "bbox_max": [
        1779.999755859375,
        1752.5001220703125,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        5.67765664527542e-06,
        0.0
      ],
      "plane_d": 1749.9901123046875,
      "bbox_min": [
        1750.0,
        1742.5003662109375,
        177.5
      ],
      "bbox_max": [
        1779.999755859375,
        1752.5001220703125,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8037027716636658,
        0.2153553068637848,
        -0.5546925663948059
      ],
      "plane_d": -1706.998046875,
      "bbox_min": [
        1778.1729736328125,
        1746.0982666015625,
        177.5
      ],
      "bbox_max": [
        1779.999755859375,
        1749.8807373046875,
        181.07115173339844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        1680.0,
        1755.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1765.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1765.0,
      "bbox_min": [
        1680.0,
        1755.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1765.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1755.0,
      "bbox_min": [
        1680.0,
        1755.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1764.3232421875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1756.476806640625,
        170.0
      ],
      "bbox_max": [
        1680.0,
        1764.3232421875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1665.0,
      "bbox_min": [
        1680.0,
        1610.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1756.476806640625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1680.0,
        1610.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1665.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        1680.0,
        1610.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1620.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1610.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1620.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1680.0,
        1610.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1610.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        1680.0,
        1655.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1665.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1655.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1665.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1655.0,
      "bbox_min": [
        1680.0,
        1655.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1655.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2207180589030031e-05,
        1.0,
        0.0
      ],
      "plane_d": -1715.0205078125,
      "bbox_min": [
        1680.0,
        1705.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1756.476806640625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1705.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1715.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1705.0,
      "bbox_min": [
        1680.0,
        1705.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1714.9998779296875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.2207180589030031e-05,
        0.0
      ],
      "plane_d": -1690.0208740234375,
      "bbox_min": [
        1689.9998779296875,
        1705.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1714.9998779296875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1755.0,
      "bbox_min": [
        1680.0,
        1755.0,
        170.0
      ],
      "bbox_max": [
        1681.476806640625,
        1756.476806640625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1755.0,
        170.0
      ],
      "bbox_max": [
        1680.0,
        1756.476806640625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1855.0,
      "bbox_min": [
        1680.0,
        1764.3232421875,
        170.0
      ],
      "bbox_max": [
        1690.0001220703125,
        1910.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.220703143189894e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1900.0206298828125,
      "bbox_min": [
        1680.0,
        1855.0,
        170.0
      ],
      "bbox_max": [
        1690.0001220703125,
        1910.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.220703143189894e-05,
        0.0
      ],
      "plane_d": -1690.0233154296875,
      "bbox_min": [
        1680.0001220703125,
        1900.0,
        170.0
      ],
      "bbox_max": [
        1690.0001220703125,
        1910.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0001220703125,
      "bbox_min": [
        1680.0001220703125,
        1900.0001220703125,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1910.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1910.0,
      "bbox_min": [
        1680.0001220703125,
        1910.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1910.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        1680.0,
        1855.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1865.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -1.220703143189894e-05,
        0.0
      ],
      "plane_d": 1680.022705078125,
      "bbox_min": [
        1680.0,
        1855.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1865.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1865.0,
      "bbox_min": [
        1680.0,
        1865.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1865.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1805.0,
      "bbox_min": [
        1680.0,
        1764.3232421875,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1815.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1805.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1815.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.220703143189894e-05,
        1.0,
        0.0
      ],
      "plane_d": -1815.0205078125,
      "bbox_min": [
        1680.0,
        1805.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1815.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        1690.0,
        1805.0,
        170.0
      ],
      "bbox_max": [
        1690.0,
        1814.9998779296875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1765.0,
      "bbox_min": [
        1680.0,
        1764.3232421875,
        170.0
      ],
      "bbox_max": [
        1680.6767578125,
        1765.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1764.3232421875,
        170.0
      ],
      "bbox_max": [
        1680.0,
        1765.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -172.19677734375,
      "bbox_min": [
        1899.999755859375,
        1610.0,
        170.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707105815410614,
        0.7071077823638916,
        -0.0
      ],
      "plane_d": -2661.7783203125,
      "bbox_min": [
        1899.999755859375,
        1700.4000244140625,
        170.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9663520455360413,
        0.25722306966781616,
        -4.129499211558141e-05
      ],
      "plane_d": -2346.755126953125,
      "bbox_min": [
        1899.999755859375,
        1700.4000244140625,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1820.4000244140625,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9654906392097473,
        -0.26043805480003357,
        0.0
      ],
      "plane_d": -1433.99072265625,
      "bbox_min": [
        1899.999755859375,
        1700.4000244140625,
        170.0
      ],
      "bbox_max": [
        1960.0,
        1794.9998779296875,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 185.0,
      "bbox_min": [
        1899.999755859375,
        1726.0,
        170.0
      ],
      "bbox_max": [
        1960.0,
        1794.9998779296875,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1930.0,
      "bbox_min": [
        1930.0,
        1731.0001220703125,
        185.0
      ],
      "bbox_max": [
        1950.177490234375,
        1790.0,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1731.0001220703125,
      "bbox_min": [
        1930.0,
        1731.0001220703125,
        185.0
      ],
      "bbox_max": [
        1950.177490234375,
        1790.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1790.0,
      "bbox_min": [
        1930.0,
        1790.0,
        185.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1790.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -173.0,
      "bbox_min": [
        1899.999755859375,
        1726.0,
        170.0
      ],
      "bbox_max": [
        1960.0,
        1794.9998779296875,
        185.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9663532972335815,
        -0.2572184205055237,
        -0.0
      ],
      "plane_d": 2344.82421875,
      "bbox_min": [
        1899.999755859375,
        1731.0001220703125,
        170.0
      ],
      "bbox_max": [
        1958.0,
        1790.0,
        173.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320502638816833,
        0.5547001361846924
      ],
      "plane_d": 1376.3497314453125,
      "bbox_min": [
        1899.999755859375,
        1731.0001220703125,
        170.0
      ],
      "bbox_max": [
        1958.0,
        1790.0,
        173.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1790.0,
      "bbox_min": [
        1930.0,
        1790.0,
        170.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1790.0,
        173.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9654915928840637,
        0.26043444871902466,
        0.0
      ],
      "plane_d": 1432.06787109375,
      "bbox_min": [
        1899.999755859375,
        1731.0001220703125,
        170.0
      ],
      "bbox_max": [
        1958.0,
        1760.0,
        173.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8320565223693848,
        0.5546907782554626
      ],
      "plane_d": -1552.4764404296875,
      "bbox_min": [
        1899.999755859375,
        1731.0001220703125,
        170.0
      ],
      "bbox_max": [
        1950.177490234375,
        1752.5,
        173.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1731.0001220703125,
      "bbox_min": [
        1930.0001220703125,
        1731.0001220703125,
        170.0
      ],
      "bbox_max": [
        1950.177490234375,
        1731.0001220703125,
        173.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9663532972335815,
        -0.2572184205055237,
        0.0
      ],
      "plane_d": 2344.82421875,
      "bbox_min": [
        1899.999755859375,
        1726.0,
        173.0
      ],
      "bbox_max": [
        1960.0,
        1794.9998779296875,
        185.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 181.99998474121094,
      "bbox_min": [
        1948.6839599609375,
        1756.268310546875,
        173.0
      ],
      "bbox_max": [
        1960.0,
        1794.9998779296875,
        182.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -2.4414661311311647e-05,
        -0.0
      ],
      "plane_d": 1950.0584716796875,
      "bbox_min": [
        1948.6839599609375,
        1790.0,
        173.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1794.9998779296875,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486891031265259,
        0.31621038913726807
      ],
      "plane_d": 1645.97900390625,
      "bbox_min": [
        1948.6839599609375,
        1790.0,
        173.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1794.9998779296875,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 180.0,
      "bbox_min": [
        1948.6839599609375,
        1790.0,
        173.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1794.9998779296875,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3162277638912201,
        0.9486833214759827
      ],
      "plane_d": 401.92547607421875,
      "bbox_min": [
        1949.2164306640625,
        1790.0,
        173.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1793.0,
        174.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9654915928840637,
        0.26043444871902466,
        0.0
      ],
      "plane_d": 1432.06787109375,
      "bbox_min": [
        1899.999755859375,
        1726.0,
        173.0
      ],
      "bbox_max": [
        1958.993408203125,
        1794.9998779296875,
        185.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 181.99998474121094,
      "bbox_min": [
        1948.8287353515625,
        1726.0,
        173.0
      ],
      "bbox_max": [
        1958.993408203125,
        1760.0,
        182.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        2.4413466235273518e-05,
        -1.2206733117636759e-05
      ],
      "plane_d": 1950.1373291015625,
      "bbox_min": [
        1948.8287353515625,
        1726.0,
        173.0
      ],
      "bbox_max": [
        1950.177490234375,
        1731.0001220703125,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486833810806274,
        0.3162277936935425
      ],
      "plane_d": -1694.3485107421875,
      "bbox_min": [
        1948.8287353515625,
        1726.0,
        173.0
      ],
      "bbox_max": [
        1950.177490234375,
        1731.0001220703125,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 180.0,
      "bbox_min": [
        1948.8287353515625,
        1726.0,
        173.0
      ],
      "bbox_max": [
        1950.177490234375,
        1731.0001220703125,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1930.0,
      "bbox_min": [
        1899.999755859375,
        1767.5,
        173.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1794.9998779296875,
        185.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8036980032920837,
        -0.2153484970331192,
        -0.5547022223472595
      ],
      "plane_d": 2008.659423828125,
      "bbox_min": [
        1899.999755859375,
        1770.11865234375,
        175.39678955078125
      ],
      "bbox_max": [
        1901.8270263671875,
        1779.3197021484375,
        181.07199096679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036985993385315,
        -0.21534866094589233,
        0.5547012686729431
      ],
      "plane_d": 1811.7418212890625,
      "bbox_min": [
        1899.999755859375,
        1772.5,
        175.39678955078125
      ],
      "bbox_max": [
        1901.8270263671875,
        1779.3197021484375,
        177.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1790.0,
      "bbox_min": [
        1929.9998779296875,
        1790.0,
        173.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1794.9998779296875,
        185.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 180.0,
      "bbox_min": [
        1929.9998779296875,
        1790.0,
        173.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1794.9998779296875,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3162277936935425,
        0.9486833810806274
      ],
      "plane_d": 401.9255065917969,
      "bbox_min": [
        1930.0,
        1790.0,
        173.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1793.0,
        174.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8036985993385315,
        -0.21534866094589233,
        0.5547012686729431
      ],
      "plane_d": 1811.7418212890625,
      "bbox_min": [
        1899.999755859375,
        1770.11865234375,
        173.92800903320312
      ],
      "bbox_max": [
        1901.8270263671875,
        1773.902099609375,
        177.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.173072855133796e-06,
        0.8320558071136475,
        -0.5546919703483582
      ],
      "plane_d": -1355.5537109375,
      "bbox_min": [
        1899.999755859375,
        1726.0,
        173.0
      ],
      "bbox_max": [
        1950.177490234375,
        1752.5,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        7.398255547741428e-06,
        -4.932170668325853e-06
      ],
      "plane_d": -1930.0120849609375,
      "bbox_min": [
        1899.999755859375,
        1726.0,
        173.0
      ],
      "bbox_max": [
        1950.177490234375,
        1752.5,
        185.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8036996722221375,
        0.21534575521945953,
        -0.5547009110450745
      ],
      "plane_d": 1250.640380859375,
      "bbox_min": [
        1899.999755859375,
        1740.6805419921875,
        175.3968505859375
      ],
      "bbox_max": [
        1901.8270263671875,
        1749.8812255859375,
        181.07186889648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036952018737793,
        0.21534454822540283,
        0.5547077059745789
      ],
      "plane_d": 1053.714111328125,
      "bbox_min": [
        1899.999755859375,
        1740.6805419921875,
        175.3968505859375
      ],
      "bbox_max": [
        1901.8270263671875,
        1747.5,
        177.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1731.0001220703125,
      "bbox_min": [
        1930.0,
        1726.0,
        173.0
      ],
      "bbox_max": [
        1950.177490234375,
        1731.0001220703125,
        185.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 180.0,
      "bbox_min": [
        1930.0,
        1726.0,
        173.0
      ],
      "bbox_max": [
        1950.177490234375,
        1731.0001220703125,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.3162161707878113,
        0.9486871361732483
      ],
      "plane_d": -711.4931640625,
      "bbox_min": [
        1930.0,
        1728.0,
        173.0
      ],
      "bbox_max": [
        1950.177490234375,
        1731.0001220703125,
        174.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        7.398255547741428e-06,
        0.0
      ],
      "plane_d": -1930.012939453125,
      "bbox_min": [
        1899.999755859375,
        1744.500244140625,
        173.0
      ],
      "bbox_max": [
        1930.0,
        1750.5,
        177.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036952018737793,
        0.21534454822540283,
        0.5547077059745789
      ],
      "plane_d": 1053.714111328125,
      "bbox_min": [
        1899.999755859375,
        1746.0980224609375,
        173.92813110351562
      ],
      "bbox_max": [
        1901.8270263671875,
        1749.8812255859375,
        177.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -1.2207180589030031e-05,
        0.0
      ],
      "plane_d": 1990.0216064453125,
      "bbox_min": [
        1990.0,
        1755.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1765.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1765.0,
      "bbox_min": [
        1990.0,
        1755.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1765.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2207180589030031e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 1755.0244140625,
      "bbox_min": [
        1990.0001220703125,
        1755.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1764.3232421875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        2000.0,
        1756.4769287109375,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1764.3232421875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.220703143189894e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 1855.0244140625,
      "bbox_min": [
        1989.9998779296875,
        1764.3232421875,
        170.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.4413466235273518e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1899.9512939453125,
      "bbox_min": [
        1989.9998779296875,
        1855.0,
        170.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.4413466235273518e-05,
        0.0
      ],
      "plane_d": 1989.9534912109375,
      "bbox_min": [
        1989.9998779296875,
        1899.9998779296875,
        170.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.2207180589030031e-05,
        0.0
      ],
      "plane_d": -2000.0233154296875,
      "bbox_min": [
        1990.0001220703125,
        1900.0001220703125,
        170.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2207180589030031e-05,
        1.0,
        -0.0
      ],
      "plane_d": -1910.0244140625,
      "bbox_min": [
        1990.0001220703125,
        1910.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1910.0001220703125,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.220703143189894e-05,
        0.0
      ],
      "plane_d": -2000.022705078125,
      "bbox_min": [
        1990.0001220703125,
        1855.0,
        170.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1865.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0001220703125,
      "bbox_min": [
        1990.0001220703125,
        1855.0001220703125,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1865.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1865.0,
      "bbox_min": [
        1990.0001220703125,
        1865.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1865.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1805.0,
      "bbox_min": [
        1990.0,
        1764.3232421875,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1815.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0,
      "bbox_min": [
        1990.0,
        1805.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1815.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        1990.0,
        1805.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1815.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1815.0,
      "bbox_min": [
        1990.0,
        1815.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1815.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1765.0,
      "bbox_min": [
        1999.3232421875,
        1764.3232421875,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1765.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        2000.0,
        1764.3232421875,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1765.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1665.0,
      "bbox_min": [
        1990.0,
        1610.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1756.4769287109375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1990.0,
        1610.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1665.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0,
      "bbox_min": [
        1990.0,
        1610.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1620.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        1990.0,
        1610.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1620.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1990.0,
        1610.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1610.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0,
      "bbox_min": [
        1990.0,
        1655.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1665.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        1990.0,
        1655.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1665.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1655.0,
      "bbox_min": [
        1990.0,
        1655.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1655.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1715.0,
      "bbox_min": [
        1990.0,
        1705.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1756.4769287109375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0,
      "bbox_min": [
        1990.0,
        1705.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1715.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        1990.0,
        1705.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1715.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1705.0,
      "bbox_min": [
        1990.0,
        1705.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1705.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2207180589030031e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 1755.0244140625,
      "bbox_min": [
        1998.5230712890625,
        1755.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1756.4769287109375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        2000.0,
        1755.0,
        170.0
      ],
      "bbox_max": [
        2000.0,
        1756.4769287109375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1700.4000244140625,
      "bbox_min": [
        1655.0,
        1570.0,
        145.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1950.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1820.4000244140625,
      "bbox_min": [
        1655.0,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        2025.0,
        1950.0,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1894332617521286,
        -0.05075898766517639,
        -0.9805806875228882
      ],
      "plane_d": -90.96246337890625,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18943364918231964,
        -0.05075809732079506,
        -0.9805806875228882
      ],
      "plane_d": 606.151123046875,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1894332766532898,
        0.0507580041885376,
        -0.9805808067321777
      ],
      "plane_d": 427.4820556640625,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18943364918231964,
        0.05075809732079506,
        -0.9805806875228882
      ],
      "plane_d": -269.6332702636719,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1386750340461731,
        0.1386750340461731,
        -0.9805808067321777
      ],
      "plane_d": -330.97119140625,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1386750340461731,
        -0.1386750340461731,
        -0.9805808067321777
      ],
      "plane_d": 667.4890747070312,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1386750340461731,
        0.1386750340461731,
        -0.9805808067321777
      ],
      "plane_d": 179.3529510498047,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1386750191450119,
        -0.1386750191450119,
        -0.9805806875228882
      ],
      "plane_d": 157.16493225097656,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05075809732079506,
        -0.18943364918231964,
        -0.9805806875228882
      ],
      "plane_d": 408.2672424316406,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1832.178466796875,
        1817.990234375,
        159.51780700683594
      ],
      "bbox_max": [
        1841.4931640625,
        1820.4000244140625,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8320565223693848,
        -8.457233889203053e-06,
        -0.5546908378601074
      ],
      "plane_d": -1435.9776611328125,
      "bbox_min": [
        1832.178466796875,
        1817.990234375,
        159.51780700683594
      ],
      "bbox_max": [
        1832.4998779296875,
        1820.4000244140625,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0507580041885376,
        -0.1894332766532898,
        -0.9805808067321777
      ],
      "plane_d": 595.0562133789062,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1840.0,
        1817.9903564453125,
        159.51783752441406
      ],
      "bbox_max": [
        1847.8214111328125,
        1820.4000244140625,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8320510387420654,
        3.133890686513041e-06,
        -0.5546990633010864
      ],
      "plane_d": 1625.9603271484375,
      "bbox_min": [
        1847.5,
        1817.9903564453125,
        159.51783752441406
      ],
      "bbox_max": [
        1847.8214111328125,
        1820.4000244140625,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05075879767537117,
        0.1894325464963913,
        -0.9805808663368225
      ],
      "plane_d": -71.74618530273438,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1841.492919921875,
        1700.4000244140625,
        159.67794799804688
      ],
      "bbox_max": [
        1847.7147216796875,
        1702.0096435546875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320565223693848,
        -0.0,
        -0.5546908378601074
      ],
      "plane_d": 1625.9749755859375,
      "bbox_min": [
        1847.5,
        1700.4000244140625,
        159.67794799804688
      ],
      "bbox_max": [
        1847.7147216796875,
        1702.0096435546875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0507580041885376,
        0.1894332766532898,
        -0.9805808067321777
      ],
      "plane_d": -258.538330078125,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1832.28515625,
        1700.4000244140625,
        159.677978515625
      ],
      "bbox_max": [
        1838.5069580078125,
        1702.009521484375,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320557475090027,
        3.213253194189747e-06,
        -0.5546919107437134
      ],
      "plane_d": -1435.996826171875,
      "bbox_min": [
        1832.28515625,
        1700.4000244140625,
        159.677978515625
      ],
      "bbox_max": [
        1832.4998779296875,
        1702.009521484375,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": 184.04165649414062,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883490443229675,
        -0.5883490443229675,
        -0.5546990036964417
      ],
      "plane_d": 89.90592956542969,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883490443229675,
        0.5883490443229675,
        0.5546989440917969
      ],
      "plane_d": 14.858566284179688,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        -0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": -79.27729797363281,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": -1981.08251953125,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": 2255.030029296875,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": -2150.265625,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": 2085.846923828125,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036982417106628,
        -0.21534967422485352,
        -0.5547013878822327
      ],
      "plane_d": 1994.7943115234375,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036984801292419,
        0.2153497189283371,
        -0.5547010898590088
      ],
      "plane_d": 1236.7637939453125,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036982417106628,
        0.21534967422485352,
        -0.5547013878822327
      ],
      "plane_d": -1720.8460693359375,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036982417106628,
        -0.21534952521324158,
        0.5547013878822327
      ],
      "plane_d": 1825.610107421875,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036984801292419,
        0.21534956991672516,
        0.5547010898590088
      ],
      "plane_d": 1067.5802001953125,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1905.1763916015625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036982417106628,
        0.21534952521324158,
        0.5547013878822327
      ],
      "plane_d": -1890.02978515625,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1872.588134765625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036984801292419,
        -0.2153497189283371,
        -0.5547010898590088
      ],
      "plane_d": -962.815673828125,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1872.588134765625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036988973617554,
        -0.21534748375415802,
        0.5547013878822327
      ],
      "plane_d": -1132.004150390625,
      "bbox_min": [
        1774.8236083984375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1872.588134765625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21534909307956696,
        -0.8036984205245972,
        -0.5547013282775879
      ],
      "plane_d": 1947.7255859375,
      "bbox_min": [
        1807.411865234375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1872.588134765625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320510387420654,
        3.133890686513041e-06,
        -0.5546990633010864
      ],
      "plane_d": 1625.9603271484375,
      "bbox_min": [
        1847.5,
        1817.9903564453125,
        155.28953552246094
      ],
      "bbox_max": [
        1850.6402587890625,
        1820.4000244140625,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2153484970331192,
        -0.8036980032920837,
        0.5547022223472595
      ],
      "plane_d": 1778.539794921875,
      "bbox_min": [
        1807.411865234375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1872.588134765625,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        0.0,
        0.5547001361846924
      ],
      "plane_d": 1456.7813720703125,
      "bbox_min": [
        1847.5,
        1817.9903564453125,
        145.0
      ],
      "bbox_max": [
        1850.6402587890625,
        1820.4000244140625,
        149.71046447753906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21534454822540283,
        -0.8036952018737793,
        -0.5547077059745789
      ],
      "plane_d": 1155.244384765625,
      "bbox_min": [
        1807.411865234375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1872.5880126953125,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320565223693848,
        -8.457233889203053e-06,
        -0.5546908378601074
      ],
      "plane_d": -1435.9776611328125,
      "bbox_min": [
        1829.359619140625,
        1817.990234375,
        155.28944396972656
      ],
      "bbox_max": [
        1832.4998779296875,
        1820.4000244140625,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21534575521945953,
        -0.8036996722221375,
        0.5547009110450745
      ],
      "plane_d": 986.0654296875,
      "bbox_min": [
        1807.411865234375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1872.5880126953125,
        1820.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320544958114624,
        -8.457213880319614e-06,
        0.5546938180923462
      ],
      "plane_d": -1605.155029296875,
      "bbox_min": [
        1829.359619140625,
        1817.990234375,
        145.0
      ],
      "bbox_max": [
        1832.4998779296875,
        1820.4000244140625,
        149.71055603027344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21534736454486847,
        0.8036937713623047,
        -0.5547088980674744
      ],
      "plane_d": -881.286865234375,
      "bbox_min": [
        1807.411865234375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1872.5880126953125,
        1769.82958984375,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320565223693848,
        -0.0,
        -0.5546908378601074
      ],
      "plane_d": 1625.9749755859375,
      "bbox_min": [
        1847.5,
        1700.4000244140625,
        156.85357666015625
      ],
      "bbox_max": [
        1849.5975341796875,
        1702.0096435546875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2153475135564804,
        0.8036943078041077,
        0.5547080039978027
      ],
      "plane_d": -1050.4736328125,
      "bbox_min": [
        1807.411865234375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1872.5880126953125,
        1769.82958984375,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320565223693848,
        0.0,
        0.5546908378601074
      ],
      "plane_d": 1456.794189453125,
      "bbox_min": [
        1847.5,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1849.5975341796875,
        1702.0096435546875,
        148.14642333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21534909307956696,
        0.8036984205245972,
        -0.5547013282775879
      ],
      "plane_d": -1673.7774658203125,
      "bbox_min": [
        1807.411865234375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320557475090027,
        3.213253194189747e-06,
        -0.5546919107437134
      ],
      "plane_d": -1435.996826171875,
      "bbox_min": [
        1830.40234375,
        1700.4000244140625,
        156.85362243652344
      ],
      "bbox_max": [
        1832.4998779296875,
        1702.009521484375,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2153553068637848,
        0.8037027716636658,
        0.5546925663948059
      ],
      "plane_d": -1842.978759765625,
      "bbox_min": [
        1807.411865234375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320556879043579,
        3.6571464079315774e-06,
        0.5546920895576477
      ],
      "plane_d": -1605.1785888671875,
      "bbox_min": [
        1830.40234375,
        1700.4000244140625,
        145.0
      ],
      "bbox_max": [
        1832.4998779296875,
        1702.009521484375,
        148.14637756347656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        -0.25881582498550415,
        -0.0
      ],
      "plane_d": 2222.3671875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        145.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        -0.0
      ],
      "plane_d": 2165.79833984375,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        145.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1332.2430419921875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        145.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1213.3560791015625,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        145.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.8985595703125,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        145.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        165.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": -2231.027587890625,
      "bbox_min": [
        1830.17041015625,
        1753.7060546875,
        145.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -2174.458740234375,
      "bbox_min": [
        1830.17041015625,
        1756.2940673828125,
        145.0
      ],
      "bbox_max": [
        1838.53564453125,
        1769.6334228515625,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.238525390625,
      "bbox_min": [
        1830.17041015625,
        1756.2940673828125,
        145.0
      ],
      "bbox_max": [
        1833.7060546875,
        1759.8297119140625,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1311.33544921875,
      "bbox_min": [
        1830.17041015625,
        1760.17041015625,
        145.0
      ],
      "bbox_max": [
        1837.803466796875,
        1769.6334228515625,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1234.263671875,
      "bbox_min": [
        1830.17041015625,
        1760.17041015625,
        145.0
      ],
      "bbox_max": [
        1837.803466796875,
        1769.6334228515625,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2541.25439453125,
      "bbox_min": [
        1830.17041015625,
        1760.17041015625,
        145.0
      ],
      "bbox_max": [
        1833.7059326171875,
        1763.7059326171875,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1323.5828857421875,
      "bbox_min": [
        1835.5621337890625,
        1754.17138671875,
        145.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": -2243.27490234375,
      "bbox_min": [
        1842.1966552734375,
        1760.17041015625,
        145.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.6334228515625,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -2186.705810546875,
      "bbox_min": [
        1842.1966552734375,
        1760.17041015625,
        145.0
      ],
      "bbox_max": [
        1848.5355224609375,
        1769.6334228515625,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        -0.0
      ],
      "plane_d": 2178.045654296875,
      "bbox_min": [
        1842.1966552734375,
        1760.17041015625,
        145.0
      ],
      "bbox_max": [
        1846.2940673828125,
        1761.268310546875,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1836.2940673828125,
        1761.268310546875,
        145.0
      ],
      "bbox_max": [
        1844.4381103515625,
        1769.82958984375,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1319.99560546875,
      "bbox_min": [
        1837.803466796875,
        1761.268310546875,
        145.0
      ],
      "bbox_max": [
        1842.1966552734375,
        1766.2940673828125,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1225.603515625,
      "bbox_min": [
        1837.803466796875,
        1761.268310546875,
        145.0
      ],
      "bbox_max": [
        1838.5355224609375,
        1761.4644775390625,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        -0.25881582498550415,
        -0.0
      ],
      "plane_d": 2234.614501953125,
      "bbox_min": [
        1840.2952880859375,
        1761.268310546875,
        145.0
      ],
      "bbox_max": [
        1842.1966552734375,
        1765.828125,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        -0.0
      ],
      "plane_d": 2178.045654296875,
      "bbox_min": [
        1841.4644775390625,
        1761.268310546875,
        145.0
      ],
      "bbox_max": [
        1842.1966552734375,
        1761.4644775390625,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -2186.705810546875,
      "bbox_min": [
        1840.17041015625,
        1765.828125,
        145.0
      ],
      "bbox_max": [
        1844.4381103515625,
        1769.82958984375,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1840.17041015625,
        1765.828125,
        145.0
      ],
      "bbox_max": [
        1843.7059326171875,
        1769.82958984375,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        -0.25881582498550415,
        -0.0
      ],
      "plane_d": 2234.614501953125,
      "bbox_min": [
        1840.17041015625,
        1765.828125,
        145.0
      ],
      "bbox_max": [
        1840.2952880859375,
        1766.2940673828125,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1323.5828857421875,
      "bbox_min": [
        1840.17041015625,
        1753.7059326171875,
        145.0
      ],
      "bbox_max": [
        1849.82958984375,
        1759.82958984375,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1846.2940673828125,
        1756.2940673828125,
        145.0
      ],
      "bbox_max": [
        1849.82958984375,
        1759.82958984375,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.707105815410614,
        0.7071077823638916,
        0.0
      ],
      "plane_d": -59.6290283203125,
      "bbox_min": [
        1655.0,
        1820.39990234375,
        145.0
      ],
      "bbox_max": [
        2025.0,
        1950.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707105815410614,
        0.7071077823638916,
        -0.0
      ],
      "plane_d": -2661.7783203125,
      "bbox_min": [
        1780.0,
        1820.4000244140625,
        145.0
      ],
      "bbox_max": [
        2025.0,
        1950.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588178515434265,
        0.9659262299537659,
        0.0
      ],
      "plane_d": -2292.55224609375,
      "bbox_min": [
        1780.0,
        1820.4000244140625,
        145.0
      ],
      "bbox_max": [
        1900.0,
        1910.0001220703125,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.2588156461715698,
        0.9659267067909241,
        2.5568255296093412e-05
      ],
      "plane_d": -1340.1116943359375,
      "bbox_min": [
        1780.0,
        1820.4000244140625,
        145.0
      ],
      "bbox_max": [
        1874.0001220703125,
        1880.39990234375,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1802.9998779296875,
        1820.4000244140625,
        145.0
      ],
      "bbox_max": [
        1874.0001220703125,
        1880.39990234375,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.2572184205055237,
        -0.9663532972335815,
        0.0
      ],
      "plane_d": 1341.9161376953125,
      "bbox_min": [
        1802.9998779296875,
        1824.9998779296875,
        160.0
      ],
      "bbox_max": [
        1869.0,
        1878.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2604372203350067,
        -0.9654908776283264,
        0.0
      ],
      "plane_d": 2292.782470703125,
      "bbox_min": [
        1802.9998779296875,
        1824.9998779296875,
        160.0
      ],
      "bbox_max": [
        1869.0,
        1878.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1850.4000244140625,
      "bbox_min": [
        1802.9998779296875,
        1824.9998779296875,
        160.0
      ],
      "bbox_max": [
        1869.0,
        1870.577392578125,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -1.220688227476785e-05,
        0.0
      ],
      "plane_d": -1802.9776611328125,
      "bbox_min": [
        1802.9998779296875,
        1824.9998779296875,
        160.0
      ],
      "bbox_max": [
        1818.0001220703125,
        1845.0001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.137954864650965e-06,
        1.0,
        0.0
      ],
      "plane_d": -1824.9852294921875,
      "bbox_min": [
        1802.9998779296875,
        1824.9998779296875,
        160.0
      ],
      "bbox_max": [
        1818.0001220703125,
        1845.0001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.138087650877424e-06,
        -1.0,
        -0.0
      ],
      "plane_d": 1845.0147705078125,
      "bbox_min": [
        1803.0001220703125,
        1825.0,
        160.0
      ],
      "bbox_max": [
        1818.0001220703125,
        1845.0001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -1.2207180589030031e-05,
        -0.0
      ],
      "plane_d": 1818.0224609375,
      "bbox_min": [
        1818.0,
        1825.0,
        160.0
      ],
      "bbox_max": [
        1818.0001220703125,
        1845.0,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1869.0,
      "bbox_min": [
        1810.0,
        1850.4000244140625,
        160.0
      ],
      "bbox_max": [
        1869.0,
        1870.577392578125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1810.0,
      "bbox_min": [
        1810.0,
        1850.4000244140625,
        160.0
      ],
      "bbox_max": [
        1810.0,
        1870.414794921875,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2572184205055237,
        -0.9663532972335815,
        0.0
      ],
      "plane_d": 1341.9161376953125,
      "bbox_min": [
        1802.9998779296875,
        1820.4000244140625,
        145.0
      ],
      "bbox_max": [
        1874.0001220703125,
        1880.39990234375,
        160.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 157.0,
      "bbox_min": [
        1805.0,
        1869.083984375,
        148.0
      ],
      "bbox_max": [
        1843.7442626953125,
        1880.39990234375,
        157.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1810.0,
      "bbox_min": [
        1805.0,
        1869.083984375,
        148.0
      ],
      "bbox_max": [
        1810.0,
        1872.361572265625,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1870.414794921875,
      "bbox_min": [
        1805.0,
        1869.083984375,
        148.0
      ],
      "bbox_max": [
        1810.0,
        1870.414794921875,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486833810806274,
        0.0,
        0.3162277936935425
      ],
      "plane_d": -1761.3887939453125,
      "bbox_min": [
        1805.0,
        1869.083984375,
        148.0
      ],
      "bbox_max": [
        1810.0,
        1870.414794921875,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3162277936935425,
        -0.0,
        0.9486833810806274
      ],
      "plane_d": -712.7774658203125,
      "bbox_min": [
        1807.0,
        1869.6163330078125,
        148.0
      ],
      "bbox_max": [
        1810.0,
        1870.414794921875,
        149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2604372203350067,
        0.9654908776283264,
        0.0
      ],
      "plane_d": -2292.782470703125,
      "bbox_min": [
        1802.9998779296875,
        1820.4000244140625,
        145.0
      ],
      "bbox_max": [
        1874.0001220703125,
        1879.3966064453125,
        160.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8320510387420654,
        3.133890686513041e-06,
        -0.5546990633010864
      ],
      "plane_d": 1625.9603271484375,
      "bbox_min": [
        1802.9998779296875,
        1820.4000244140625,
        145.0
      ],
      "bbox_max": [
        1874.0001220703125,
        1870.577392578125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -1.627604251552839e-05
      ],
      "plane_d": -1850.3975830078125,
      "bbox_min": [
        1847.5001220703125,
        1820.4000244140625,
        145.0
      ],
      "bbox_max": [
        1874.0001220703125,
        1870.577392578125,
        160.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.2153484970331192,
        -0.8036980032920837,
        0.5547022223472595
      ],
      "plane_d": 1778.539794921875,
      "bbox_min": [
        1852.5,
        1820.4000244140625,
        150.85751342773438
      ],
      "bbox_max": [
        1857.82568359375,
        1821.8270263671875,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1869.0,
      "bbox_min": [
        1869.0,
        1850.4000244140625,
        145.0
      ],
      "bbox_max": [
        1874.0001220703125,
        1870.577392578125,
        160.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 155.0,
      "bbox_min": [
        1869.0,
        1850.4000244140625,
        148.0
      ],
      "bbox_max": [
        1874.0001220703125,
        1870.577392578125,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        0.0,
        0.5547001361846924
      ],
      "plane_d": 1456.7813720703125,
      "bbox_min": [
        1802.9998779296875,
        1820.4000244140625,
        145.0
      ],
      "bbox_max": [
        1857.5,
        1870.414794921875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1850.4000244140625,
      "bbox_min": [
        1847.5001220703125,
        1820.4000244140625,
        145.0
      ],
      "bbox_max": [
        1857.5,
        1850.400146484375,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2153484970331192,
        -0.8036980032920837,
        0.5547022223472595
      ],
      "plane_d": 1778.539794921875,
      "bbox_min": [
        1850.6402587890625,
        1820.4000244140625,
        149.71046447753906
      ],
      "bbox_max": [
        1853.5948486328125,
        1821.8270263671875,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -1.220688227476785e-05,
        0.0
      ],
      "plane_d": -1802.9776611328125,
      "bbox_min": [
        1802.9998779296875,
        1820.4000244140625,
        145.0
      ],
      "bbox_max": [
        1832.5,
        1870.414794921875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1850.4000244140625,
      "bbox_min": [
        1802.9998779296875,
        1820.4000244140625,
        145.0
      ],
      "bbox_max": [
        1832.5,
        1870.414794921875,
        160.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -8.137954864650965e-06,
        1.0,
        0.0
      ],
      "plane_d": -1824.9852294921875,
      "bbox_min": [
        1802.9998779296875,
        1820.4000244140625,
        145.0
      ],
      "bbox_max": [
        1832.5,
        1850.4000244140625,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320544958114624,
        -8.457213880319614e-06,
        0.5546938180923462
      ],
      "plane_d": -1605.155029296875,
      "bbox_min": [
        1822.17431640625,
        1820.4000244140625,
        145.0
      ],
      "bbox_max": [
        1832.4998779296875,
        1825.0001220703125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21534575521945953,
        -0.8036996722221375,
        0.5547009110450745
      ],
      "plane_d": 986.0654296875,
      "bbox_min": [
        1822.17431640625,
        1820.4000244140625,
        149.71055603027344
      ],
      "bbox_max": [
        1829.359619140625,
        1821.8270263671875,
        154.14244079589844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21534454822540283,
        -0.8036952018737793,
        -0.5547077059745789
      ],
      "plane_d": 1155.244384765625,
      "bbox_min": [
        1822.17431640625,
        1820.4000244140625,
        152.5
      ],
      "bbox_max": [
        1827.5,
        1821.8270263671875,
        154.14244079589844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320565223693848,
        -8.457233889203053e-06,
        -0.5546908378601074
      ],
      "plane_d": -1435.9776611328125,
      "bbox_min": [
        1826.405029296875,
        1820.4000244140625,
        152.5
      ],
      "bbox_max": [
        1832.4998779296875,
        1825.0001220703125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21534454822540283,
        -0.8036952018737793,
        -0.5547077059745789
      ],
      "plane_d": 1155.244384765625,
      "bbox_min": [
        1826.405029296875,
        1820.4000244140625,
        152.5
      ],
      "bbox_max": [
        1829.359619140625,
        1821.8270263671875,
        155.28944396972656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.138087650877424e-06,
        -1.0,
        0.0
      ],
      "plane_d": 1845.0147705078125,
      "bbox_min": [
        1803.0001220703125,
        1825.0,
        145.0
      ],
      "bbox_max": [
        1832.5,
        1850.4000244140625,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320565819740295,
        -0.0,
        0.5546908378601074
      ],
      "plane_d": -1605.173828125,
      "bbox_min": [
        1827.5,
        1844.9998779296875,
        145.0
      ],
      "bbox_max": [
        1832.5,
        1850.4000244140625,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320565223693848,
        9.766380571818445e-06,
        -0.5546908378601074
      ],
      "plane_d": -1436.010986328125,
      "bbox_min": [
        1827.5,
        1844.9998779296875,
        152.5
      ],
      "bbox_max": [
        1832.5,
        1850.4000244140625,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.4413466235273518e-05,
        0.0
      ],
      "plane_d": 1817.9554443359375,
      "bbox_min": [
        1818.0,
        1825.0,
        145.0
      ],
      "bbox_max": [
        1832.5,
        1845.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.627577694307547e-05,
        1.0,
        2.712629793677479e-05
      ],
      "plane_d": -1829.9744873046875,
      "bbox_min": [
        1818.0,
        1825.0001220703125,
        145.0
      ],
      "bbox_max": [
        1832.5,
        1844.9998779296875,
        160.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8320544958114624,
        -8.457213880319614e-06,
        0.5546938180923462
      ],
      "plane_d": -1605.155029296875,
      "bbox_min": [
        1827.5,
        1825.0001220703125,
        145.0
      ],
      "bbox_max": [
        1832.5,
        1830.0001220703125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320565223693848,
        -8.457233889203053e-06,
        -0.5546908378601074
      ],
      "plane_d": -1435.9776611328125,
      "bbox_min": [
        1827.5,
        1825.0001220703125,
        152.5
      ],
      "bbox_max": [
        1832.5,
        1830.0001220703125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -1.627604251552839e-05
      ],
      "plane_d": 1840.0025634765625,
      "bbox_min": [
        1818.0,
        1840.0,
        145.0
      ],
      "bbox_max": [
        1832.5,
        1844.9998779296875,
        160.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8320565819740295,
        -0.0,
        0.5546908378601074
      ],
      "plane_d": -1605.173828125,
      "bbox_min": [
        1827.5001220703125,
        1840.0,
        145.0
      ],
      "bbox_max": [
        1832.5,
        1844.9998779296875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320565223693848,
        9.766380571818445e-06,
        -0.5546908378601074
      ],
      "plane_d": -1436.010986328125,
      "bbox_min": [
        1827.5001220703125,
        1840.0,
        152.5
      ],
      "bbox_max": [
        1832.5,
        1844.9998779296875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1810.0,
      "bbox_min": [
        1804.9998779296875,
        1850.39990234375,
        145.0
      ],
      "bbox_max": [
        1810.0,
        1870.414794921875,
        160.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 155.0,
      "bbox_min": [
        1804.9998779296875,
        1850.39990234375,
        148.0
      ],
      "bbox_max": [
        1810.0,
        1870.414794921875,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 157.0,
      "bbox_min": [
        1840.0,
        1869.228515625,
        148.0
      ],
      "bbox_max": [
        1874.0001220703125,
        1879.3966064453125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.4413466235273518e-05,
        -0.9999999403953552,
        1.2206733117636759e-05
      ],
      "plane_d": 1870.52978515625,
      "bbox_min": [
        1869.0,
        1869.228515625,
        148.0
      ],
      "bbox_max": [
        1874.0001220703125,
        1870.5775146484375,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833810806274,
        5.739369953516871e-06,
        0.3162277936935425
      ],
      "plane_d": 1728.8067626953125,
      "bbox_min": [
        1869.0,
        1869.228515625,
        148.0
      ],
      "bbox_max": [
        1874.0001220703125,
        1870.5775146484375,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162277936935425,
        0.0,
        0.9486833810806274
      ],
      "plane_d": 450.62457275390625,
      "bbox_min": [
        1869.0,
        1869.7679443359375,
        148.0
      ],
      "bbox_max": [
        1872.0,
        1870.577392578125,
        149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.2207180589030031e-05,
        -0.0
      ],
      "plane_d": -1845.0233154296875,
      "bbox_min": [
        1835.0001220703125,
        1900.0001220703125,
        145.0
      ],
      "bbox_max": [
        1845.0001220703125,
        1910.0001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2207180589030031e-05,
        1.0,
        0.0
      ],
      "plane_d": -1910.0225830078125,
      "bbox_min": [
        1835.0001220703125,
        1910.0,
        145.0
      ],
      "bbox_max": [
        1845.0,
        1910.0001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5299978256225586,
        -0.847999095916748
      ],
      "plane_d": 1152.215576171875,
      "bbox_min": [
        1885.0,
        1899.9998779296875,
        145.0
      ],
      "bbox_max": [
        2025.0,
        1950.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5299989581108093,
        0.8479983806610107
      ],
      "plane_d": -1156.457763671875,
      "bbox_min": [
        2015.0,
        1910.0,
        145.0
      ],
      "bbox_max": [
        2025.0,
        1950.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 2015.0,
      "bbox_min": [
        2015.0,
        1910.0,
        145.0
      ],
      "bbox_max": [
        2015.0,
        1950.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.4413466235273518e-05,
        0.0
      ],
      "plane_d": 1934.9534912109375,
      "bbox_min": [
        1885.0,
        1899.9998779296875,
        145.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.4413466235273518e-05,
        0.0
      ],
      "plane_d": 1989.9534912109375,
      "bbox_min": [
        1934.9998779296875,
        1899.9998779296875,
        145.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.4413466235273518e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1899.9512939453125,
      "bbox_min": [
        1989.9998779296875,
        1899.9998779296875,
        145.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2207180589030031e-05,
        1.0,
        0.0
      ],
      "plane_d": -1910.0244140625,
      "bbox_min": [
        1990.0001220703125,
        1900.0001220703125,
        145.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.2207180589030031e-05,
        -0.0
      ],
      "plane_d": -2000.0233154296875,
      "bbox_min": [
        2000.0,
        1900.0001220703125,
        145.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.4413466235273518e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1899.95263671875,
      "bbox_min": [
        1934.9998779296875,
        1899.9998779296875,
        145.0
      ],
      "bbox_max": [
        1945.0001220703125,
        1910.0001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1910.0001220703125,
      "bbox_min": [
        1935.0001220703125,
        1900.0001220703125,
        145.0
      ],
      "bbox_max": [
        1945.0001220703125,
        1910.0001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1945.0001220703125,
      "bbox_min": [
        1945.0001220703125,
        1900.0001220703125,
        145.0
      ],
      "bbox_max": [
        1945.0001220703125,
        1910.0001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1885.0,
      "bbox_min": [
        1885.0,
        1900.0,
        145.0
      ],
      "bbox_max": [
        1895.0,
        1910.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1900.0,
      "bbox_min": [
        1885.0,
        1900.0,
        145.0
      ],
      "bbox_max": [
        1895.0,
        1910.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1910.0,
      "bbox_min": [
        1885.0,
        1900.0,
        145.0
      ],
      "bbox_max": [
        1895.0,
        1910.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1895.0,
      "bbox_min": [
        1895.0,
        1900.0,
        145.0
      ],
      "bbox_max": [
        1895.0,
        1910.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5300001502037048,
        -0.8479976654052734
      ],
      "plane_d": 1152.219970703125,
      "bbox_min": [
        1655.0,
        1900.0,
        145.0
      ],
      "bbox_max": [
        1795.0,
        1950.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5299989581108093,
        0.8479983806610107
      ],
      "plane_d": -1156.457763671875,
      "bbox_min": [
        1655.0,
        1910.0,
        145.0
      ],
      "bbox_max": [
        1665.0,
        1950.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        3.0517671802954283e-06,
        0.0
      ],
      "plane_d": -1665.005859375,
      "bbox_min": [
        1664.9998779296875,
        1910.0,
        145.0
      ],
      "bbox_max": [
        1665.0,
        1949.9998779296875,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1745.0,
      "bbox_min": [
        1680.0001220703125,
        1900.0,
        145.0
      ],
      "bbox_max": [
        1795.0,
        1910.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.220703143189894e-05,
        -0.0
      ],
      "plane_d": -1690.0233154296875,
      "bbox_min": [
        1680.0001220703125,
        1900.0,
        145.0
      ],
      "bbox_max": [
        1745.0,
        1910.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.220703143189894e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1900.0206298828125,
      "bbox_min": [
        1680.0001220703125,
        1900.0,
        145.0
      ],
      "bbox_max": [
        1690.0001220703125,
        1910.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1680.0001220703125,
      "bbox_min": [
        1680.0001220703125,
        1900.0001220703125,
        145.0
      ],
      "bbox_max": [
        1690.0,
        1910.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1910.0,
      "bbox_min": [
        1680.0001220703125,
        1910.0,
        145.0
      ],
      "bbox_max": [
        1690.0,
        1910.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1910.0,
      "bbox_min": [
        1735.0,
        1900.0,
        145.0
      ],
      "bbox_max": [
        1745.0,
        1910.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2207180589030031e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1900.0213623046875,
      "bbox_min": [
        1735.0,
        1900.0,
        145.0
      ],
      "bbox_max": [
        1745.0,
        1910.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -1.2207180589030031e-05,
        -0.0
      ],
      "plane_d": 1735.0233154296875,
      "bbox_min": [
        1735.0,
        1900.0001220703125,
        145.0
      ],
      "bbox_max": [
        1735.0001220703125,
        1910.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1900.0,
      "bbox_min": [
        1785.0,
        1900.0,
        145.0
      ],
      "bbox_max": [
        1795.0,
        1910.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1795.0,
      "bbox_min": [
        1785.0,
        1900.0,
        145.0
      ],
      "bbox_max": [
        1795.0,
        1910.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1785.0,
      "bbox_min": [
        1785.0,
        1900.0,
        145.0
      ],
      "bbox_max": [
        1795.0,
        1910.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1910.0,
      "bbox_min": [
        1785.0,
        1910.0,
        145.0
      ],
      "bbox_max": [
        1795.0,
        1910.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -172.19677734375,
      "bbox_min": [
        1655.0,
        1570.0,
        145.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1700.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2429.956298828125,
      "bbox_min": [
        1655.0,
        1570.0,
        145.0
      ],
      "bbox_max": [
        1899.9998779296875,
        1700.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881847739219666,
        -0.9659260511398315,
        -1.176710156869376e-05
      ],
      "plane_d": 1108.281005859375,
      "bbox_min": [
        1780.0,
        1610.0,
        145.0
      ],
      "bbox_max": [
        1899.9998779296875,
        1700.4000244140625,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.2588183581829071,
        -0.9659260511398315,
        -0.0
      ],
      "plane_d": 2060.73095703125,
      "bbox_min": [
        1780.0,
        1640.4000244140625,
        145.0
      ],
      "bbox_max": [
        1874.0,
        1700.4000244140625,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1805.0,
        1640.4000244140625,
        145.0
      ],
      "bbox_max": [
        1874.0,
        1700.4000244140625,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.2572184205055237,
        0.9663532972335815,
        0.0
      ],
      "plane_d": -2060.420654296875,
      "bbox_min": [
        1810.0,
        1642.4000244140625,
        160.0
      ],
      "bbox_max": [
        1869.0001220703125,
        1700.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26043999195098877,
        0.9654901027679443,
        0.0
      ],
      "plane_d": -1106.511474609375,
      "bbox_min": [
        1810.0,
        1642.4000244140625,
        160.0
      ],
      "bbox_max": [
        1869.0001220703125,
        1700.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1670.4000244140625,
      "bbox_min": [
        1810.0,
        1650.2227783203125,
        160.0
      ],
      "bbox_max": [
        1869.0001220703125,
        1700.4000244140625,
        165.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.05075879767537117,
        0.1894325464963913,
        -0.9805808663368225
      ],
      "plane_d": -71.74618530273438,
      "bbox_min": [
        1838.507080078125,
        1700.0,
        160.0
      ],
      "bbox_max": [
        1841.492919921875,
        1700.4000244140625,
        160.07728576660156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0507580041885376,
        0.1894332766532898,
        -0.9805808067321777
      ],
      "plane_d": -258.538330078125,
      "bbox_min": [
        1838.507080078125,
        1700.0,
        160.0
      ],
      "bbox_max": [
        1840.0,
        1700.4000244140625,
        160.07728576660156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -1.2099872037651949e-05,
        -0.0
      ],
      "plane_d": 1869.0201416015625,
      "bbox_min": [
        1810.0,
        1650.2227783203125,
        160.0
      ],
      "bbox_max": [
        1869.0001220703125,
        1670.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1810.0,
      "bbox_min": [
        1810.0,
        1650.38525390625,
        160.0
      ],
      "bbox_max": [
        1810.0,
        1670.4000244140625,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2572184205055237,
        0.9663532972335815,
        0.0
      ],
      "plane_d": -2060.420654296875,
      "bbox_min": [
        1805.0,
        1640.4000244140625,
        145.0
      ],
      "bbox_max": [
        1874.0,
        1700.4000244140625,
        160.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 156.99998474121094,
      "bbox_min": [
        1805.0,
        1640.4000244140625,
        148.0
      ],
      "bbox_max": [
        1843.7447509765625,
        1651.7161865234375,
        157.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1810.0,
      "bbox_min": [
        1805.0,
        1648.4384765625,
        148.0
      ],
      "bbox_max": [
        1810.0,
        1651.7161865234375,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -1650.3851318359375,
      "bbox_min": [
        1805.0,
        1650.38525390625,
        148.0
      ],
      "bbox_max": [
        1810.0,
        1651.7161865234375,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486833810806274,
        0.0,
        0.3162277936935425
      ],
      "plane_d": -1761.3887939453125,
      "bbox_min": [
        1805.0,
        1650.38525390625,
        148.0
      ],
      "bbox_max": [
        1810.0,
        1651.7161865234375,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3162277936935425,
        -0.0,
        0.9486833810806274
      ],
      "plane_d": -712.7774658203125,
      "bbox_min": [
        1807.0,
        1650.38525390625,
        148.0
      ],
      "bbox_max": [
        1810.0,
        1651.183837890625,
        149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26043999195098877,
        0.9654901027679443,
        0.0
      ],
      "plane_d": -1106.511474609375,
      "bbox_min": [
        1805.0,
        1641.4034423828125,
        145.0
      ],
      "bbox_max": [
        1874.0,
        1700.4000244140625,
        160.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 157.0,
      "bbox_min": [
        1840.0,
        1641.4034423828125,
        148.0
      ],
      "bbox_max": [
        1874.0,
        1651.571533203125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1650.2227783203125,
      "bbox_min": [
        1869.0001220703125,
        1650.22265625,
        148.0
      ],
      "bbox_max": [
        1874.0,
        1651.571533203125,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486891031265259,
        -1.147901639342308e-05,
        0.31621038913726807
      ],
      "plane_d": 1728.8497314453125,
      "bbox_min": [
        1869.0001220703125,
        1650.22265625,
        148.0
      ],
      "bbox_max": [
        1874.0,
        1651.571533203125,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162277936935425,
        -3.826316060440149e-06,
        0.9486833810806274
      ],
      "plane_d": 450.6309814453125,
      "bbox_min": [
        1869.0001220703125,
        1650.2227783203125,
        148.0
      ],
      "bbox_max": [
        1872.0001220703125,
        1651.0321044921875,
        149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320565223693848,
        0.0,
        0.5546908378601074
      ],
      "plane_d": 1456.794189453125,
      "bbox_min": [
        1805.0,
        1650.22265625,
        145.0
      ],
      "bbox_max": [
        1874.0,
        1700.4000244140625,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -5.677721674146596e-06,
        -1.0,
        -1.2490987501223572e-05
      ],
      "plane_d": 1670.412353515625,
      "bbox_min": [
        1847.5,
        1650.22265625,
        145.0
      ],
      "bbox_max": [
        1874.0,
        1700.4000244140625,
        160.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.21534736454486847,
        0.8036937713623047,
        -0.5547088980674744
      ],
      "plane_d": -881.286865234375,
      "bbox_min": [
        1852.4998779296875,
        1698.1728515625,
        152.5
      ],
      "bbox_max": [
        1860.8118896484375,
        1700.4000244140625,
        155.06344604492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -1.2099872037651949e-05,
        -0.0
      ],
      "plane_d": 1869.0201416015625,
      "bbox_min": [
        1868.9998779296875,
        1650.22265625,
        145.0
      ],
      "bbox_max": [
        1874.0,
        1670.4000244140625,
        160.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 155.0,
      "bbox_min": [
        1868.9998779296875,
        1650.2227783203125,
        148.0
      ],
      "bbox_max": [
        1874.0,
        1670.4000244140625,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320565223693848,
        -0.0,
        -0.5546908378601074
      ],
      "plane_d": 1625.9749755859375,
      "bbox_min": [
        1805.0,
        1650.38525390625,
        145.0
      ],
      "bbox_max": [
        1857.4996337890625,
        1700.4000244140625,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -5.6777212193992455e-06,
        -1.0,
        -0.0
      ],
      "plane_d": 1670.4105224609375,
      "bbox_min": [
        1847.5,
        1670.39990234375,
        152.5
      ],
      "bbox_max": [
        1857.4996337890625,
        1700.4000244140625,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21534736454486847,
        0.8036937713623047,
        -0.5547088980674744
      ],
      "plane_d": -881.286865234375,
      "bbox_min": [
        1849.5975341796875,
        1698.1728515625,
        152.5
      ],
      "bbox_max": [
        1854.208740234375,
        1700.4000244140625,
        156.85357666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320557475090027,
        3.213253194189747e-06,
        -0.5546919107437134
      ],
      "plane_d": -1435.996826171875,
      "bbox_min": [
        1805.0,
        1650.38525390625,
        145.0
      ],
      "bbox_max": [
        1832.5,
        1700.4000244140625,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.975398264330579e-06,
        -1.0,
        -2.0926194338244386e-05
      ],
      "plane_d": 1670.3905029296875,
      "bbox_min": [
        1805.0,
        1650.38525390625,
        145.0
      ],
      "bbox_max": [
        1832.5,
        1700.4000244140625,
        160.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.2153553068637848,
        0.8037027716636658,
        0.5546925663948059
      ],
      "plane_d": -1842.978759765625,
      "bbox_min": [
        1819.1884765625,
        1698.1729736328125,
        149.9366455078125
      ],
      "bbox_max": [
        1827.5,
        1700.4000244140625,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1810.0,
      "bbox_min": [
        1805.0,
        1650.38525390625,
        145.0
      ],
      "bbox_max": [
        1810.0,
        1670.4000244140625,
        160.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 155.0,
      "bbox_min": [
        1805.0,
        1650.38525390625,
        148.0
      ],
      "bbox_max": [
        1810.0,
        1670.4000244140625,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320556879043579,
        3.6571464079315774e-06,
        0.5546920895576477
      ],
      "plane_d": -1605.1785888671875,
      "bbox_min": [
        1822.5001220703125,
        1670.4000244140625,
        145.0
      ],
      "bbox_max": [
        1832.5,
        1700.4000244140625,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1670.4000244140625,
      "bbox_min": [
        1822.5001220703125,
        1670.4000244140625,
        145.0
      ],
      "bbox_max": [
        1832.5,
        1700.4000244140625,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2153553068637848,
        0.8037027716636658,
        0.5546925663948059
      ],
      "plane_d": -1842.978759765625,
      "bbox_min": [
        1825.791015625,
        1698.1729736328125,
        148.14637756347656
      ],
      "bbox_max": [
        1830.40234375,
        1700.4000244140625,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1835.0,
        1610.0,
        145.0
      ],
      "bbox_max": [
        1845.0,
        1620.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1835.0,
      "bbox_min": [
        1835.0,
        1610.0,
        145.0
      ],
      "bbox_max": [
        1845.0,
        1620.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1845.0,
      "bbox_min": [
        1835.0,
        1610.0,
        145.0
      ],
      "bbox_max": [
        1845.0,
        1620.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1835.0,
        1610.0,
        145.0
      ],
      "bbox_max": [
        1845.0,
        1610.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5299989581108093,
        -0.8479983806610107
      ],
      "plane_d": -713.3786010742188,
      "bbox_min": [
        1655.0,
        1570.0,
        145.0
      ],
      "bbox_max": [
        1795.0001220703125,
        1620.0001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5299989581108093,
        0.8479983806610107
      ],
      "plane_d": 709.1386108398438,
      "bbox_min": [
        1655.0,
        1570.0,
        145.0
      ],
      "bbox_max": [
        1665.0,
        1610.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1665.0,
      "bbox_min": [
        1665.0,
        1570.0,
        145.0
      ],
      "bbox_max": [
        1665.0,
        1610.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1745.0,
      "bbox_min": [
        1680.0,
        1609.9998779296875,
        145.0
      ],
      "bbox_max": [
        1795.0001220703125,
        1620.0001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        1680.0,
        1610.0,
        145.0
      ],
      "bbox_max": [
        1745.0,
        1620.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1680.0,
        1610.0,
        145.0
      ],
      "bbox_max": [
        1690.0,
        1620.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1680.0,
        1610.0,
        145.0
      ],
      "bbox_max": [
        1690.0,
        1620.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1610.0,
        145.0
      ],
      "bbox_max": [
        1680.0,
        1620.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1735.0,
        1610.0,
        145.0
      ],
      "bbox_max": [
        1745.0,
        1620.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1735.0,
        1610.0,
        145.0
      ],
      "bbox_max": [
        1745.0,
        1620.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1735.0,
      "bbox_min": [
        1735.0,
        1610.0,
        145.0
      ],
      "bbox_max": [
        1735.0,
        1620.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -2.4413466235273518e-05,
        0.0
      ],
      "plane_d": -1794.9605712890625,
      "bbox_min": [
        1784.9998779296875,
        1609.9998779296875,
        145.0
      ],
      "bbox_max": [
        1795.0001220703125,
        1620.0001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.4413466235273518e-05,
        1.0,
        0.0
      ],
      "plane_d": -1619.956298828125,
      "bbox_min": [
        1784.9998779296875,
        1609.9998779296875,
        145.0
      ],
      "bbox_max": [
        1795.0001220703125,
        1620.0001220703125,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2207180589030031e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0218505859375,
      "bbox_min": [
        1784.9998779296875,
        1609.9998779296875,
        145.0
      ],
      "bbox_max": [
        1794.9998779296875,
        1619.9998779296875,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -1.2207180589030031e-05,
        0.0
      ],
      "plane_d": 1785.0196533203125,
      "bbox_min": [
        1784.9998779296875,
        1610.0,
        145.0
      ],
      "bbox_max": [
        1785.0,
        1619.9998779296875,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2939141015522182e-05,
        0.5300001502037048,
        -0.8479976654052734
      ],
      "plane_d": -713.3544921875,
      "bbox_min": [
        1885.0,
        1570.0,
        145.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1620.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2939084626850672e-05,
        -0.5299978256225586,
        0.847999095916748
      ],
      "plane_d": 709.1105346679688,
      "bbox_min": [
        2014.9998779296875,
        1570.0,
        145.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1609.9998779296875,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -3.0517671802954283e-06,
        -0.0
      ],
      "plane_d": 2015.0047607421875,
      "bbox_min": [
        2014.9998779296875,
        1570.0,
        145.0
      ],
      "bbox_max": [
        2015.0,
        1609.9998779296875,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1935.0,
      "bbox_min": [
        1885.0,
        1609.9998779296875,
        145.0
      ],
      "bbox_max": [
        2000.0,
        1620.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0,
      "bbox_min": [
        1935.0,
        1610.0,
        145.0
      ],
      "bbox_max": [
        2000.0,
        1620.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1990.0,
        1610.0,
        145.0
      ],
      "bbox_max": [
        2000.0,
        1620.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1990.0,
        1610.0,
        145.0
      ],
      "bbox_max": [
        2000.0,
        1620.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        2000.0,
        1610.0,
        145.0
      ],
      "bbox_max": [
        2000.0,
        1620.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1935.0,
        1610.0,
        145.0
      ],
      "bbox_max": [
        1945.0,
        1620.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1935.0,
        1610.0,
        145.0
      ],
      "bbox_max": [
        1945.0,
        1620.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1945.0,
      "bbox_min": [
        1945.0,
        1610.0,
        145.0
      ],
      "bbox_max": [
        1945.0,
        1620.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.220703143189894e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1610.02294921875,
      "bbox_min": [
        1885.0,
        1609.9998779296875,
        145.0
      ],
      "bbox_max": [
        1895.0,
        1619.9998779296875,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.220703143189894e-05,
        0.0
      ],
      "plane_d": -1895.0196533203125,
      "bbox_min": [
        1885.0,
        1609.9998779296875,
        145.0
      ],
      "bbox_max": [
        1895.0,
        1619.9998779296875,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1885.0,
      "bbox_min": [
        1885.0,
        1610.0,
        145.0
      ],
      "bbox_max": [
        1894.9998779296875,
        1619.9998779296875,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1619.9998779296875,
      "bbox_min": [
        1885.0,
        1619.9998779296875,
        145.0
      ],
      "bbox_max": [
        1894.9998779296875,
        1619.9998779296875,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1655.0,
        1555.0,
        119.99995422363281
      ],
      "bbox_max": [
        2025.0001220703125,
        1965.0001220703125,
        140.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1780.0,
      "bbox_min": [
        1655.0,
        1555.0,
        135.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1965.0001220703125,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        1.202938051392266e-06,
        0.0
      ],
      "plane_d": -1900.0018310546875,
      "bbox_min": [
        1780.0,
        1555.0,
        135.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1965.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.05075809732079506,
        -0.18943364918231964,
        -0.9805806875228882
      ],
      "plane_d": 383.7527160644531,
      "bbox_min": [
        1780.0,
        1700.0,
        135.0
      ],
      "bbox_max": [
        1900.0,
        1845.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -1.220688227476785e-05,
        0.0
      ],
      "plane_d": -1802.9776611328125,
      "bbox_min": [
        1802.9998779296875,
        1824.9998779296875,
        135.0
      ],
      "bbox_max": [
        1818.0001220703125,
        1845.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.137954864650965e-06,
        1.0,
        0.0
      ],
      "plane_d": -1824.9852294921875,
      "bbox_min": [
        1802.9998779296875,
        1824.9998779296875,
        135.0
      ],
      "bbox_max": [
        1818.0001220703125,
        1845.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.138087650877424e-06,
        -1.0,
        -0.0
      ],
      "plane_d": 1845.0147705078125,
      "bbox_min": [
        1803.0001220703125,
        1825.0,
        135.0
      ],
      "bbox_max": [
        1818.0001220703125,
        1845.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -1.2207180589030031e-05,
        -0.0
      ],
      "plane_d": 1818.0224609375,
      "bbox_min": [
        1818.0,
        1825.0,
        135.0
      ],
      "bbox_max": [
        1818.0001220703125,
        1845.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.05075879767537117,
        0.1894325464963913,
        -0.9805808663368225
      ],
      "plane_d": -96.26071166992188,
      "bbox_min": [
        1780.0,
        1700.0,
        135.0
      ],
      "bbox_max": [
        1900.0,
        1820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1894332617521286,
        -0.05075898766517639,
        -0.9805806875228882
      ],
      "plane_d": -115.47698974609375,
      "bbox_min": [
        1780.0,
        1700.0,
        135.0
      ],
      "bbox_max": [
        1900.0,
        1820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18943364918231964,
        -0.05075809732079506,
        -0.9805806875228882
      ],
      "plane_d": 581.6365966796875,
      "bbox_min": [
        1780.0,
        1700.0,
        135.0
      ],
      "bbox_max": [
        1900.0,
        1820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1894332766532898,
        0.0507580041885376,
        -0.9805808067321777
      ],
      "plane_d": 402.967529296875,
      "bbox_min": [
        1780.0,
        1700.0,
        135.0
      ],
      "bbox_max": [
        1900.0,
        1820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0507580041885376,
        0.1894332766532898,
        -0.9805808067321777
      ],
      "plane_d": -283.0528564453125,
      "bbox_min": [
        1780.0,
        1700.0,
        135.0
      ],
      "bbox_max": [
        1891.9615478515625,
        1820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18943364918231964,
        0.05075809732079506,
        -0.9805806875228882
      ],
      "plane_d": -294.1477966308594,
      "bbox_min": [
        1780.0,
        1708.0384521484375,
        135.0
      ],
      "bbox_max": [
        1891.9615478515625,
        1820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0507580041885376,
        -0.1894332766532898,
        -0.9805808067321777
      ],
      "plane_d": 570.5416870117188,
      "bbox_min": [
        1788.0384521484375,
        1708.0384521484375,
        135.0
      ],
      "bbox_max": [
        1891.9615478515625,
        1820.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1386750340461731,
        0.1386750340461731,
        -0.9805808067321777
      ],
      "plane_d": -355.4857177734375,
      "bbox_min": [
        1788.0384521484375,
        1708.0384521484375,
        135.0
      ],
      "bbox_max": [
        1891.9615478515625,
        1811.9615478515625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1386750340461731,
        -0.1386750340461731,
        -0.9805808067321777
      ],
      "plane_d": 642.9745483398438,
      "bbox_min": [
        1788.0384521484375,
        1708.0384521484375,
        135.0
      ],
      "bbox_max": [
        1891.9615478515625,
        1811.9615478515625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1386750340461731,
        0.1386750340461731,
        -0.9805808067321777
      ],
      "plane_d": 154.8384246826172,
      "bbox_min": [
        1788.0384521484375,
        1708.0384521484375,
        135.0
      ],
      "bbox_max": [
        1891.9615478515625,
        1811.9615478515625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1386750191450119,
        -0.1386750191450119,
        -0.9805806875228882
      ],
      "plane_d": 132.65040588378906,
      "bbox_min": [
        1788.0384521484375,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1811.9615478515625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": 2222.3671875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2165.79833984375,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1332.2431640625,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1213.35595703125,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1311.33544921875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1234.263671875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        -0.0
      ],
      "plane_d": -2243.27490234375,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2186.705810546875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        -0.0
      ],
      "plane_d": -2231.02734375,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2174.458740234375,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1763.7059326171875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.898681640625,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        135.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1759.8297119140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1830.17041015625,
        1756.2940673828125,
        135.0
      ],
      "bbox_max": [
        1833.7060546875,
        1759.8297119140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2541.25439453125,
      "bbox_min": [
        1830.17041015625,
        1760.17041015625,
        135.0
      ],
      "bbox_max": [
        1837.80322265625,
        1763.7059326171875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1225.603515625,
      "bbox_min": [
        1833.7059326171875,
        1760.17041015625,
        135.0
      ],
      "bbox_max": [
        1837.80322265625,
        1761.268310546875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1840.17041015625,
        1753.7059326171875,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1759.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1323.5828857421875,
      "bbox_min": [
        1840.17041015625,
        1753.7059326171875,
        135.0
      ],
      "bbox_max": [
        1841.4644775390625,
        1758.5355224609375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": 2234.614501953125,
      "bbox_min": [
        1836.2940673828125,
        1760.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1840.17041015625,
        1760.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.8985595703125,
      "bbox_min": [
        1841.4644775390625,
        1760.17041015625,
        135.0
      ],
      "bbox_max": [
        1849.82958984375,
        1763.7059326171875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2178.045654296875,
      "bbox_min": [
        1841.4644775390625,
        1760.17041015625,
        135.0
      ],
      "bbox_max": [
        1846.2940673828125,
        1761.4644775390625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1836.2940673828125,
        1761.268310546875,
        135.0
      ],
      "bbox_max": [
        1839.82958984375,
        1769.82958984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1319.99560546875,
      "bbox_min": [
        1837.80322265625,
        1761.268310546875,
        135.0
      ],
      "bbox_max": [
        1839.82958984375,
        1766.2940673828125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1225.603515625,
      "bbox_min": [
        1837.80322265625,
        1761.268310546875,
        135.0
      ],
      "bbox_max": [
        1838.5355224609375,
        1761.4644775390625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9663520455360413,
        0.25722306966781616,
        -4.129499211558141e-05
      ],
      "plane_d": -2346.757080078125,
      "bbox_min": [
        1930.0,
        1700.4000244140625,
        135.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9654906392097473,
        -0.26043805480003357,
        0.0
      ],
      "plane_d": -1433.99072265625,
      "bbox_min": [
        1930.0,
        1700.4000244140625,
        135.0
      ],
      "bbox_max": [
        1960.0,
        1790.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9663532972335815,
        -0.2572184205055237,
        0.0
      ],
      "plane_d": 2344.82421875,
      "bbox_min": [
        1930.0,
        1731.0001220703125,
        135.0
      ],
      "bbox_max": [
        1958.0,
        1790.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9654915928840637,
        0.26043444871902466,
        0.0
      ],
      "plane_d": 1432.06787109375,
      "bbox_min": [
        1930.0,
        1731.0001220703125,
        135.0
      ],
      "bbox_max": [
        1958.0,
        1790.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1930.0,
      "bbox_min": [
        1930.0,
        1731.0001220703125,
        135.0
      ],
      "bbox_max": [
        1950.177490234375,
        1790.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1731.0001220703125,
      "bbox_min": [
        1930.0,
        1731.0001220703125,
        135.0
      ],
      "bbox_max": [
        1950.177490234375,
        1790.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1790.0,
      "bbox_min": [
        1930.0,
        1790.0,
        135.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1790.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.220703143189894e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 1855.0244140625,
      "bbox_min": [
        1989.9998779296875,
        1755.0,
        135.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.4413466235273518e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1899.9512939453125,
      "bbox_min": [
        1989.9998779296875,
        1855.0,
        135.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.4413466235273518e-05,
        0.0
      ],
      "plane_d": 1989.9534912109375,
      "bbox_min": [
        1989.9998779296875,
        1899.9998779296875,
        135.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.2207180589030031e-05,
        0.0
      ],
      "plane_d": -2000.0233154296875,
      "bbox_min": [
        2000.0,
        1900.0001220703125,
        135.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.220703143189894e-05,
        0.0
      ],
      "plane_d": -2000.022705078125,
      "bbox_min": [
        1990.0001220703125,
        1855.0,
        135.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1865.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0001220703125,
      "bbox_min": [
        1990.0001220703125,
        1855.0001220703125,
        135.0
      ],
      "bbox_max": [
        1990.0001220703125,
        1865.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1765.0,
      "bbox_min": [
        1990.0,
        1755.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1815.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -1.2207180589030031e-05,
        0.0
      ],
      "plane_d": 1990.0216064453125,
      "bbox_min": [
        1990.0,
        1755.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1765.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2207180589030031e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 1755.0244140625,
      "bbox_min": [
        1990.0001220703125,
        1755.0,
        135.0
      ],
      "bbox_max": [
        1998.5230712890625,
        1755.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        2000.0,
        1805.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1815.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2939084626850672e-05,
        -0.5299978256225586,
        0.847999095916748
      ],
      "plane_d": 730.310546875,
      "bbox_min": [
        1990.0,
        1593.9998779296875,
        135.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1756.4769287109375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.856886451103492e-06,
        0.5386186838150024,
        -0.8425496816635132
      ],
      "plane_d": -749.226806640625,
      "bbox_min": [
        1990.0,
        1593.9998779296875,
        135.0
      ],
      "bbox_max": [
        2025.0001220703125,
        1756.4769287109375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -2.5649475599021088e-11,
        -4.882771008851705e-06
      ],
      "plane_d": 2015.0006103515625,
      "bbox_min": [
        2014.9998779296875,
        1593.9998779296875,
        135.0
      ],
      "bbox_max": [
        2014.9998779296875,
        1609.9998779296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0,
      "bbox_min": [
        1990.0,
        1610.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1620.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        1990.0,
        1610.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1620.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1990.0,
        1610.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1610.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0,
      "bbox_min": [
        1990.0,
        1655.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1665.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        1990.0,
        1655.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1665.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1655.0,
      "bbox_min": [
        1990.0,
        1655.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1655.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1715.0,
      "bbox_min": [
        1990.0,
        1705.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1756.4769287109375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0,
      "bbox_min": [
        1990.0,
        1705.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1715.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        1990.0,
        1705.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1715.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1705.0,
      "bbox_min": [
        1990.0,
        1705.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1705.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2207180589030031e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 1755.0244140625,
      "bbox_min": [
        1998.5230712890625,
        1755.0,
        135.0
      ],
      "bbox_max": [
        2000.0,
        1756.4769287109375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9663541316986084,
        0.257215291261673,
        0.0
      ],
      "plane_d": 1209.43017578125,
      "bbox_min": [
        1680.0,
        1610.0,
        135.0
      ],
      "bbox_max": [
        1750.0001220703125,
        1820.39990234375,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9654934406280518,
        -0.2604275941848755,
        6.466050399467349e-05
      ],
      "plane_d": 2118.992919921875,
      "bbox_min": [
        1682.736083984375,
        1610.0,
        135.0
      ],
      "bbox_max": [
        1750.0001220703125,
        1790.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9663532972335815,
        -0.2572184205055237,
        0.0
      ],
      "plane_d": -1211.35595703125,
      "bbox_min": [
        1722.0,
        1731.0,
        135.0
      ],
      "bbox_max": [
        1750.0001220703125,
        1790.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9654908776283264,
        0.2604372203350067,
        0.0
      ],
      "plane_d": -2120.94482421875,
      "bbox_min": [
        1722.0,
        1731.0,
        135.0
      ],
      "bbox_max": [
        1750.0001220703125,
        1790.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        1729.8226318359375,
        1731.0,
        135.0
      ],
      "bbox_max": [
        1750.0001220703125,
        1790.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1731.0,
      "bbox_min": [
        1729.8226318359375,
        1731.0,
        135.0
      ],
      "bbox_max": [
        1750.0,
        1790.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1790.0,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        135.0
      ],
      "bbox_max": [
        1750.0,
        1790.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        1682.736083984375,
        1610.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1620.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1682.736083984375,
        1620.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1620.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1665.0,
      "bbox_min": [
        1680.0,
        1610.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1765.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1610.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1665.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        1680.0,
        1620.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1665.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1680.0,
        1620.0,
        135.0
      ],
      "bbox_max": [
        1682.736083984375,
        1620.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1755.0,
        135.0
      ],
      "bbox_max": [
        1680.0,
        1764.3232421875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.2207180589030031e-05,
        0.0
      ],
      "plane_d": -1690.0208740234375,
      "bbox_min": [
        1689.9998779296875,
        1705.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1714.9998779296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.9238043427758384e-06,
        -0.515036940574646,
        -0.8571680784225464
      ],
      "plane_d": 1103.7305908203125,
      "bbox_min": [
        1655.0,
        1764.3232421875,
        135.0
      ],
      "bbox_max": [
        1690.0001220703125,
        1926.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5299989581108093,
        0.8479983806610107
      ],
      "plane_d": -1135.2578125,
      "bbox_min": [
        1655.0,
        1910.0,
        135.0
      ],
      "bbox_max": [
        1665.0,
        1926.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.818099190131761e-05,
        2.4206688976846635e-05
      ],
      "plane_d": -1665.0382080078125,
      "bbox_min": [
        1665.0,
        1910.0,
        135.0
      ],
      "bbox_max": [
        1665.0,
        1926.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.220703143189894e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1900.0206298828125,
      "bbox_min": [
        1680.0,
        1855.0,
        135.0
      ],
      "bbox_max": [
        1690.0001220703125,
        1910.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.220703143189894e-05,
        0.0
      ],
      "plane_d": -1690.0233154296875,
      "bbox_min": [
        1680.0001220703125,
        1900.0,
        135.0
      ],
      "bbox_max": [
        1690.0001220703125,
        1910.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0001220703125,
      "bbox_min": [
        1680.0001220703125,
        1900.0001220703125,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1910.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1910.0,
      "bbox_min": [
        1680.0001220703125,
        1910.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1910.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        1680.0,
        1855.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1865.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -1.220703143189894e-05,
        0.0
      ],
      "plane_d": 1680.022705078125,
      "bbox_min": [
        1680.0,
        1855.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1865.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1865.0,
      "bbox_min": [
        1680.0,
        1865.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1865.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1805.0,
      "bbox_min": [
        1680.0,
        1764.3232421875,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1815.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1805.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1815.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.220703143189894e-05,
        1.0,
        0.0
      ],
      "plane_d": -1815.0205078125,
      "bbox_min": [
        1680.0,
        1805.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1815.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        1690.0,
        1805.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1814.9998779296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1765.0,
      "bbox_min": [
        1680.0,
        1764.3232421875,
        135.0
      ],
      "bbox_max": [
        1680.6767578125,
        1765.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.202938051392266e-06,
        0.0
      ],
      "plane_d": -1900.0018310546875,
      "bbox_min": [
        1847.4998779296875,
        1555.0,
        119.99995422363281
      ],
      "bbox_max": [
        2025.0001220703125,
        1965.0,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": 170.1741943359375,
      "bbox_min": [
        1847.4998779296875,
        1698.1728515625,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883490443229675,
        0.5883490443229675,
        0.5546989440917969
      ],
      "plane_d": 28.726043701171875,
      "bbox_min": [
        1847.4998779296875,
        1698.1728515625,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": 2241.16259765625,
      "bbox_min": [
        1847.4998779296875,
        1698.1728515625,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": 2099.71435546875,
      "bbox_min": [
        1847.4998779296875,
        1698.1728515625,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2153475135564804,
        0.8036943078041077,
        0.5547080039978027
      ],
      "plane_d": -1036.60595703125,
      "bbox_min": [
        1847.4998779296875,
        1698.1728515625,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2153484970331192,
        -0.8036980032920837,
        0.5547022223472595
      ],
      "plane_d": 1792.4072265625,
      "bbox_min": [
        1847.4998779296875,
        1698.1728515625,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -126.0,
      "bbox_min": [
        1847.4998779296875,
        1698.1728515625,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036985993385315,
        -0.21534866094589233,
        0.5547012686729431
      ],
      "plane_d": 1839.476806640625,
      "bbox_min": [
        1847.4998779296875,
        1727.929443359375,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        1792.070556640625,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320502638816833,
        0.5547001361846924
      ],
      "plane_d": 1404.0848388671875,
      "bbox_min": [
        1897.9903564453125,
        1767.5,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        1770.11865234375,
        123.92801666259766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036952018737793,
        0.21534454822540283,
        0.5547077059745789
      ],
      "plane_d": 1081.449462890625,
      "bbox_min": [
        1847.4998779296875,
        1727.929443359375,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        1781.755859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8320565223693848,
        0.5546907782554626
      ],
      "plane_d": -1524.7418212890625,
      "bbox_min": [
        1897.990234375,
        1749.8812255859375,
        120.0
      ],
      "bbox_max": [
        1899.999755859375,
        1752.4998779296875,
        123.92813110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659233689308167,
        0.2588285207748413,
        -0.0
      ],
      "plane_d": -2255.79296875,
      "bbox_min": [
        1847.4998779296875,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1863.7655029296875,
        1781.755859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659233689308167,
        -0.2588285207748413,
        0.0
      ],
      "plane_d": -1344.7164306640625,
      "bbox_min": [
        1847.4998779296875,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1863.7655029296875,
        1781.755859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2568.5400390625,
      "bbox_min": [
        1847.4998779296875,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1863.7655029296875,
        1781.755859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -79.524169921875,
      "bbox_min": [
        1847.4998779296875,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1863.7655029296875,
        1781.755859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5795432925224304,
        0.1552942395210266,
        0.8000082969665527
      ],
      "plane_d": -1451.8516845703125,
      "bbox_min": [
        1847.4998779296875,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1863.7655029296875,
        1781.755859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5795527100563049,
        -0.15529675781726837,
        0.8000009655952454
      ],
      "plane_d": -905.228271484375,
      "bbox_min": [
        1847.4998779296875,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1863.7655029296875,
        1781.755859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4242638051509857,
        0.4242638051509857,
        0.8000003099441528
      ],
      "plane_d": -1639.5230712890625,
      "bbox_min": [
        1847.4998779296875,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1860.5814208984375,
        1781.755859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4242638051509857,
        -0.4242638051509857,
        0.8000003099441528
      ],
      "plane_d": -146.11451721191406,
      "bbox_min": [
        1847.4998779296875,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1860.5814208984375,
        1781.755859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882601737976074,
        -0.9659239649772644,
        0.0
      ],
      "plane_d": 1200.830810546875,
      "bbox_min": [
        1847.4998779296875,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1851.8828125,
        1781.755859375,
        124.75625610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588217258453369,
        0.9659250974655151,
        -0.0
      ],
      "plane_d": -2199.2158203125,
      "bbox_min": [
        1847.4998779296875,
        1738.7801513671875,
        120.0
      ],
      "bbox_max": [
        1851.8828125,
        1781.755859375,
        124.75625610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15529559552669525,
        -0.5795543193817139,
        0.7999999523162842
      ],
      "plane_d": 622.098388671875,
      "bbox_min": [
        1849.499755859375,
        1738.7801513671875,
        123.0
      ],
      "bbox_max": [
        1851.8828125,
        1781.219970703125,
        124.75625610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15529289841651917,
        0.579554557800293,
        0.8000004291534424
      ],
      "plane_d": -1417.9283447265625,
      "bbox_min": [
        1849.499755859375,
        1778.4820556640625,
        123.0
      ],
      "bbox_max": [
        1851.8826904296875,
        1781.219970703125,
        124.75614166259766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036980032920837,
        -0.2153484970331192,
        -0.5547022223472595
      ],
      "plane_d": 1980.92431640625,
      "bbox_min": [
        1852.4998779296875,
        1698.1728515625,
        126.0
      ],
      "bbox_max": [
        1899.999755859375,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.6051924325875007e-06,
        -0.8320494890213013,
        -0.5547015070915222
      ],
      "plane_d": 1545.5390625,
      "bbox_min": [
        1897.9903564453125,
        1767.5,
        131.07199096679688
      ],
      "bbox_max": [
        1899.999755859375,
        1770.11865234375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036984205245972,
        0.21534909307956696,
        -0.5547013282775879
      ],
      "plane_d": 1222.897216796875,
      "bbox_min": [
        1852.4998779296875,
        1698.1728515625,
        126.0
      ],
      "bbox_max": [
        1899.999755859375,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.173072855133796e-06,
        0.8320558071136475,
        -0.5546919703483582
      ],
      "plane_d": -1383.288330078125,
      "bbox_min": [
        1897.990234375,
        1749.8812255859375,
        131.07186889648438
      ],
      "bbox_max": [
        1899.999755859375,
        1752.4998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036985993385315,
        -0.21534866094589233,
        0.5547012686729431
      ],
      "plane_d": 1839.476806640625,
      "bbox_min": [
        1895.5478515625,
        1775.455810546875,
        126.0
      ],
      "bbox_max": [
        1899.999755859375,
        1792.588134765625,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -172.19677734375,
      "bbox_min": [
        1899.999755859375,
        1570.0,
        119.99995422363281
      ],
      "bbox_max": [
        2025.0001220703125,
        1910.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9663534164428711,
        0.25721797347068787,
        -0.0
      ],
      "plane_d": -2346.75634765625,
      "bbox_min": [
        1899.999755859375,
        1700.4000244140625,
        120.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9654908180236816,
        -0.2604371905326843,
        -1.739408435241785e-05
      ],
      "plane_d": -1433.9903564453125,
      "bbox_min": [
        1899.999755859375,
        1700.4000244140625,
        120.0
      ],
      "bbox_max": [
        1960.0,
        1794.9998779296875,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        1899.999755859375,
        1726.0,
        120.0
      ],
      "bbox_max": [
        1960.0,
        1794.9998779296875,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9663532972335815,
        -0.2572184205055237,
        -0.0
      ],
      "plane_d": 2344.82421875,
      "bbox_min": [
        1899.999755859375,
        1731.0001220703125,
        120.0
      ],
      "bbox_max": [
        1958.0,
        1790.0,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320502638816833,
        0.5547001361846924
      ],
      "plane_d": 1404.0848388671875,
      "bbox_min": [
        1899.999755859375,
        1731.0001220703125,
        120.0
      ],
      "bbox_max": [
        1958.0,
        1790.0,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1790.0,
      "bbox_min": [
        1930.0,
        1790.0,
        120.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1790.0,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9654915928840637,
        0.26043444871902466,
        0.0
      ],
      "plane_d": 1432.06787109375,
      "bbox_min": [
        1899.999755859375,
        1731.0001220703125,
        120.0
      ],
      "bbox_max": [
        1958.0,
        1760.0,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8320565223693848,
        0.5546907782554626
      ],
      "plane_d": -1524.7418212890625,
      "bbox_min": [
        1899.999755859375,
        1731.0001220703125,
        120.0
      ],
      "bbox_max": [
        1950.177490234375,
        1752.5,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1731.0001220703125,
      "bbox_min": [
        1930.0001220703125,
        1731.0001220703125,
        120.0
      ],
      "bbox_max": [
        1950.177490234375,
        1731.0001220703125,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9663532972335815,
        -0.2572184205055237,
        0.0
      ],
      "plane_d": 2344.82421875,
      "bbox_min": [
        1899.999755859375,
        1726.0,
        123.0
      ],
      "bbox_max": [
        1960.0,
        1794.9998779296875,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 131.99998474121094,
      "bbox_min": [
        1948.6839599609375,
        1756.268310546875,
        123.0
      ],
      "bbox_max": [
        1960.0,
        1794.9998779296875,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -2.4414661311311647e-05,
        -0.0
      ],
      "plane_d": 1950.0584716796875,
      "bbox_min": [
        1948.6839599609375,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1794.9998779296875,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486891031265259,
        0.31621038913726807
      ],
      "plane_d": 1661.78955078125,
      "bbox_min": [
        1948.6839599609375,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1794.9998779296875,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1948.6839599609375,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1794.9998779296875,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3162277638912201,
        0.9486833214759827
      ],
      "plane_d": 449.359619140625,
      "bbox_min": [
        1949.2164306640625,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1793.0,
        124.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9654915928840637,
        0.26043444871902466,
        0.0
      ],
      "plane_d": 1432.06787109375,
      "bbox_min": [
        1899.999755859375,
        1726.0,
        123.0
      ],
      "bbox_max": [
        1958.993408203125,
        1794.9998779296875,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 131.99998474121094,
      "bbox_min": [
        1948.8287353515625,
        1726.0,
        123.0
      ],
      "bbox_max": [
        1958.993408203125,
        1760.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        2.4413466235273518e-05,
        -1.2206733117636759e-05
      ],
      "plane_d": 1950.13671875,
      "bbox_min": [
        1948.8287353515625,
        1726.0,
        123.0
      ],
      "bbox_max": [
        1950.177490234375,
        1731.0001220703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486833810806274,
        0.3162277936935425
      ],
      "plane_d": -1678.537109375,
      "bbox_min": [
        1948.8287353515625,
        1726.0,
        123.0
      ],
      "bbox_max": [
        1950.177490234375,
        1731.0001220703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1948.8287353515625,
        1726.0,
        123.0
      ],
      "bbox_max": [
        1950.177490234375,
        1731.0001220703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1930.0,
      "bbox_min": [
        1899.999755859375,
        1767.5,
        123.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1794.9998779296875,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8036980032920837,
        -0.2153484970331192,
        -0.5547022223472595
      ],
      "plane_d": 1980.92431640625,
      "bbox_min": [
        1899.999755859375,
        1770.11865234375,
        125.39684295654297
      ],
      "bbox_max": [
        1901.8270263671875,
        1779.3197021484375,
        131.07199096679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036985993385315,
        -0.21534866094589233,
        0.5547012686729431
      ],
      "plane_d": 1839.476806640625,
      "bbox_min": [
        1899.999755859375,
        1772.5,
        125.39684295654297
      ],
      "bbox_max": [
        1901.8270263671875,
        1779.3197021484375,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1790.0,
      "bbox_min": [
        1929.9998779296875,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1794.9998779296875,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1929.9998779296875,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1794.9998779296875,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3162277936935425,
        0.9486833810806274
      ],
      "plane_d": 449.35968017578125,
      "bbox_min": [
        1930.0,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1950.0147705078125,
        1793.0,
        124.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8036985993385315,
        -0.21534866094589233,
        0.5547012686729431
      ],
      "plane_d": 1839.476806640625,
      "bbox_min": [
        1899.999755859375,
        1770.11865234375,
        123.92801666259766
      ],
      "bbox_max": [
        1901.8270263671875,
        1773.9022216796875,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.173072855133796e-06,
        0.8320558071136475,
        -0.5546919703483582
      ],
      "plane_d": -1383.288330078125,
      "bbox_min": [
        1899.999755859375,
        1726.0,
        123.0
      ],
      "bbox_max": [
        1950.177490234375,
        1752.5,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        7.398255547741428e-06,
        -4.932170668325853e-06
      ],
      "plane_d": -1930.0123291015625,
      "bbox_min": [
        1899.999755859375,
        1726.0,
        123.0
      ],
      "bbox_max": [
        1950.177490234375,
        1752.5,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8036984205245972,
        0.21534909307956696,
        -0.5547013282775879
      ],
      "plane_d": 1222.897216796875,
      "bbox_min": [
        1899.999755859375,
        1740.6805419921875,
        125.3968505859375
      ],
      "bbox_max": [
        1901.8270263671875,
        1749.8812255859375,
        131.07186889648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036952018737793,
        0.21534454822540283,
        0.5547077059745789
      ],
      "plane_d": 1081.449462890625,
      "bbox_min": [
        1899.999755859375,
        1740.6805419921875,
        125.3968505859375
      ],
      "bbox_max": [
        1901.8270263671875,
        1747.5,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1731.0001220703125,
      "bbox_min": [
        1930.0,
        1726.0,
        123.0
      ],
      "bbox_max": [
        1950.177490234375,
        1731.0001220703125,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1930.0,
        1726.0,
        123.0
      ],
      "bbox_max": [
        1950.177490234375,
        1731.0001220703125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.3162161707878113,
        0.9486871361732483
      ],
      "plane_d": -664.0587768554688,
      "bbox_min": [
        1930.0,
        1728.0,
        123.0
      ],
      "bbox_max": [
        1950.177490234375,
        1731.0001220703125,
        124.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        7.398255547741428e-06,
        0.0
      ],
      "plane_d": -1930.012939453125,
      "bbox_min": [
        1899.999755859375,
        1744.5003662109375,
        123.0
      ],
      "bbox_max": [
        1930.0,
        1750.5,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8036952018737793,
        0.21534454822540283,
        0.5547077059745789
      ],
      "plane_d": 1081.449462890625,
      "bbox_min": [
        1899.999755859375,
        1746.0980224609375,
        123.92813110351562
      ],
      "bbox_max": [
        1901.8270263671875,
        1749.8812255859375,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.220703143189894e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 1855.0244140625,
      "bbox_min": [
        1989.9998779296875,
        1755.0,
        120.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.4413466235273518e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1899.9512939453125,
      "bbox_min": [
        1989.9998779296875,
        1855.0,
        120.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        2.4413466235273518e-05,
        0.0
      ],
      "plane_d": 1989.9534912109375,
      "bbox_min": [
        1989.9998779296875,
        1899.9998779296875,
        120.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.2207180589030031e-05,
        0.0
      ],
      "plane_d": -2000.0233154296875,
      "bbox_min": [
        2000.0,
        1900.0001220703125,
        120.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1910.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.220703143189894e-05,
        0.0
      ],
      "plane_d": -2000.022705078125,
      "bbox_min": [
        1990.0001220703125,
        1855.0,
        120.0
      ],
      "bbox_max": [
        2000.0001220703125,
        1865.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0001220703125,
      "bbox_min": [
        1990.0001220703125,
        1855.0001220703125,
        120.0
      ],
      "bbox_max": [
        1990.0001220703125,
        1865.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1765.0,
      "bbox_min": [
        1990.0,
        1755.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1815.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -1.2207180589030031e-05,
        0.0
      ],
      "plane_d": 1990.0216064453125,
      "bbox_min": [
        1990.0,
        1755.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1765.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2207180589030031e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 1755.0244140625,
      "bbox_min": [
        1990.0001220703125,
        1755.0,
        120.0
      ],
      "bbox_max": [
        1998.5230712890625,
        1755.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        2000.0,
        1805.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1815.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2939084626850672e-05,
        -0.5299978256225586,
        0.847999095916748
      ],
      "plane_d": 730.310546875,
      "bbox_min": [
        1990.0,
        1570.0,
        119.99995422363281
      ],
      "bbox_max": [
        2025.0001220703125,
        1756.4769287109375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.856886451103492e-06,
        0.5386186838150024,
        -0.8425496816635132
      ],
      "plane_d": -749.226806640625,
      "bbox_min": [
        1990.0,
        1570.0,
        119.99995422363281
      ],
      "bbox_max": [
        2025.0001220703125,
        1756.4769287109375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -2.5649475599021088e-11,
        -4.882771008851705e-06
      ],
      "plane_d": 2015.0006103515625,
      "bbox_min": [
        2014.9998779296875,
        1570.0,
        119.99995422363281
      ],
      "bbox_max": [
        2015.0,
        1602.178466796875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1665.0,
      "bbox_min": [
        1990.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1756.4769287109375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1990.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1665.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0,
      "bbox_min": [
        1990.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1620.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        1990.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1620.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1990.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1610.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0,
      "bbox_min": [
        1990.0,
        1655.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1665.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        1990.0,
        1655.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1665.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1655.0,
      "bbox_min": [
        1990.0,
        1655.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1655.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1715.0,
      "bbox_min": [
        1990.0,
        1705.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1756.4769287109375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1990.0,
      "bbox_min": [
        1990.0,
        1705.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1715.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        1990.0,
        1705.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1715.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1705.0,
      "bbox_min": [
        1990.0,
        1705.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1705.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2207180589030031e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 1755.0244140625,
      "bbox_min": [
        1998.5230712890625,
        1755.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1756.4769287109375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -2000.0,
      "bbox_min": [
        2000.0,
        1755.0,
        120.0
      ],
      "bbox_max": [
        2000.0,
        1756.4769287109375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320440649986267,
        -6.367512241922668e-07,
        -0.5547096133232117
      ],
      "plane_d": 1612.0882568359375,
      "bbox_min": [
        1655.0,
        1555.0,
        119.99995422363281
      ],
      "bbox_max": [
        1857.5,
        1965.0001220703125,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.21534736454486847,
        0.8036937713623047,
        -0.5547088980674744
      ],
      "plane_d": -895.1546020507812,
      "bbox_min": [
        1847.5,
        1698.1728515625,
        127.5
      ],
      "bbox_max": [
        1857.5,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        -0.0
      ],
      "plane_d": -2243.27490234375,
      "bbox_min": [
        1847.5,
        1751.18701171875,
        131.50558471679688
      ],
      "bbox_max": [
        1849.82958984375,
        1768.81298828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1847.5,
        1751.18701171875,
        131.50558471679688
      ],
      "bbox_max": [
        1849.82958984375,
        1768.81298828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1213.3560791015625,
      "bbox_min": [
        1847.5,
        1751.18701171875,
        133.44677734375
      ],
      "bbox_max": [
        1848.5355224609375,
        1751.4644775390625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.8985595703125,
      "bbox_min": [
        1847.5,
        1761.3763427734375,
        131.50558471679688
      ],
      "bbox_max": [
        1849.82958984375,
        1768.81298828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2186.705810546875,
      "bbox_min": [
        1847.5,
        1768.5355224609375,
        133.44677734375
      ],
      "bbox_max": [
        1848.5355224609375,
        1768.81298828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320565223693848,
        6.524541618091462e-07,
        0.5546908378601074
      ],
      "plane_d": -1591.307373046875,
      "bbox_min": [
        1655.0,
        1555.0,
        119.99995422363281
      ],
      "bbox_max": [
        1851.4998779296875,
        1965.0001220703125,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1780.0,
      "bbox_min": [
        1655.0,
        1555.0,
        119.99995422363281
      ],
      "bbox_max": [
        1832.5,
        1965.0001220703125,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5883489847183228,
        0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": -1994.949951171875,
      "bbox_min": [
        1780.0,
        1698.1729736328125,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1845.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": -2136.398193359375,
      "bbox_min": [
        1780.0,
        1698.1729736328125,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1845.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        -0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": -65.40982055664062,
      "bbox_min": [
        1780.0,
        1698.1729736328125,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1845.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -1.220688227476785e-05,
        0.0
      ],
      "plane_d": -1802.9776611328125,
      "bbox_min": [
        1802.9998779296875,
        1824.9998779296875,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1845.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.138087650877424e-06,
        -1.0,
        0.0
      ],
      "plane_d": 1845.0147705078125,
      "bbox_min": [
        1802.9998779296875,
        1824.9998779296875,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1845.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.137954864650965e-06,
        1.0,
        0.0
      ],
      "plane_d": -1824.9852294921875,
      "bbox_min": [
        1802.9998779296875,
        1824.9998779296875,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1845.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1818.0,
      "bbox_min": [
        1818.0,
        1825.0,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1845.0,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.627577694307547e-05,
        -1.0,
        2.712629793677479e-05
      ],
      "plane_d": 1839.9669189453125,
      "bbox_min": [
        1818.0,
        1830.0,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1840.0001220703125,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -1.627604251552839e-05
      ],
      "plane_d": -1829.998046875,
      "bbox_min": [
        1818.0001220703125,
        1830.0,
        120.0
      ],
      "bbox_max": [
        1828.0384521484375,
        1830.0001220703125,
        130.6474151611328
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5883490443229675,
        -0.5883490443229675,
        -0.5546990036964417
      ],
      "plane_d": 76.0384521484375,
      "bbox_min": [
        1780.0,
        1698.1729736328125,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1830.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -8.137954864650965e-06,
        1.0,
        0.0
      ],
      "plane_d": -1824.9852294921875,
      "bbox_min": [
        1808.8963623046875,
        1824.9998779296875,
        127.5
      ],
      "bbox_max": [
        1824.7940673828125,
        1830.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.627577694307547e-05,
        1.0,
        2.712629793677479e-05
      ],
      "plane_d": -1829.9737548828125,
      "bbox_min": [
        1818.0,
        1825.0,
        127.5
      ],
      "bbox_max": [
        1824.7940673828125,
        1830.0001220703125,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        2.4413466235273518e-05,
        0.0
      ],
      "plane_d": 1817.9554443359375,
      "bbox_min": [
        1818.0,
        1825.0,
        127.5000228881836
      ],
      "bbox_max": [
        1818.0001220703125,
        1830.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21534575521945953,
        -0.8036996722221375,
        0.5547009110450745
      ],
      "plane_d": 999.9329833984375,
      "bbox_min": [
        1780.0,
        1698.1729736328125,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1830.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -1.627604251552839e-05
      ],
      "plane_d": -1829.998046875,
      "bbox_min": [
        1815.967529296875,
        1825.0,
        120.0
      ],
      "bbox_max": [
        1832.5,
        1830.0001220703125,
        131.5587921142578
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -8.137954864650965e-06,
        1.0,
        0.0
      ],
      "plane_d": -1824.9852294921875,
      "bbox_min": [
        1815.967529296875,
        1825.0,
        125.34430694580078
      ],
      "bbox_max": [
        1818.0,
        1825.0,
        129.6557159423828
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036968111991882,
        0.21535371243953705,
        0.5547019839286804
      ],
      "plane_d": -1876.1668701171875,
      "bbox_min": [
        1780.0,
        1727.929443359375,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1792.0704345703125,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.346212103380822e-06,
        0.8320550322532654,
        0.5546930432319641
      ],
      "plane_d": -1524.750732421875,
      "bbox_min": [
        1780.0,
        1749.8809814453125,
        120.0
      ],
      "bbox_max": [
        1782.009521484375,
        1752.4998779296875,
        123.92837524414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036937713623047,
        -0.21534736454486847,
        0.5547088980674744
      ],
      "plane_d": -1118.128662109375,
      "bbox_min": [
        1780.0,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1792.0704345703125,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.6052263112651417e-06,
        -0.8320573568344116,
        0.5546895265579224
      ],
      "plane_d": 1404.1051025390625,
      "bbox_min": [
        1780.0,
        1767.5,
        120.0
      ],
      "bbox_max": [
        1782.0096435546875,
        1770.118896484375,
        123.9283676147461
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2522.62890625,
      "bbox_min": [
        1816.234619140625,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1781.755615234375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659239649772644,
        0.25882601737976074,
        0.0
      ],
      "plane_d": 1298.810791015625,
      "bbox_min": [
        1816.234619140625,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1781.755615234375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659250974655151,
        -0.2588217258453369,
        0.0
      ],
      "plane_d": 2209.872802734375,
      "bbox_min": [
        1816.234619140625,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1781.755615234375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 33.613037109375,
      "bbox_min": [
        1816.234619140625,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1781.755615234375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5795534253120422,
        0.15529534220695496,
        0.800000786781311
      ],
      "plane_d": 680.8850708007812,
      "bbox_min": [
        1816.234619140625,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1781.755615234375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5795546174049377,
        -0.15529291331768036,
        0.8000003695487976
      ],
      "plane_d": 1227.5225830078125,
      "bbox_min": [
        1816.234619140625,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1781.755615234375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4242696166038513,
        -0.4242696166038513,
        0.7999941110610962
      ],
      "plane_d": 1415.1978759765625,
      "bbox_min": [
        1819.4185791015625,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1781.755615234375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4242638051509857,
        0.4242638051509857,
        0.8000003099441528
      ],
      "plane_d": -78.23225402832031,
      "bbox_min": [
        1819.418701171875,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1781.755615234375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588217258453369,
        -0.9659250974655151,
        0.0
      ],
      "plane_d": 2153.3046875,
      "bbox_min": [
        1828.1173095703125,
        1738.2442626953125,
        120.0
      ],
      "bbox_max": [
        1832.499755859375,
        1781.755615234375,
        124.75595092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881677865982056,
        0.965926468372345,
        0.0
      ],
      "plane_d": -1246.7633056640625,
      "bbox_min": [
        1828.1173095703125,
        1738.7801513671875,
        120.0
      ],
      "bbox_max": [
        1832.4996337890625,
        1781.755615234375,
        124.75595092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15529368817806244,
        -0.5795575380325317,
        0.7999982237815857
      ],
      "plane_d": 1193.5885009765625,
      "bbox_min": [
        1828.1173095703125,
        1738.7801513671875,
        123.0
      ],
      "bbox_max": [
        1830.4998779296875,
        1781.2197265625,
        124.75595092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15529058873653412,
        0.5795578956604004,
        0.7999984622001648
      ],
      "plane_d": -846.46044921875,
      "bbox_min": [
        1828.1173095703125,
        1778.4822998046875,
        123.0
      ],
      "bbox_max": [
        1830.499755859375,
        1781.2197265625,
        124.75595092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036941885948181,
        -0.21534796059131622,
        -0.5547080636024475
      ],
      "plane_d": -976.6776123046875,
      "bbox_min": [
        1780.0,
        1698.1729736328125,
        126.0
      ],
      "bbox_max": [
        1827.5,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320565223693848,
        -0.5546908378601074
      ],
      "plane_d": 1545.543212890625,
      "bbox_min": [
        1780.0,
        1767.5,
        131.07164001464844
      ],
      "bbox_max": [
        1782.0096435546875,
        1770.118896484375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8037027716636658,
        0.2153553068637848,
        -0.5546925663948059
      ],
      "plane_d": -1734.732666015625,
      "bbox_min": [
        1780.0,
        1698.1729736328125,
        126.0
      ],
      "bbox_max": [
        1827.5,
        1821.8270263671875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320565223693848,
        -0.5546907782554626
      ],
      "plane_d": -1383.2957763671875,
      "bbox_min": [
        1780.0,
        1749.8809814453125,
        131.07162475585938
      ],
      "bbox_max": [
        1782.009521484375,
        1752.4998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036937713623047,
        -0.21534736454486847,
        0.5547088980674744
      ],
      "plane_d": -1118.128662109375,
      "bbox_min": [
        1780.0,
        1775.4552001953125,
        126.0
      ],
      "bbox_max": [
        1784.4520263671875,
        1792.5880126953125,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707105815410614,
        0.7071077823638916,
        0.0
      ],
      "plane_d": -59.6290283203125,
      "bbox_min": [
        1655.0,
        1610.0,
        119.99995422363281
      ],
      "bbox_max": [
        1780.0,
        1950.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9663533568382263,
        0.2572184205055237,
        6.749428575858474e-05
      ],
      "plane_d": 1209.4151611328125,
      "bbox_min": [
        1680.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1820.39990234375,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9654912948608398,
        -0.26043570041656494,
        0.0
      ],
      "plane_d": 2119.011962890625,
      "bbox_min": [
        1682.7354736328125,
        1610.0,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1795.0,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9663532972335815,
        -0.2572184205055237,
        0.0
      ],
      "plane_d": -1211.35595703125,
      "bbox_min": [
        1720.0001220703125,
        1725.9998779296875,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1795.0,
        135.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 132.0,
      "bbox_min": [
        1720.0001220703125,
        1756.268310546875,
        123.0
      ],
      "bbox_max": [
        1731.3160400390625,
        1795.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -6.103888154029846e-05,
        -1.0,
        -0.0
      ],
      "plane_d": 1790.1055908203125,
      "bbox_min": [
        1727.9853515625,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1731.3160400390625,
        1795.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -1729.985107421875,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1731.3160400390625,
        1795.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833810806274,
        0.3162277936935425
      ],
      "plane_d": 1661.777099609375,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1731.3160400390625,
        1795.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3162277638912201,
        0.9486833214759827
      ],
      "plane_d": 449.35968017578125,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1730.78369140625,
        1793.0,
        124.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320565223693848,
        -0.5546908378601074
      ],
      "plane_d": 1545.543212890625,
      "bbox_min": [
        1721.0067138671875,
        1725.9998779296875,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1795.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        1729.9852294921875,
        1767.5,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1795.0,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8036937713623047,
        -0.21534736454486847,
        0.5547088980674744
      ],
      "plane_d": -1118.128662109375,
      "bbox_min": [
        1778.1728515625,
        1772.4998779296875,
        125.39698791503906
      ],
      "bbox_max": [
        1780.0,
        1779.3189697265625,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1790.0,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        120.0
      ],
      "bbox_max": [
        1750.0,
        1795.0,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1729.9852294921875,
        1790.0,
        123.0
      ],
      "bbox_max": [
        1750.0,
        1795.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.6052263112651417e-06,
        -0.8320573568344116,
        0.5546895265579224
      ],
      "plane_d": 1404.1051025390625,
      "bbox_min": [
        1721.0067138671875,
        1725.9998779296875,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1777.4998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        1750.0,
        1767.5,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1777.4998779296875,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8036937713623047,
        -0.21534736454486847,
        0.5547088980674744
      ],
      "plane_d": -1118.128662109375,
      "bbox_min": [
        1778.1728515625,
        1770.118896484375,
        123.9283676147461
      ],
      "bbox_max": [
        1780.0,
        1773.90185546875,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9654908776283264,
        0.2604372203350067,
        0.0
      ],
      "plane_d": -2120.94482421875,
      "bbox_min": [
        1721.0067138671875,
        1725.9998779296875,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1760.0,
        135.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 132.0,
      "bbox_min": [
        1721.0067138671875,
        1725.9998779296875,
        123.0
      ],
      "bbox_max": [
        1731.1715087890625,
        1760.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1729.8226318359375,
      "bbox_min": [
        1729.822509765625,
        1725.9998779296875,
        123.0
      ],
      "bbox_max": [
        1731.1715087890625,
        1731.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486775994300842,
        0.3162451684474945
      ],
      "plane_d": -1678.529296875,
      "bbox_min": [
        1729.822509765625,
        1725.9998779296875,
        123.0
      ],
      "bbox_max": [
        1731.1715087890625,
        1731.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.346212103380822e-06,
        0.8320550322532654,
        0.5546930432319641
      ],
      "plane_d": -1524.750732421875,
      "bbox_min": [
        1729.8226318359375,
        1725.9998779296875,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1752.5001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        5.6776571000227705e-06,
        -1.2490845620050095e-05
      ],
      "plane_d": 1749.9915771484375,
      "bbox_min": [
        1729.8226318359375,
        1725.9998779296875,
        120.0
      ],
      "bbox_max": [
        1780.0,
        1752.5001220703125,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8037027716636658,
        0.2153553068637848,
        -0.5546925663948059
      ],
      "plane_d": -1734.732666015625,
      "bbox_min": [
        1778.1729736328125,
        1740.681396484375,
        127.5
      ],
      "bbox_max": [
        1780.0,
        1747.5,
        129.6029052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1731.0,
      "bbox_min": [
        1729.8226318359375,
        1725.9998779296875,
        120.0
      ],
      "bbox_max": [
        1750.0,
        1731.0,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1729.8226318359375,
        1725.9998779296875,
        123.0
      ],
      "bbox_max": [
        1750.0,
        1731.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320565223693848,
        -0.5546907782554626
      ],
      "plane_d": -1383.2957763671875,
      "bbox_min": [
        1750.0,
        1742.500244140625,
        127.5
      ],
      "bbox_max": [
        1780.0,
        1752.5001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        5.67765664527542e-06,
        0.0
      ],
      "plane_d": 1749.9901123046875,
      "bbox_min": [
        1750.0,
        1742.500244140625,
        127.5
      ],
      "bbox_max": [
        1780.0,
        1752.5001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8037027716636658,
        0.2153553068637848,
        -0.5546925663948059
      ],
      "plane_d": -1734.732666015625,
      "bbox_min": [
        1778.1729736328125,
        1746.097900390625,
        127.5
      ],
      "bbox_max": [
        1780.0,
        1749.8809814453125,
        131.07162475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        1682.7354736328125,
        1610.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1620.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1682.7354736328125,
        1620.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1620.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1665.0,
      "bbox_min": [
        1680.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1765.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1665.0,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        1680.0,
        1620.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1665.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1620.0,
      "bbox_min": [
        1680.0,
        1620.0,
        120.0
      ],
      "bbox_max": [
        1682.736572265625,
        1620.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1755.0,
        120.0
      ],
      "bbox_max": [
        1680.0,
        1764.3232421875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.2207180589030031e-05,
        0.0
      ],
      "plane_d": -1690.0208740234375,
      "bbox_min": [
        1689.9998779296875,
        1705.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1714.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.9238043427758384e-06,
        -0.515036940574646,
        -0.8571680784225464
      ],
      "plane_d": 1103.7305908203125,
      "bbox_min": [
        1655.0,
        1764.3232421875,
        119.99995422363281
      ],
      "bbox_max": [
        1690.0001220703125,
        1950.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5299989581108093,
        0.8479983806610107
      ],
      "plane_d": -1135.2578125,
      "bbox_min": [
        1655.0,
        1918.3214111328125,
        119.99995422363281
      ],
      "bbox_max": [
        1665.0,
        1950.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.818099190131761e-05,
        2.4206688976846635e-05
      ],
      "plane_d": -1665.0382080078125,
      "bbox_min": [
        1664.9998779296875,
        1918.3214111328125,
        119.99995422363281
      ],
      "bbox_max": [
        1665.0,
        1949.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1855.0,
      "bbox_min": [
        1680.0,
        1764.3232421875,
        120.0
      ],
      "bbox_max": [
        1690.0001220703125,
        1910.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.220703143189894e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1900.0206298828125,
      "bbox_min": [
        1680.0,
        1855.0,
        120.0
      ],
      "bbox_max": [
        1690.0001220703125,
        1910.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.220703143189894e-05,
        0.0
      ],
      "plane_d": -1690.0233154296875,
      "bbox_min": [
        1680.0001220703125,
        1900.0,
        120.0
      ],
      "bbox_max": [
        1690.0001220703125,
        1910.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0001220703125,
      "bbox_min": [
        1680.0001220703125,
        1900.0001220703125,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1910.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1910.0,
      "bbox_min": [
        1680.0001220703125,
        1910.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1910.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        1680.0,
        1855.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1865.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -1.220703143189894e-05,
        0.0
      ],
      "plane_d": 1680.022705078125,
      "bbox_min": [
        1680.0,
        1855.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1865.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1865.0,
      "bbox_min": [
        1680.0,
        1865.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1865.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1805.0,
      "bbox_min": [
        1680.0,
        1764.3232421875,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1815.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1805.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1815.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.220703143189894e-05,
        1.0,
        0.0
      ],
      "plane_d": -1815.0205078125,
      "bbox_min": [
        1680.0,
        1805.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1815.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        1690.0,
        1805.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1814.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1765.0,
      "bbox_min": [
        1680.0,
        1764.3232421875,
        120.0
      ],
      "bbox_max": [
        1680.6767578125,
        1765.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1764.3232421875,
        120.0
      ],
      "bbox_max": [
        1680.0,
        1765.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320565223693848,
        6.367607738866354e-07,
        -0.5546908378601074
      ],
      "plane_d": -1449.861328125,
      "bbox_min": [
        1822.499755859375,
        1555.0001220703125,
        120.0
      ],
      "bbox_max": [
        1851.4998779296875,
        1964.9998779296875,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -1.627604251552839e-05
      ],
      "plane_d": 1840.002197265625,
      "bbox_min": [
        1822.499755859375,
        1840.0,
        127.5
      ],
      "bbox_max": [
        1832.5,
        1840.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1311.33544921875,
      "bbox_min": [
        1830.17041015625,
        1751.18701171875,
        131.50558471679688
      ],
      "bbox_max": [
        1832.5,
        1768.81298828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1830.17041015625,
        1751.18701171875,
        131.50558471679688
      ],
      "bbox_max": [
        1832.5,
        1768.81298828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2165.79833984375,
      "bbox_min": [
        1831.4644775390625,
        1751.18701171875,
        133.44677734375
      ],
      "bbox_max": [
        1832.4998779296875,
        1751.4644775390625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2541.25439453125,
      "bbox_min": [
        1830.17041015625,
        1761.3763427734375,
        131.50558471679688
      ],
      "bbox_max": [
        1832.5,
        1768.81298828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1234.263671875,
      "bbox_min": [
        1831.4644775390625,
        1768.5355224609375,
        133.44677734375
      ],
      "bbox_max": [
        1832.4998779296875,
        1768.81298828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        1828.5,
        1555.0001220703125,
        120.0
      ],
      "bbox_max": [
        1851.4998779296875,
        1964.9998779296875,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1839.0,
      "bbox_min": [
        1830.499755859375,
        1555.0001220703125,
        120.0
      ],
      "bbox_max": [
        1849.499755859375,
        1964.9998779296875,
        123.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1841.0,
      "bbox_min": [
        1839.0,
        1555.0001220703125,
        120.0
      ],
      "bbox_max": [
        1849.499755859375,
        1964.9998779296875,
        123.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1840.0,
      "bbox_min": [
        1839.0,
        1680.0,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1840.0,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1680.0,
      "bbox_min": [
        1839.0,
        1680.0,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1783.765380859375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881677865982056,
        0.965926468372345,
        0.0
      ],
      "plane_d": -1246.7633056640625,
      "bbox_min": [
        1839.0,
        1736.234619140625,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1783.765380859375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882601737976074,
        -0.9659239649772644,
        0.0
      ],
      "plane_d": 1200.830810546875,
      "bbox_min": [
        1839.0,
        1736.234619140625,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1783.765380859375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588217258453369,
        -0.9659250974655151,
        0.0
      ],
      "plane_d": 2153.3046875,
      "bbox_min": [
        1839.0,
        1736.234619140625,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1783.765380859375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588217258453369,
        0.9659250974655151,
        -0.0
      ],
      "plane_d": -2199.2158203125,
      "bbox_min": [
        1840.0001220703125,
        1783.4974365234375,
        120.0
      ],
      "bbox_max": [
        1841.0,
        1783.765380859375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882601737976074,
        -0.9659239649772644,
        0.0
      ],
      "plane_d": 1200.830810546875,
      "bbox_min": [
        1841.0,
        1736.5025634765625,
        120.0
      ],
      "bbox_max": [
        1849.499755859375,
        1783.4974365234375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588217258453369,
        0.9659250974655151,
        -0.0
      ],
      "plane_d": -2199.2158203125,
      "bbox_min": [
        1841.0,
        1781.219970703125,
        120.0
      ],
      "bbox_max": [
        1849.499755859375,
        1783.4974365234375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881677865982056,
        0.965926468372345,
        0.0
      ],
      "plane_d": -1246.7633056640625,
      "bbox_min": [
        1830.499755859375,
        1736.5025634765625,
        120.0
      ],
      "bbox_max": [
        1839.0,
        1783.4974365234375,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588217258453369,
        -0.9659250974655151,
        0.0
      ],
      "plane_d": 2153.3046875,
      "bbox_min": [
        1830.4998779296875,
        1736.5025634765625,
        120.0
      ],
      "bbox_max": [
        1839.0,
        1738.7801513671875,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -126.0,
      "bbox_min": [
        1828.5,
        1736.234619140625,
        123.0
      ],
      "bbox_max": [
        1851.4998779296875,
        1783.765380859375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15529058873653412,
        0.5795578956604004,
        0.7999984622001648
      ],
      "plane_d": -846.46044921875,
      "bbox_min": [
        1828.5,
        1736.234619140625,
        123.0
      ],
      "bbox_max": [
        1851.4998779296875,
        1783.765380859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15529368817806244,
        -0.5795575380325317,
        0.7999982237815857
      ],
      "plane_d": 1193.5885009765625,
      "bbox_min": [
        1828.5,
        1736.234619140625,
        123.0
      ],
      "bbox_max": [
        1851.4998779296875,
        1783.765380859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15529559552669525,
        -0.5795543193817139,
        0.7999999523162842
      ],
      "plane_d": 622.098388671875,
      "bbox_min": [
        1828.5,
        1736.234619140625,
        123.0
      ],
      "bbox_max": [
        1851.4998779296875,
        1783.765380859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15529289841651917,
        0.579554557800293,
        0.8000004291534424
      ],
      "plane_d": -1417.9283447265625,
      "bbox_min": [
        1828.5,
        1741.5177001953125,
        123.0
      ],
      "bbox_max": [
        1851.4998779296875,
        1783.765380859375,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4242638051509857,
        0.4242638051509857,
        0.8000003099441528
      ],
      "plane_d": -78.23225402832031,
      "bbox_min": [
        1828.5,
        1741.5177001953125,
        124.75595092773438
      ],
      "bbox_max": [
        1851.4998779296875,
        1778.4822998046875,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4242696166038513,
        -0.4242696166038513,
        0.7999941110610962
      ],
      "plane_d": 1415.1978759765625,
      "bbox_min": [
        1828.5,
        1741.5177001953125,
        124.75595092773438
      ],
      "bbox_max": [
        1851.4998779296875,
        1778.4820556640625,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4242638051509857,
        0.4242638051509857,
        0.8000003099441528
      ],
      "plane_d": -1639.5230712890625,
      "bbox_min": [
        1849.8121337890625,
        1741.5181884765625,
        124.75614166259766
      ],
      "bbox_max": [
        1851.4998779296875,
        1778.4820556640625,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4242638051509857,
        -0.4242638051509857,
        0.8000003099441528
      ],
      "plane_d": -146.11451721191406,
      "bbox_min": [
        1849.812255859375,
        1741.5181884765625,
        124.75625610351562
      ],
      "bbox_max": [
        1851.4998779296875,
        1744.692626953125,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2165.79833984375,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1234.263671875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1213.3560791015625,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2186.705810546875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": 2222.3671875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1332.2430419921875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1311.33544921875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        -0.0
      ],
      "plane_d": -2243.27490234375,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        0.25881582498550415,
        0.0
      ],
      "plane_d": 1323.5828857421875,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        0.9659267067909241,
        0.0
      ],
      "plane_d": -1222.016357421875,
      "bbox_min": [
        1840.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1763.7059326171875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2541.25439453125,
      "bbox_min": [
        1840.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1759.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1846.2940673828125,
        1756.2940673828125,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1759.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2178.045654296875,
      "bbox_min": [
        1842.1966552734375,
        1760.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1763.7059326171875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.8985595703125,
      "bbox_min": [
        1846.2940673828125,
        1760.17041015625,
        126.0
      ],
      "bbox_max": [
        1849.82958984375,
        1763.7059326171875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        0.9659267067909241,
        -0.0
      ],
      "plane_d": -2174.458740234375,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1843.7059326171875,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -60.898681640625,
      "bbox_min": [
        1830.17041015625,
        1750.17041015625,
        126.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1759.8297119140625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        0.25881582498550415,
        -0.0
      ],
      "plane_d": -2231.02734375,
      "bbox_min": [
        1830.17041015625,
        1753.7060546875,
        126.0
      ],
      "bbox_max": [
        1839.8297119140625,
        1759.8297119140625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1830.17041015625,
        1756.2940673828125,
        126.0
      ],
      "bbox_max": [
        1833.7060546875,
        1759.8297119140625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": -1319.99560546875,
      "bbox_min": [
        1830.17041015625,
        1760.17041015625,
        126.0
      ],
      "bbox_max": [
        1843.7059326171875,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2549.91455078125,
      "bbox_min": [
        1830.17041015625,
        1760.17041015625,
        126.0
      ],
      "bbox_max": [
        1839.82958984375,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 1225.603515625,
      "bbox_min": [
        1830.17041015625,
        1760.17041015625,
        126.0
      ],
      "bbox_max": [
        1838.5355224609375,
        1763.7059326171875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2541.25439453125,
      "bbox_min": [
        1830.17041015625,
        1760.17041015625,
        126.0
      ],
      "bbox_max": [
        1833.7059326171875,
        1763.7059326171875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 52.2384033203125,
      "bbox_min": [
        1840.17041015625,
        1761.268310546875,
        126.0
      ],
      "bbox_max": [
        1843.7059326171875,
        1769.82958984375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659267067909241,
        -0.25881582498550415,
        0.0
      ],
      "plane_d": 2234.614501953125,
      "bbox_min": [
        1840.17041015625,
        1761.268310546875,
        126.0
      ],
      "bbox_max": [
        1842.1966552734375,
        1766.2940673828125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881582498550415,
        -0.9659267067909241,
        0.0
      ],
      "plane_d": 2178.045654296875,
      "bbox_min": [
        1841.4644775390625,
        1761.268310546875,
        126.0
      ],
      "bbox_max": [
        1842.1966552734375,
        1761.4644775390625,
        135.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: elvdr1",
      "entity_class": "CSlidingDoor",
      "piece_name": "elvdr1",
      "offset": 4249,
      "centroid": [
        1768.9999389648438,
        1542.5,
        176.0
      ],
      "bbox_min": [
        1768.0,
        1537.5,
        170.0
      ],
      "bbox_max": [
        1769.9998779296875,
        1547.5,
        182.0
      ],
      "dimensions_source": {
        "span_x": 1.9998779296875,
        "span_y": 10.0,
        "height_z": 12.0,
        "door_width": 10.0,
        "door_depth": 1.9998779296875,
        "leaf_depth": 1.9598779296875,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          1769.9998779296875,
          1547.5,
          182.0
        ],
        [
          1769.9998779296875,
          1547.5,
          170.0
        ],
        [
          1768.0,
          1547.5,
          182.0
        ],
        [
          1768.0,
          1547.5,
          170.0
        ],
        [
          1769.9998779296875,
          1537.5,
          182.0
        ],
        [
          1769.9998779296875,
          1537.5,
          170.0
        ],
        [
          1768.0,
          1537.5,
          170.0
        ],
        [
          1768.0,
          1537.5,
          182.0
        ]
      ],
      "plane_distance": -1769.9999,
      "authentic_texture": "spkelevdoor1"
    },
    {
      "tag": "CSlidingDoor piece: elev2dr3",
      "entity_class": "CSlidingDoor",
      "piece_name": "elev2dr3",
      "offset": 5352,
      "centroid": [
        1819.0003662109375,
        1835.0000610351562,
        177.5
      ],
      "bbox_min": [
        1818.0001220703125,
        1830.0,
        170.0
      ],
      "bbox_max": [
        1820.0006103515625,
        1840.0001220703125,
        185.0
      ],
      "dimensions_source": {
        "span_x": 2.00048828125,
        "span_y": 10.0001220703125,
        "height_z": 15.0,
        "door_width": 10.0001220703125,
        "door_depth": 2.00048828125,
        "leaf_depth": 1.96048828125,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          1.0,
          -0.0001,
          0.0
        ]
      },
      "vertices": [
        [
          1820.0,
          1830.0,
          170.0
        ],
        [
          1820.0,
          1830.0,
          185.0
        ],
        [
          1818.0001220703125,
          1830.0001220703125,
          185.0
        ],
        [
          1818.0001220703125,
          1830.0001220703125,
          170.0
        ],
        [
          1820.0006103515625,
          1840.0,
          170.0
        ],
        [
          1820.0006103515625,
          1840.0,
          185.0
        ],
        [
          1818.000732421875,
          1840.0001220703125,
          185.0
        ],
        [
          1818.000732421875,
          1840.0001220703125,
          170.0
        ]
      ],
      "plane_distance": -1819.8883,
      "authentic_texture": "spkelevdoor1"
    },
    {
      "tag": "CSlidingDoor piece: elev2dr1",
      "entity_class": "CSlidingDoor",
      "piece_name": "elev2dr1",
      "offset": 6487,
      "centroid": [
        1819.0003662109375,
        1835.0000610351562,
        127.5
      ],
      "bbox_min": [
        1818.0001220703125,
        1830.0,
        120.0
      ],
      "bbox_max": [
        1820.0006103515625,
        1840.0001220703125,
        135.0
      ],
      "dimensions_source": {
        "span_x": 2.00048828125,
        "span_y": 10.0001220703125,
        "height_z": 15.0,
        "door_width": 10.0001220703125,
        "door_depth": 2.00048828125,
        "leaf_depth": 1.96048828125,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          1.0,
          -0.0001,
          0.0
        ]
      },
      "vertices": [
        [
          1820.0,
          1830.0,
          120.0
        ],
        [
          1820.0,
          1830.0,
          135.0
        ],
        [
          1818.0001220703125,
          1830.0001220703125,
          135.0
        ],
        [
          1818.0001220703125,
          1830.0001220703125,
          120.0
        ],
        [
          1820.0006103515625,
          1840.0,
          120.0
        ],
        [
          1820.0006103515625,
          1840.0,
          135.0
        ],
        [
          1818.000732421875,
          1840.0001220703125,
          135.0
        ],
        [
          1818.000732421875,
          1840.0001220703125,
          120.0
        ]
      ],
      "plane_distance": -1819.8883,
      "authentic_texture": "spkelevdoor1"
    },
    {
      "tag": "CSlidingDoor piece: elev2dr2",
      "entity_class": "CSlidingDoor",
      "piece_name": "elev2dr2",
      "offset": 9408,
      "centroid": [
        1819.0003662109375,
        1835.0000610351562,
        152.5
      ],
      "bbox_min": [
        1818.0001220703125,
        1830.0,
        145.0
      ],
      "bbox_max": [
        1820.0006103515625,
        1840.0001220703125,
        160.0
      ],
      "dimensions_source": {
        "span_x": 2.00048828125,
        "span_y": 10.0001220703125,
        "height_z": 15.0,
        "door_width": 10.0001220703125,
        "door_depth": 2.00048828125,
        "leaf_depth": 1.96048828125,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          1.0,
          -0.0001,
          0.0
        ]
      },
      "vertices": [
        [
          1820.0,
          1830.0,
          145.0
        ],
        [
          1820.0,
          1830.0,
          160.0
        ],
        [
          1818.0001220703125,
          1830.0001220703125,
          160.0
        ],
        [
          1818.0001220703125,
          1830.0001220703125,
          145.0
        ],
        [
          1820.0006103515625,
          1840.0,
          145.0
        ],
        [
          1820.0006103515625,
          1840.0,
          160.0
        ],
        [
          1818.000732421875,
          1840.0001220703125,
          160.0
        ],
        [
          1818.000732421875,
          1840.0001220703125,
          145.0
        ]
      ],
      "plane_distance": -1819.8883,
      "authentic_texture": "spkelevdoor1"
    }
  ],
  "tutorial_messages": []
}